var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _g3, _g4, _g5, _path10, _polygon, _path11, _rect2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g6, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _polygon2, _path58, _path59, _path60, _path61, _path62, _polygon3, _path63, _path64, _polygon4, _path65, _path66, _polygon5, _path67, _path68, _path69, _path70, _path71, _path72, _g7, _circle, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _polygon6, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _g8, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _g9, _path102, _path103, _path104, _path105, _path106, _path107, _polygon7, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _g10, _rect3, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _rect4, _rect5, _path134, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path135, _path136, _path137, _rect12, _rect13, _rect14, _rect15, _path138, _path139, _path140, _path141, _path142, _circle2, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _g11, _g12, _rect16, _text, _g13, _g14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 720",
    enableBackground: "new 0 0 2048 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "story-header-bg"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "white-bg",
    fill: "#FFFFFF",
    width: 2048,
    height: 720
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M430.99,348.55c0.16-5.48-2.31-14.32-16.5-20.94c-0.38-0.18-0.79,0.16-0.7,0.56l5.43,22.94 c0.03,0.13,0.01,0.26-0.06,0.37l-6.72,11.12c-0.12,0.2-0.09,0.45,0.08,0.61c10.07,9.79,17.52,23.42,17.41,42.3 C430.09,396.72,430.75,356.73,430.99,348.55z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M390.21,320.92c-5.94-0.89-12.72-1.54-20.47-1.87c-0.6-0.03-1.05,0.55-0.87,1.13l3.1,10.2 c0.07,0.22,0.04,0.46-0.06,0.66l-4.43,8.39c-0.27,0.51,0.02,1.13,0.57,1.26c5.51,1.28,13.42,3.55,21.75,7.38 c0.41,0.19,0.91,0.03,1.13-0.37l4.92-8.86c0.11-0.21,0.14-0.45,0.07-0.67l-5-16.62C390.81,321.21,390.54,320.97,390.21,320.92z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M368.08,319.95c-0.18-0.58-0.7-0.98-1.31-1c-0.26-0.01-0.51-0.02-0.77-0.02l-10.79-0.12 c-0.97-0.01-1.67,0.94-1.36,1.86l5.96,17.72c0.17,0.5,0.6,0.87,1.12,0.95c0.85,0.13,2.32,0.38,4.25,0.78 c0.62,0.13,1.25-0.17,1.54-0.72l4.34-8.21c0.17-0.33,0.21-0.71,0.1-1.07L368.08,319.95z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M385.23,331.16c0.03-3.8-0.63-7.51-1.87-10.98l4.09-4.32l-5.64-9.4l-6.03,1.81 c-2.66-2.64-5.8-4.83-9.34-6.42l-0.15-5.66l-10.63-2.65l-2.96,5.51c-3.28,0.07-6.49,0.64-9.52,1.66l-5.06-4.54l-9.4,5.64 l2.01,6.64c-2.2,2.21-4.09,4.75-5.59,7.58l-6.98,0.04l-2.65,10.63l5.83,3.14l0.14-0.38c-0.16,3.42,0.23,6.78,1.12,9.98 l-4.46,4.81l5.64,9.4l5.58-1.67c2.52,2.88,5.57,5.32,9.05,7.17l0.16,5.94l10.63,2.65l2.65-4.91c4.08,0.2,8.07-0.4,11.8-1.68 l4.15,3.93l9.4-5.64l-1.67-5.56c2.76-2.67,5.06-5.85,6.74-9.46l-0.46,0.56l6.47-0.12l2.65-10.63L385.23,331.16z M347.93,352.59 c-11.95-2.98-19.22-15.09-16.24-27.04c2.98-11.95,15.09-19.22,27.04-16.24c11.95,2.98,19.22,15.09,16.24,27.04 C371.99,348.3,359.88,355.57,347.93,352.59z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 610.81,
    y1: -2501.1062,
    x2: 686.4664,
    y2: -2501.1062,
    gradientTransform: "matrix(0.1834 0.983 -0.983 0.1834 -2319.3381 129.5704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1677,
    style: {
      stopColor: "#FCFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3055,
    style: {
      stopColor: "#F2FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4327,
    style: {
      stopColor: "#E0F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5534,
    style: {
      stopColor: "#C8EEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6698,
    style: {
      stopColor: "#A9E4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#83D8EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8914,
    style: {
      stopColor: "#56CAE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#23B9E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M231.89,274.99c0,0,15.16-2.67,28.72,4.59c17.43,9.33,33.04,30.4,21.49,63.01l-47.14-18.22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -1271.6256,
    y1: 813.5903,
    x2: -1194.4326,
    y2: 813.5903,
    gradientTransform: "matrix(0.752 -0.6591 0.6591 0.752 602.4982 -1110.7278)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1677,
    style: {
      stopColor: "#FCFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3055,
    style: {
      stopColor: "#F2FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4327,
    style: {
      stopColor: "#E0F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5534,
    style: {
      stopColor: "#C8EEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6698,
    style: {
      stopColor: "#A9E4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#83D8EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8914,
    style: {
      stopColor: "#56CAE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#23B9E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M196.18,354.95c0,0-8.69-11.18-9.36-26.54c-0.86-19.76,9.39-45.12,43.33-51.82l6.14,47.59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -3203.4695,
    y1: -2301.3669,
    x2: -3126.2571,
    y2: -2301.3669,
    gradientTransform: "matrix(-0.9529 -0.3032 0.3032 -0.9529 -2079.1296 -2801.6099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1677,
    style: {
      stopColor: "#FCFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3055,
    style: {
      stopColor: "#F2FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4327,
    style: {
      stopColor: "#E0F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5534,
    style: {
      stopColor: "#C8EEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6698,
    style: {
      stopColor: "#A9E4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#83D8EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8914,
    style: {
      stopColor: "#56CAE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#23B9E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M282.04,342.8c0,0-5.08,13.22-17.88,21.73c-16.47,10.95-43.61,15.6-66.88-9.99l37.69-30.18"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DDD7C5",
    d: "M280.6,339.45c-1.42-0.89-5.12-3.15-9.39-5.76c-6.89-4.22-15.25-9.34-17.81-11.02 c-4.16-2.73-3.97-1.2-6.53-0.39c-2.18,0.69-4.27,0.82-6.13,0.32c0,0.05,0.01,0.1,0,0.14c-0.04,2.34-1.96,4.21-4.3,4.17 c-2.06-0.03-3.76-1.53-4.1-3.49c-2.94,2.44-16.41,13.6-25.55,21.17c-4.1,3.4-7.33,6.07-8.34,6.91 c-2.72,2.26-0.87,5.17,2.43,3.27c1.47-0.85,5.27-3.09,9.64-5.66c7.07-4.16,15.64-9.21,18.37-10.71 c4.42-2.43,2.98-2.97,3.5-5.62c0.3-1.55,0.83-2.93,1.55-4.11l-1.99,44.44c0,0,2.22,0.25,4.41,0.26 c3.46,0.03,4.04-0.33,4.05-0.25c-0.14-5.22-1.32-36.79-1.68-46.3c3.5,1.43,19.44,7.92,30.24,12.32 c4.86,1.98,8.68,3.54,9.87,4.02C282.08,344.47,283.77,341.44,280.6,339.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDD7C5",
    d: "M238.88,319.17c-0.84-5.87-2.94-20.65-4.42-31.05c-0.75-5.28-1.34-9.43-1.53-10.72 c-0.5-3.5-3.95-3.44-4.06,0.36c-0.05,1.7-0.13,6.11-0.22,11.18c-0.15,8.2-0.33,18.15-0.48,21.26c-0.24,5.04,0.97,4.1,2.96,5.93 c1.11,1.02,2,2.14,2.62,3.32c0.76-0.65,1.74-1.03,2.82-1.02C237.43,318.46,238.22,318.72,238.88,319.17z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 303.4494,
    cy: 356.4065,
    r: 22.3564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1616,
    style: {
      stopColor: "#FAFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2848,
    style: {
      stopColor: "#EDF6FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    style: {
      stopColor: "#D8ECF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4714,
    style: {
      stopColor: "#CDE9F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5882,
    style: {
      stopColor: "#B0E1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    style: {
      stopColor: "#80D3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#3FC1E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M317.29,358.35c-4.31-9.65-13.59-29.79-13.84-30.33l0-0.01c0,0,0,0,0,0.01c0,0,0-0.01,0-0.01 l0,0.01c-0.25,0.54-9.53,20.68-13.84,30.33c-4.82,10.79-1.83,25.56,12.55,26.42l0,0.01c0.33,0.02,0.65,0.02,0.97,0.03 c0.11,0,0.22,0,0.33,0c0.11,0,0.22,0,0.33,0c0.32,0,0.64-0.01,0.97-0.03l0-0.01C319.12,383.91,322.12,369.14,317.29,358.35z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M344.89,318.33l-0.12,7.32c-5.01-6.15-11.21-11.03-18.44-14.5c-26.83-12.88-59.13-1.54-72.02,25.29 c-7.83,16.31-6.99,35.35,2.25,50.94l1.56-0.93c-8.93-15.06-9.74-33.46-2.17-49.22c12.45-25.92,43.67-36.89,69.59-24.44 c6.99,3.36,12.98,8.07,17.83,14.02l-6.85-0.29l-0.08,1.82l10.1,0.43l0.17-10.4L344.89,318.33z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M348.89,331.45l-1.55,0.95c9.37,15.21,10.36,33.9,2.63,49.98c-6.03,12.56-16.59,22.02-29.73,26.63 c-13.14,4.62-27.3,3.84-39.86-2.19c-7-3.36-13-8.09-17.85-14.05l6.66,1.61l0.43-1.77l-9.82-2.38l-2.18,10.17l1.78,0.38l1.53-7.12 c5.06,6.29,11.33,11.27,18.67,14.79c7.4,3.56,15.34,5.35,23.32,5.35c6.02,0,12.07-1.02,17.92-3.08 c13.6-4.78,24.53-14.56,30.77-27.56C359.61,366.53,358.59,347.19,348.89,331.45z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M411.94,326.49c-5.08-2.07-11.46-3.87-19.46-5.21c-0.39-0.06-0.71,0.3-0.6,0.68l4.94,16.43 c0.04,0.14,0.03,0.29-0.04,0.41l-5.25,9.46c-0.15,0.27-0.04,0.6,0.23,0.73c6.51,3.17,13.19,7.3,19.1,12.66 c0.25,0.22,0.64,0.17,0.81-0.11l6.21-10.24c0.07-0.12,0.09-0.26,0.06-0.4l-5.69-24.04C412.21,326.69,412.1,326.55,411.94,326.49 z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M393.46,372.41c-7.2,2.27-15.77,4.46-25.97,6.51c-0.68,0.14-1.25,0.59-1.52,1.23l-20.73,48.51 c-0.27,0.62-0.21,1.33,0.13,1.91l23.82,39.28c0.39,0.64,1.09,1.03,1.85,1.01c4.31-0.12,19.2-1.28,32.94-10.97 c0.91-0.64,1.15-1.9,0.55-2.84l-22.34-34.81c-0.33-0.52-0.42-1.16-0.24-1.75l14.12-45.46 C396.58,373.42,395.06,371.9,393.46,372.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M426.27,423.23c0.3,0.52,1.08,0.4,1.22-0.18c1.41-6.02,2.31-12.79,2.54-20.42c0,0,0.63-42.57,0.95-53.37 c0.18-6-2.05-11.32-6.56-15.11c0,0,8.02,7.02,3.57,16.28c-0.3,0.62-0.41,1.22-0.44,1.42l-9.02,56.97 c-0.09,0.6,0.02,1.21,0.33,1.73L426.27,423.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M426.18,426.27l-9.21-15.76c-0.17-0.3-0.24-0.64-0.18-0.98l7.94-50.16c0.22-1.37-1.42-2.27-2.45-1.34 c-4.38,3.98-11.3,8.09-21.95,12.03c-0.43,0.16-0.77,0.51-0.91,0.95l-15.36,49.45c-0.13,0.42-0.07,0.87,0.17,1.24l22.03,34.33 c0.49,0.76,1.54,0.91,2.22,0.32c7.33-6.4,13.92-15.63,17.84-28.91C426.44,427.05,426.39,426.62,426.18,426.27z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#027084",
    d: "M424.42,334.16c0.3,0.27,7.92,7.19,3.56,16.27c-0.3,0.62-0.41,1.22-0.44,1.42l-4.09,25.83 c3.98,7.53,6.44,16.49,6.48,27.14c0.01-0.18,0.02-0.35,0.02-0.53c0.08-5.13,0.27-16.26,0.47-27.35 c0.19-11.13,0.4-22.74,0.54-27.68c0.07-2.51-0.28-4.9-1.04-7.11c-0.86-2.34-2.34-4.85-4.75-7.32 C424.94,334.6,424.68,334.38,424.42,334.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M424.42,334.16c-0.01-0.01-0.01-0.01-0.01-0.01C424.42,334.16,424.42,334.16,424.42,334.16z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#027084",
    d: "M422.28,358.04c-2.22,2.02-5.11,4.08-8.8,6.13c3.26,3.31,6.22,7.04,8.71,11.25l2.54-16.04 C424.95,358,423.31,357.1,422.28,358.04z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.9,
    fill: "#C16032",
    points: "304.49,252.14 306.02,227.82 306.02,252.19 309.07,228.01 307.54,252.33 312.1,228.4 309.05,252.57 315.11,228.97 310.54,252.91 318.07,229.73 312.01,253.33 320.98,230.67 313.45,253.85 323.82,231.8 314.85,254.46 326.59,233.1 316.22,255.15 329.27,234.58 317.53,255.93 331.86,236.22 318.8,256.79 334.33,238.01 320.01,257.73 336.69,239.96 321.15,258.74 338.92,242.06 322.23,259.82 341.01,244.29 323.25,260.97 342.96,246.64 324.18,262.18 344.76,249.12 325.04,263.44 346.4,251.7 325.82,264.76 347.87,254.38 326.52,266.12 349.17,257.15 327.12,267.53 350.3,259.99 327.64,268.96 351.24,262.9 328.07,270.43 352.01,265.87 328.4,271.93 352.58,268.87 328.64,273.44 352.96,271.91 328.78,274.96 353.15,274.96 328.83,276.49 353.15,278.02 328.78,278.02 352.96,281.07 328.64,279.54 352.58,284.1 328.4,281.05 352.01,287.11 328.07,282.54 351.24,290.07 327.64,284.01 350.3,292.98 327.12,285.45 349.17,295.83 326.52,286.85 347.87,298.59 325.82,288.22 346.4,301.27 325.04,289.53 344.76,303.86 324.18,290.8 342.96,306.33 323.25,292.01 341.01,308.69 322.23,293.15 338.92,310.92 321.15,294.23 336.69,313.01 320.01,295.25 334.33,314.96 318.8,296.18 331.86,316.76 317.53,297.04 329.27,318.4 316.22,297.82 326.59,319.87 314.85,298.52 323.82,321.17 313.45,299.12 320.98,322.3 312.01,299.64 318.07,323.25 310.54,300.07 315.11,324.01 309.05,300.4 312.1,324.58 307.54,300.64 309.07,324.96 306.02,300.79 306.02,325.16 304.49,300.83 302.96,325.16 302.96,300.79 299.9,324.96 301.44,300.64 296.87,324.58 299.92,300.4 293.86,324.01 298.43,300.07 290.9,323.25 296.96,299.64 287.99,322.3 295.52,299.12 285.15,321.17 294.12,298.52 282.38,319.87 292.76,297.82 279.7,318.4 291.44,297.04 277.12,316.76 290.18,296.18 274.64,314.96 288.97,295.25 272.29,313.01 287.82,294.23 270.06,310.92 286.74,293.15 267.96,308.69 285.73,292.01 266.01,306.33 284.79,290.8 264.21,303.86 283.93,289.53 262.58,301.27 283.15,288.22 261.1,298.59 282.46,286.85 259.8,295.83 281.85,285.45 258.67,292.98 281.33,284.01 257.73,290.07 280.91,282.54 256.97,287.11 280.57,281.05 256.39,284.1 280.33,279.54 256.01,281.07 280.19,278.02 255.82,278.02 280.14,276.49 255.82,274.96 280.19,274.96 256.01,271.91 280.33,273.44 256.39,268.87 280.57,271.93 256.97,265.87 280.91,270.43 257.73,262.9 281.33,268.96 258.67,259.99 281.85,267.53 259.8,257.15 282.46,266.12 261.1,254.38 283.15,264.76 262.58,251.7 283.93,263.44 264.21,249.12 284.79,262.18 266.01,246.64 285.73,260.97 267.96,244.29 286.74,259.82 270.06,242.06 287.82,258.74 272.29,239.96 288.97,257.73 274.64,238.01 290.18,256.79 277.12,236.22 291.44,255.93 279.7,234.58 292.76,255.15 282.38,233.1 294.12,254.46 285.15,231.8 295.52,253.85 287.99,230.67 296.96,253.33 290.9,229.73 298.43,252.91 293.86,228.97 299.92,252.57 296.87,228.4 301.44,252.33 299.9,228.01 302.96,252.19 302.96,227.82  "
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M236.44,326.92c2.34,0.04,4.27-1.83,4.3-4.17c0-0.05,0-0.1,0-0.14c-0.03-1.42-0.75-2.68-1.86-3.43 c-0.66-0.45-1.45-0.72-2.31-0.73c-1.07-0.02-2.06,0.37-2.82,1.02c-0.89,0.76-1.47,1.89-1.49,3.15c0,0.28,0.02,0.55,0.07,0.81 C232.68,325.38,234.38,326.88,236.44,326.92z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 809,
    y: 91,
    opacity: 0.9,
    fill: "#C16032",
    width: 247,
    height: 629
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M84.61,279.96c0.16-0.01,0.31-0.02,0.47-0.03c0.18-0.15,0.38-0.3,0.59-0.46 C85.23,279.65,84.78,279.77,84.61,279.96z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M97.62,278.23c0.04,0,0.08,0.01,0.13,0C97.71,278.23,97.66,278.23,97.62,278.23z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M92.13,275.76c0.16-0.02,0.32-0.04,0.48-0.05c-0.01,0-0.02,0-0.03,0c-1.09-0.17-1.46,0.11-1.8,0.48 C91.27,275.97,91.73,275.81,92.13,275.76z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M96.54,277.11c0.01,0.01,0.02,0.02,0.03,0.03C96.56,277.13,96.55,277.12,96.54,277.11z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M97,278.04c0,0.01,0,0.02,0,0.03c0-0.02,0.01-0.02,0.02-0.02C97.01,278.05,97,278.04,97,278.04 C97,278.04,97,278.04,97,278.04z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M95.34,276.49c0.49,0.11,0.83,0.29,1.08,0.5c-0.34-0.3-0.86-0.56-1.59-0.79 C95,276.29,95.18,276.39,95.34,276.49z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M87.12,284.48c0.75-0.14,1.91-0.35,3.07-0.57c0-0.18,0-0.36,0-0.54c-0.03,0-0.06-0.01-0.1-0.01 c-1.62,0.5-3.08,0.98-3.78,1.27C86.32,284.62,86.63,284.57,87.12,284.48z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M87.58,278.07c-0.29,0.17-0.57,0.36-0.83,0.59C87.02,278.47,87.3,278.27,87.58,278.07z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-6.34,418.2l-0.07-0.01c-0.16-0.58-0.31-1.15-0.44-1.71c-1.84-5.96-2.48-5.2-3.43-3.83l-3.68,4.8 L-6.34,418.2L-6.34,418.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M86.75,283.14c-0.33,0.38-0.51,0.63-0.51,0.63L86.75,283.14z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M94.95,277.33c-0.68,0.25-1.79,1.76-2.39,5.29c-0.17,0.99-0.3,2.13-0.36,3.45 c0.03,0.19,0.06,0.37,0.11,0.54c-0.05-0.02-0.09-0.05-0.14-0.07c-0.02,0.45-0.03,0.92-0.03,1.41 c-0.06,7.45,1.92,13.29,3.76,3.47C97.73,281.6,96.9,276.61,94.95,277.33z M93.45,287.27C93.45,287.27,93.45,287.26,93.45,287.27 l0.04,0C93.49,287.27,93.48,287.27,93.45,287.27z M93.55,287.09c0.06-0.2,0.11-0.39,0.14-0.59 C93.64,286.75,93.59,286.96,93.55,287.09z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M96.71,277.32c-0.01-0.02-0.03-0.04-0.04-0.06C96.69,277.28,96.7,277.3,96.71,277.32z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M100.09,506.8C100.12,506.81,100.1,506.8,100.09,506.8L100.09,506.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M102.12,523.94c0.04,0.01,0.13,0.03,0.24,0.06C102.23,523.97,102.16,523.95,102.12,523.94z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M96.91,277.67c-0.01-0.02-0.02-0.04-0.02-0.06C96.89,277.63,96.9,277.65,96.91,277.67z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M97.5,278.21c-0.03-0.01-0.06-0.01-0.09-0.02C97.44,278.2,97.47,278.21,97.5,278.21z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M96.84,277.52c-0.02-0.04-0.04-0.07-0.06-0.1C96.8,277.45,96.82,277.48,96.84,277.52z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M-13.15,575.98c0-0.05,0.01-0.1,0.01-0.15C-13.15,575.88-13.15,575.93-13.15,575.98z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M17.07,565.35c-7.61-1.93-14.14-4.37-19.55-6.83c0,0,0,0,0,0C2.17,560.72,8.73,563.29,17.07,565.35z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M-8.92,648.75C-8.92,648.75-8.92,648.75-8.92,648.75c0.79,10.08-0.4,42.24,0.37,48.77c0,0,0,0,0,0 C-9.26,690.13-8.08,657.56-8.92,648.75z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M-13.28,577.46c-0.8,9.75-0.29,19.18,0.68,29.86C-13.75,591.42-13.72,583.28-13.28,577.46z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M54.81,569.18C46.15,570.89,1.56,581-3.67,596.84c-0.03,14.61,0.59,31.8,2.74,48.4 c4.53,34.99,3.57,76.19,3.78,80.63c0,0,0,0,0,0c15.47,10.67,53,9.12,79.63,10.23c6.56,0.27,33.33-1.19,36.14-13.83 c7.51-33.7-4.69-105.11-15.19-155.06l-38.77,1.26C61.29,568.82,58,569.05,54.81,569.18z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M-9.22,555.37c-0.08,0.28-0.15,0.56-0.23,0.84c0.13-0.37,0.25-0.65,0.34-0.8 C-9.14,555.41-9.18,555.39-9.22,555.37z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M71.84,316.16c-0.16-0.1-0.32-0.2-0.48-0.3C71.52,315.96,71.68,316.06,71.84,316.16z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M75.44,318.45c-0.58-0.37-1.18-0.75-1.79-1.14C74.26,317.7,74.85,318.08,75.44,318.45z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M77.68,319.88c-0.64-0.41-1.29-0.82-1.96-1.25C76.39,319.06,77.04,319.47,77.68,319.88z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M101.88,294.67c-1.65-2.78-2.37-3.81-2.99-5.67c-0.04,0.15-0.06,0.21-0.06,0.21s0.42-1.88,0.07-3.03 c-0.05-0.16-0.29-0.37-0.35-0.54c-0.21-0.6-1.56-1.81-1.65-1.21c-0.24,1.7,0.43,10.47-2.96,11.94 c-3.17,1.38-3.24-6.93-2.97-10.36c-0.84-0.3-2.54-0.91-3.18-1.07c-0.22-0.15-0.45-0.31-0.67-0.47 c-0.49,0.09-0.81,0.14-0.81,0.14c0.7-0.29,2.16-0.77,3.78-1.27c-0.57-0.07-1.54-0.15-3.13-0.2c-0.23,0.2-0.47,0.4-0.72,0.63 c0,0,0.18-0.26,0.51-0.63c-0.3-0.01-0.63-0.02-0.97-0.02l0.96-2.68c1.67-0.16,2.93-0.39,3.61-0.42 c0.09-0.33,0.71-0.53,0.96-0.76c1.17-1.12,1.91-2.35,3.37-2.21c0.17,0.02,1.8,0.08,1.84,0.12c0.01,0.01,0.02,0.02,0.03,0.03 c0.03,0.04,0.07,0.08,0.1,0.11c0.02,0.02,0.03,0.04,0.04,0.06c0.02,0.03,0.04,0.06,0.06,0.1c0.02,0.03,0.04,0.07,0.06,0.1 c0.02,0.03,0.03,0.07,0.05,0.1c0.01,0.02,0.02,0.04,0.02,0.06c0.06,0.16,0.09,0.3,0.09,0.37c0,0,0,0,0,0 c0.01,0,0.02,0.01,0.02,0.01c0.02,0,0.04,0,0.07,0.02c0.07,0.03,0.38,0.14,0.41,0.14c0.04,0.01,0.2,0.02,0.25,0.02 c0.08,0,1.46,0.12,1.1-1.26c0.09-0.94,0.85-2.1,0.9-3.03c-0.04-1.89,1.94-5.82,0.94-9.3c-0.67-2.36-0.94-8.07-5.2-6.67 c0,0,0.02-0.01,0.05-0.02c-0.02-0.05-0.04-0.09-0.06-0.14c-1.56,1.84-25.67-4.94-25.67-4.94L33.24,308.1l-0.77,18.77 c-3.79,1.79-7.47,2.39-7.63,2.42c0.06,1.72-0.11,3.81-0.9,5.77c-0.99,2.48-1.51,3.55-3.57,4.02c0,0,0.01,0,0.01,0 c0.01,0,0.03,0,0.04-0.01c0.05,0.04,0.04,0.04-0.03,0.01c-2.72,1.37-5.35,2.34-7.2,2.67l4.14,2.17 c17.15,14.39,41.22,56.18,41.22,56.18c6.99-11.04,9.31-36.05,10.06-44.46c0.24-2.65-0.78-4.69-0.78-4.69 c0.01,0,0.02,0.01,0.03,0.01c-0.03-0.18-0.05-0.37-0.06-0.58c0.05-1.36-0.21-3.36-0.14-5.12c1.01-1.9-4.05-13.66,23.74-10.78 c6.84-0.19,6.7-4.71,6.06-7.95c-0.66-3.29,0.87-3.45,1.44-5.36c-2.97-2.72-6.07-6.07-6.46-6.59c1.16-0.76,7.63-3.37,7.88-6.1 c0.03,0.04,0.06,0.08,0.09,0.12c-1.46-3.2,1.36-3.3,3.69-4.67C107.42,301.98,105.72,301.17,101.88,294.67z M97.44,303.11 c0.02-0.27,0.06-0.44,0.06-0.44C97.47,302.82,97.46,302.97,97.44,303.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M20.39,339.08L20.39,339.08c-0.21,0.03-0.43,0.07-0.65,0.1C19.96,339.14,20.17,339.11,20.39,339.08z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M88.19,242.04c-7.75-8.55-18.38-11.14-35.86-9.21c0.17-0.03,0.34-0.05,0.51-0.08 c0,0-4.11-0.13-7.16,0.82c-0.07,0.07-0.14,0.12-0.21,0.17l0.13,0l-1.58,0.29l0.01-0.29c-0.06-0.03-0.13-0.07-0.2-0.1 c-0.01-0.01-0.02-0.01-0.03-0.02c-0.07-0.04-0.16-0.08-0.26-0.11c-2.05-0.1-3.93,0.04-5.65,0.37c-2.44,0.61-5.52,1.86-8.69,4.08 c-0.41,0.29-0.82,0.58-1.24,0.9c-1.62-0.88-3.85-1.53-6.72-2.2c-13.42-3.13-20.94,5.71-23.62,12.88 c-2.57,6.9-2.31,13.05-0.25,17.85c0.88,3.46,2.35,7.35,4.62,11.7c0,0-0.59-2.73-1.06-6.31c2.57,2.66,5.9,4.4,9.55,4.93 c0.12,5.78,1.17,11.1,2.94,15.18c0.18,0.42,0.37,0.84,0.57,1.24c4.01,7.98,6.55,15.34,8.15,21.25c0.85,2.96,1.55,5.98,2,8.92 c0.08,0.48,0.15,0.91,0.22,1.33l0,0c0,0,0.4,1.54,0.47,3.66c0.16-0.03,3.84-0.63,7.63-2.42c4.58-2.16,9.31-6.04,8.19-12.68 c-0.34-0.07-0.08-3.13-0.44-3.22c-12.3-3.01-10.37-14.19-10.07-14.37c0.37-7.57,28.61-6.78,28.41,1.42 c-0.02,1,1.83,1.5,1.63,2.44c2.64-2.56,6.75-6.1,13.05-10.75c0.58-0.42,1.14-0.86,1.7-1.31c-3.73,5.12-6.41,10.4-7.27,12.14 c0.87-1.04,2.72-3.14,6.48-7.27c3.1-3.41,5.59-6.87,7.62-10.19c0.63-1.04,1.22-2.06,1.77-3.06c0.04-0.07,0.08-0.15,0.12-0.22 c6.48-7.73,10.77-16.3,11.81-21.99c0.02,0.05,0.04,0.09,0.06,0.14c0.64-0.2,7.13-1.75,3.42,18.31c0,0,1.07-0.67,1.07,2.05 C107.5,261.48,101.3,244.37,88.19,242.04z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#99857D",
    d: "M24.84,329.29c0.06,1.72-0.11,3.81-0.9,5.77c-1,2.5-1.52,3.57-3.63,4.03c0.04-0.01,0.08-0.01,0.11-0.02 c0.81,0.57,1.61,1.19,2.42,1.87c6.2-2.25,9.54-7.84,9.62-14.08C28.68,328.65,25,329.26,24.84,329.29z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M93.45,287.27c0.03,0,0.04,0,0.04,0L93.45,287.27C93.45,287.26,93.45,287.27,93.45,287.27z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M92.19,286.07c-0.01,0.16-0.02,0.31-0.03,0.47c0.05,0.02,0.09,0.04,0.14,0.07 C92.25,286.43,92.22,286.25,92.19,286.07z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M93.69,286.5c-0.04,0.2-0.08,0.4-0.14,0.59C93.59,286.96,93.64,286.75,93.69,286.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.8,284.95c0.63,0.16,1.42,0.39,2.26,0.69c0.02-0.25,0.04-0.48,0.07-0.67 c0.05-0.36,0.07-0.72,0.07-1.06c-1.16,0.22-2.33,0.44-3.07,0.57C87.35,284.65,87.57,284.81,87.8,284.95z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M86.96,283.15c-0.07,0-0.14,0-0.21-0.01l-0.51,0.63C86.49,283.55,86.72,283.35,86.96,283.15z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M97.5,302.66c0,0-0.03,0.18-0.06,0.44C97.46,302.97,97.47,302.82,97.5,302.66z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#AB7D62",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M97.44,303.11 c0,0.02,0,0.04,0,0.05"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M96.76,313.53c-0.97,0.28-1.76-0.23-2.63-0.22c-0.01,0.03-0.68,0.94-0.68,0.98 c-0.08,0.55,1.51,1.64,2.46,2.14c0.22,0.12,0.35-0.33,0.52-0.24C95.47,315.62,95.18,314.47,96.76,313.53z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#669694",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M103.96,524.37 c0.01,0,0.03,0.01,0.04,0.01"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#669694",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M104.19,524.42 c0.02,0.01,0.05,0.01,0.07,0.02"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-13.65,552.62c-3.57-2.42-7.83-5.52-7.83-5.52S-18.81,549.45-13.65,552.62z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-21.17,545c0.05-0.3,0.1-0.63,0.16-0.98C-21.06,544.35-21.12,544.67-21.17,545z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-38.85,463.36c0.18-0.7,0.36-1.42,0.52-2.13C-38.48,461.79-38.66,462.53-38.85,463.36z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-34.93,501.49c-0.55,0.25-1.18,0.49-1.93,0.7C-36.15,502-35.51,501.77-34.93,501.49z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-36.07,450.19c0,0,0.92-0.96,2.33-2.51C-34.73,448.67-35.56,449.55-36.07,450.19z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-83.22,483.7c-0.18-0.41-0.34-0.85-0.51-1.28C-83.57,482.85-83.4,483.28-83.22,483.7z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-83.2,483.77c3.12,7.37,9.29,13.59,20.53,16.2c5.16,1.2,10.19,2.15,14.67,2.61 c-7.33-0.83-15.23-3.04-18.91-4.23C-73.14,496.34-79.68,491.84-83.2,483.77z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-31.76,496.92c0.04,0.31,0.1,0.99-0.21,1.79c0.23-0.47,0.39-1,0.49-1.56 c-0.07-0.08-0.13-0.17-0.19-0.25C-31.7,496.91-31.73,496.91-31.76,496.92z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#659896",
    points: "-6.34,418.2 -0.23,418.8 -6.34,418.2  "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M-0.93,645.24c-2.15-16.6-2.77-33.79-2.74-48.4c5.23-15.84,49.83-25.95,58.48-27.66 c-14.56,0.56-27.18-1.14-37.74-3.82c-8.33-2.07-14.89-4.64-19.55-6.82c0,0,0,0,0,0c-2.46-1.12-4.7-2.24-6.69-3.32 c-0.02,0.06-0.03,0.11-0.05,0.17c0.04,0.02,0.08,0.03,0.11,0.05c-0.1,0.15-0.21,0.43-0.34,0.8c-1.92,6.98-3.09,13.38-3.69,19.61 c0,0.05-0.01,0.1-0.01,0.15c-0.05,0.49-0.09,0.99-0.13,1.48c-0.44,5.82-0.47,13.96,0.68,29.86c0.92,10.21,2.25,21.58,3.24,35.49 c0.15,2.05,0.29,4.03,0.44,5.94c0,0,0,0,0,0c0.83,8.8-0.34,41.38,0.37,48.77c0,0,0,0,0,0c1.99,16.86,3.65,22.81,3.65,22.81 s2.88,2.19,7.74,5.54c0,0,0,0,0,0C2.63,721.43,3.59,680.23-0.93,645.24z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#254354",
    d: "M-0.93,645.24c-2.15-16.6-2.77-33.79-2.74-48.4c5.23-15.84,49.83-25.95,58.48-27.66 c-14.56,0.56-27.18-1.14-37.74-3.82c-8.33-2.07-14.89-4.64-19.55-6.82c0,0,0,0,0,0c-2.46-1.12-4.7-2.24-6.69-3.32 c-0.02,0.06-0.03,0.11-0.05,0.17c0.04,0.02,0.08,0.03,0.11,0.05c-0.1,0.15-0.21,0.43-0.34,0.8c-1.92,6.98-3.09,13.38-3.69,19.61 c0,0.05-0.01,0.1-0.01,0.15c-0.05,0.49-0.09,0.99-0.13,1.48c-0.44,5.82-0.47,13.96,0.68,29.86c0.92,10.21,2.25,21.58,3.24,35.49 c0.15,2.05,0.29,4.03,0.44,5.94c0,0,0,0,0,0c0.83,8.8-0.34,41.38,0.37,48.77c0,0,0,0,0,0c1.99,16.86,3.65,22.81,3.65,22.81 s2.88,2.19,7.74,5.54c0,0,0,0,0,0C2.63,721.43,3.59,680.23-0.93,645.24z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M54.81,569.18c0.22-0.04,0.43-0.08,0.6-0.12c-15.3,0.6-28.15-1.18-38.35-3.71 C27.63,568.04,40.25,569.74,54.81,569.18z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-2.49,558.53c-5.33-8.39-7.21-21.01-7.78-31.23l-5.7-2.72c-2.18,6.81-4,13.34-5.04,19.44 c-0.06,0.35-0.11,0.68-0.16,0.98c-0.11,0.71-0.22,1.41-0.31,2.1c0,0,4.26,3.1,7.83,5.52c1.33,0.82,2.81,1.68,4.47,2.58 C-7.18,556.29-4.95,557.41-2.49,558.53z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M-2.49,558.53c-5.33-8.39-7.21-21.01-7.78-31.23l-5.7-2.72c-2.18,6.81-4,13.34-5.04,19.44 c-0.06,0.35-0.11,0.68-0.16,0.98c-0.11,0.71-0.22,1.41-0.31,2.1c0,0,4.26,3.1,7.83,5.52c1.33,0.82,2.81,1.68,4.47,2.58 C-7.18,556.29-4.95,557.41-2.49,558.53z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#161616",
    points: "-10.27,527.3 -10.27,527.3 -16.28,524.44 -16.28,524.44 -15.97,524.58  "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-40.59,469.16c0.01-0.09,0.02-0.18,0.04-0.26C-40.56,468.98-40.57,469.07-40.59,469.16 c0.16-0.12,0.34-0.24,0.52-0.35c0.28-1.46,0.54-2.8,0.63-3.04c-0.01-0.09,0.02-0.28,0.1-0.56c0.17-0.6,0.33-1.22,0.49-1.84 c0.19-0.83,0.37-1.58,0.52-2.13c1.32-5.58,2.25-11.04,2.25-11.04c0.51-0.65,1.34-1.52,2.33-2.51c0.24-0.26,0.48-0.54,0.75-0.83 l-0.32-2.2c-2.61,1.78-5.17,2.93-7.12,2.13c-6.34-2.6-3.08,10.79-2.42,22.82c0.49,0.15,0.86,0.38,1.14,0.65 C-41.42,469.88-41.06,469.51-40.59,469.16z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M-40.59,469.16c0.01-0.09,0.02-0.18,0.04-0.26C-40.56,468.98-40.57,469.07-40.59,469.16 c0.16-0.12,0.34-0.24,0.52-0.35c0.28-1.46,0.54-2.8,0.63-3.04c-0.01-0.09,0.02-0.28,0.1-0.56c0.17-0.6,0.33-1.22,0.49-1.84 c0.19-0.83,0.37-1.58,0.52-2.13c1.32-5.58,2.25-11.04,2.25-11.04c0.51-0.65,1.34-1.52,2.33-2.51c0.24-0.26,0.48-0.54,0.75-0.83 l-0.32-2.2c-2.61,1.78-5.17,2.93-7.12,2.13c-6.34-2.6-3.08,10.79-2.42,22.82c0.49,0.15,0.86,0.38,1.14,0.65 C-41.42,469.88-41.06,469.51-40.59,469.16z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#161616",
    points: "-32.98,446.93 -32.98,446.93 -33.31,444.65 -33.31,444.65 -32.99,446.85  "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M126.16,433.07c-9.22-55.3-18.87-63.36-27.9-70.02c0,0-7.18-4.35-30.37-12.08 c-0.01,0-0.02-0.01-0.03-0.01c0,0-0.07,1.61-0.31,4.26c-0.76,8.41-3.18,27.29-10.16,38.32c0,0-17.37-38.2-34.52-52.6 c-0.81-0.68-1.62-1.31-2.42-1.87c-0.04,0.01-0.08,0.01-0.11,0.02c-0.58,0.13-1.27,0.21-2.14,0.26c0,0,0,0,0,0 c-1.44,0.14-3.04,0.23-4.75,0.29c-2.31,0.09-4.83,0.14-7.48,0.23c-14.51,0.46-32.92,1.93-41.25,16.16 c-11.61,19.83-5.36,18.09-21.44,44.89c-4.13,6.89-7.49,13.19-10.15,18.58c-1.4,1.64-3.65,4.57-6.29,9.07c0,0,0,0,0,0.01 c-3.68,7.39-7.68,21.5-4.19,30.72c0.11,0.16,0.22,0.39,0.33,0.7c0.04,0.12,0.09,0.26,0.13,0.38c0.37,0.8,0.81,1.56,1.32,2.27 c4.97,6.86,10.04,24.35,15.35,29.51c1.63-1.1,3.09-10.72,4.18-12.28c2.11-6.92,6-9.15,7.69-9.71c2.68-0.89,4.41-0.93,5.52-0.58 c-0.66-12.02-3.92-25.42,2.42-22.82c1.94,0.8,6.99,0.12,9.6-1.66l-4.09-24.86c-0.43-2.65-0.7-2.83,1.17-2.06l19.76-0.75 l3.68-4.8c0.95-1.38,1.59-2.13,3.43,3.83c0.16,0.52,0.33,1.09,0.51,1.72l5.94,0.58c0.05,0.59,0.1,1.16,0.16,1.73l12.15,3.53 c1.81,0.74,1.75,1.57,1.82,4.01l13.85,113.51c0.08,2.47-1.19,1.13-3.03,0l-36.99-18.56c0.57,10.22,3.43,29.3,8.76,37.69 c5.41,2.46,12.24,5.36,19.84,7.29c10.2,2.53,23.46,3.16,39.24,1.09c-0.17,0.03,0.83,2.27,0.6,2.32 c3.19-0.12,5.27-2.55,8.65-2.91l38.77-1.26l5.97-0.19c0.53-9.04-9.31-60.22-9.31-60.22c25.38,19.34,30.44-7.24,31.43-15.11 C133.33,477.19,134.69,484.24,126.16,433.07z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M-0.23,418.8v1.71c-1.72-15.07,3.08-39.13,2-37.33c-1.34,2.23-3.57,17.87-5.36,9.38 c-1.79-8.49-3.13-11.17-3.13-11.17c0,15.18-3.23,22.25-0.14,35.08c0,0,0,0.01,0,0.01c0.16,0.52,1.1,3.28,1.28,3.91L-0.23,418.8z "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#161616",
    points: "0.06,418.83 0.06,418.83 -0.23,418.8  "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-31.76,496.92c-5.19,1.11-10.57-1.32-13.61-4.98c-2.25-2.7-3.11-4.84-3.42-5.87 c-0.87-2.5-1.01-5.04-0.17-7.19c2.04-5.21,4.59-6.09,6.03-6.12c0.02-0.09,0.04-0.18,0.07-0.27c0.04-0.09,0.07-0.19,0.11-0.29 c-0.02-0.86-0.05-1.73-0.1-2.62c-1.12-0.35-2.85-0.31-5.52,0.58c-1.69,0.56-5.58,2.79-7.69,9.71 c-1.1,1.56-2.55,11.18-4.18,12.28c-5.31-5.16-10.39-22.64-15.35-29.51c-0.51-0.7-0.94-1.47-1.32-2.27 c-0.04-0.13-0.09-0.26-0.13-0.38c-0.11-0.32-0.22-0.54-0.33-0.7c-3.49-9.22,0.51-23.34,4.19-30.72c0,0,0,0,0-0.01 c-2.78,4.73-6.01,11.21-9.17,19.79c-2.49,6.76-5.9,21.76-1.38,34.07c0.16,0.43,0.33,0.87,0.51,1.28 c0.01,0.02,0.02,0.04,0.03,0.06c3.52,8.07,10.06,12.58,16.28,14.58c3.68,1.18,11.58,3.39,18.91,4.23 c4.4,0.45,8.26,0.41,11.15-0.38c0.74-0.21,1.38-0.45,1.93-0.7c1.35-0.65,2.37-1.56,2.96-2.78 C-31.65,497.91-31.72,497.23-31.76,496.92z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M-31.53,497.29c-5.19,1.11-10.85-1.55-13.9-5.2c-2.25-2.7-3.11-4.84-3.42-5.87 c-0.87-2.5-1.01-5.04-0.17-7.19c2.04-5.21,4.59-6.09,6.03-6.12c0.02-0.09,0.04-0.18,0.07-0.27c0.04-0.09,0.07-0.19,0.11-0.29 c-0.02-0.86-0.05-1.73-0.1-2.62c-1.12-0.35-2.85-0.31-5.52,0.58c-1.69,0.56-5.58,2.79-7.69,9.71 c-1.1,1.56-2.55,11.18-4.18,12.28c-5.31-5.16-10.39-22.64-15.35-29.51c-0.51-0.7-0.94-1.47-1.32-2.27 c-0.04-0.13-0.09-0.26-0.13-0.38c-0.11-0.32-0.22-0.54-0.33-0.7c-3.49-9.22,0.51-23.34,4.19-30.72c0,0,0,0,0-0.01 c-2.78,4.73-6.01,11.21-9.17,19.79c-2.49,6.76-5.9,21.76-1.38,34.07c0.16,0.43,0.33,0.87,0.51,1.28 c0.01,0.02,0.02,0.04,0.03,0.06c3.52,8.07,10.06,12.58,16.28,14.58c3.68,1.18,11.64,3.26,18.97,4.09 c4.4,0.45,8.15,0.45,11.04-0.33c0.74-0.21,1.41-0.44,1.95-0.7c1.35-0.65,2.39-1.48,2.99-2.69 C-31.71,498.04-31.5,497.59-31.53,497.29z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-41.71,470.25c-0.28-0.27-0.65-0.5-1.14-0.65c0.05,0.88,0.08,1.76,0.1,2.62 C-42.51,471.6-42.23,470.92-41.71,470.25z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M43.68,235.1l1.66,0c0.09,0,0.19,0.01,0.28,0.04l-0.01-1.41l-0.13,0l-1.44,0l-0.31,0L43.68,235.1z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M46.69,281.45l-0.12-45.06c0-0.61-0.41-1.12-0.95-1.25c-0.09-0.02-0.18-0.04-0.28-0.04l-1.66,0l-0.05,0 c-0.68,0-1.23,0.58-1.24,1.29l-0.22,45.14c0.94-0.15,1.91-0.22,2.9-0.2C45.62,281.34,46.16,281.38,46.69,281.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.772,
    y1: 244.6383,
    x2: 82.475,
    y2: 258.0888,
    gradientTransform: "matrix(0.9997 0.0235 -0.0235 0.9997 -44.4344 5.4548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5156,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.5156
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7501,
    style: {
      stopColor: "#090909",
      stopOpacity: 0.7501
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.9271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1E1C"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M46.69,281.45l-0.12-45.06c0-0.61-0.41-1.12-0.95-1.25c-0.09-0.02-0.18-0.04-0.28-0.04l-1.66,0 l-0.05,0c-0.68,0-1.23,0.58-1.24,1.29l-0.22,45.14c0.94-0.15,1.91-0.22,2.9-0.2C45.62,281.34,46.16,281.38,46.69,281.45z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#99857D",
    d: "M40.23,310.97c0.35,0.09,0.1,3.15,0.44,3.22c4.32,0.87,7.64,0.31,10.16-0.9c0,0,0.01,0,0.01-0.01 c2.59-1.25,4.36-3.2,5.56-5.01c5.03,3.3,17.32,11.36,20.29,13.13c2.49,1.48,3.68,0.94,3.37-0.02 c-0.2-0.11-18.79-12.49-22.83-15.06c-0.32,0.42-22.28-4.99-27.33-8.33C29.67,301.1,30.5,308.59,40.23,310.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33190D",
    d: "M28.87,296.79c0-0.13,0.01-0.27,0.02-0.4c-0.07-0.01-0.12-0.02-0.13-0.01 c-0.29,0.18-1.43,14.57,10.87,17.57c0.35,0.09,0.69,0.16,1.03,0.22c-0.34-0.07-0.08-3.13-0.44-3.22 c-9.73-2.38-10.55-9.86-10.33-12.98C29.23,297.55,28.86,297.14,28.87,296.79z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#41637C",
    cx: 44.65,
    cy: 297.13,
    r: 15.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.8623,
    y1: 297.1669,
    x2: 60.5428,
    y2: 297.1669
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4913,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7387,
    style: {
      stopColor: "#0A0A09",
      stopOpacity: 0.7387
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    style: {
      stopColor: "#171716",
      stopOpacity: 0.931
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1E1C"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M28.87,296.79c-0.07,3.01,0.7,5.84,2.1,8.27c0.38,0.66,0.81,1.29,1.28,1.89 c0.31,0.4,0.65,0.78,1,1.15c1.05,1.1,2.26,2.05,3.59,2.81c1.06,0.61,2.2,1.1,3.4,1.45c1.31,0.38,2.68,0.61,4.11,0.64 c0.3,0.01,0.6,0,0.9-0.01c0.09,0,0.19-0.01,0.28-0.01c0.21-0.01,0.41-0.02,0.61-0.04c0.11-0.01,0.21-0.02,0.32-0.03 c0.19-0.02,0.38-0.05,0.57-0.07c0.11-0.02,0.21-0.03,0.31-0.05c0.2-0.03,0.4-0.07,0.6-0.11c0.09-0.02,0.18-0.03,0.26-0.05 c0.28-0.06,0.56-0.13,0.83-0.21c0,0,0.01,0,0.01,0c0.28-0.08,0.56-0.17,0.84-0.27c0.07-0.02,0.13-0.05,0.19-0.07 c0.21-0.07,0.41-0.15,0.62-0.24c0.08-0.03,0.16-0.07,0.24-0.1c0.19-0.08,0.38-0.17,0.57-0.26c0.08-0.04,0.15-0.07,0.23-0.11 c0.2-0.1,0.4-0.2,0.59-0.31c0.06-0.03,0.11-0.06,0.17-0.09c0.51-0.29,1-0.6,1.48-0.94c0.02-0.02,0.04-0.03,0.07-0.05 c0.21-0.15,0.41-0.31,0.62-0.47c0.05-0.04,0.09-0.08,0.14-0.11c0.18-0.15,0.35-0.3,0.53-0.45c0.05-0.04,0.09-0.08,0.14-0.12 c0.18-0.17,0.36-0.34,0.53-0.51c0.03-0.03,0.06-0.06,0.09-0.09c0.41-0.43,0.8-0.87,1.17-1.34c-2.47-1.57-4.51-2.87-5.78-3.68 c-1.7,1.91-4.2,3.09-6.96,3.03c-4.99-0.12-8.95-4.26-8.83-9.26c0.12-4.99,4.26-8.95,9.26-8.83c4.99,0.12,8.95,4.26,8.83,9.26 c-0.03,1.31-0.35,2.55-0.87,3.66c1.35,0.91,3.35,2.25,5.69,3.79c0.74-1.34,1.3-2.81,1.63-4.36c0.2-0.95,0.32-1.93,0.34-2.93 c0.19-8.2-5.88-15.09-13.85-16.09c-0.53-0.07-1.07-0.11-1.61-0.12c-0.99-0.02-1.96,0.05-2.9,0.2 c-7.27,1.17-12.92,7.29-13.29,14.86h0C28.88,296.53,28.87,296.66,28.87,296.79z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M52.87,301.04c0.53-1.11,0.84-2.35,0.87-3.66c0.12-4.99-3.84-9.14-8.83-9.26 c-4.99-0.12-9.14,3.84-9.26,8.83c-0.12,4.99,3.84,9.14,8.83,9.26c2.76,0.06,5.26-1.12,6.96-3.03 C52.02,302.55,52.5,301.82,52.87,301.04z M44.6,301.35c-2.31-0.05-4.13-1.97-4.08-4.28c0.05-2.31,1.97-4.13,4.28-4.08 c2.31,0.05,4.13,1.97,4.08,4.28C48.83,299.57,46.91,301.4,44.6,301.35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.0146,
    y1: 289.5369,
    x2: 86.9218,
    y2: 289.5369,
    gradientTransform: "matrix(0.9997 0.0235 -0.0235 0.9997 -44.4344 5.4548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4913,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7387,
    style: {
      stopColor: "#0A0A09",
      stopOpacity: 0.7387
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    style: {
      stopColor: "#171716",
      stopOpacity: 0.931
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1E1C"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M52.87,301.04c0.53-1.11,0.84-2.35,0.87-3.66c0.12-4.99-3.84-9.14-8.83-9.26 c-4.99-0.12-9.14,3.84-9.26,8.83c-0.12,4.99,3.84,9.14,8.83,9.26c2.76,0.06,5.26-1.12,6.96-3.03 C52.02,302.55,52.5,301.82,52.87,301.04z M44.6,301.35c-2.31-0.05-4.13-1.97-4.08-4.28c0.05-2.31,1.97-4.13,4.28-4.08 c2.31,0.05,4.13,1.97,4.08,4.28C48.83,299.57,46.91,301.4,44.6,301.35z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M48.88,297.27c0.05-2.31-1.77-4.22-4.08-4.28c-2.31-0.05-4.22,1.77-4.28,4.08 c-0.05,2.31,1.77,4.22,4.08,4.28C46.91,301.4,48.83,299.57,48.88,297.27z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M79.45,321.01c0.21,0.13,0.41,0.25,0.61,0.36l0,0C79.86,321.26,79.66,321.14,79.45,321.01z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M73.65,317.32c-0.6-0.38-1.2-0.77-1.81-1.15C72.45,316.55,73.05,316.93,73.65,317.32z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M79.45,321.01c-0.57-0.36-1.16-0.74-1.77-1.13C78.29,320.27,78.88,320.65,79.45,321.01z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M75.71,318.63c-0.09-0.06-0.18-0.12-0.28-0.18C75.53,318.51,75.62,318.57,75.71,318.63z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M57.23,306.86L57.23,306.86L57.23,306.86c4.04,2.57,9.24,5.88,14.13,9 C66.47,312.74,61.27,309.43,57.23,306.86z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#33190D",
    d: "M20.1,254.91c9.84-21.02,23.4-21.08,23.4-21.08l0.54-0.09c-0.01-0.01-0.21-0.11-0.23-0.12 c-0.07-0.04-0.16-0.08-0.26-0.11c-1.46-0.36-3.93-0.03-5.65,0.37c-2.44,0.61-5.52,1.86-8.69,4.08 C21.59,244.24,20.1,254.91,20.1,254.91z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#41637C",
    points: "51.45,303.18 57.23,306.86 58.57,304.83 52.87,301.04  "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M52.87,301.04c-0.37,0.78-0.85,1.5-1.42,2.14c1.27,0.81,3.31,2.1,5.78,3.68l0,0 c4.04,2.57,9.24,5.88,14.13,9c0.16,0.1,0.32,0.2,0.48,0.3c0.61,0.39,1.22,0.77,1.81,1.15c0.61,0.39,1.2,0.76,1.79,1.14 c0.09,0.06,0.18,0.12,0.28,0.18c0.67,0.43,1.33,0.85,1.96,1.25c0.61,0.39,1.2,0.77,1.77,1.13c0.21,0.13,0.41,0.25,0.61,0.36l0,0 c4.06,2.26,5.37-0.43,2-2.12c-1.95-0.98-3.24-1.88-8.16-4.77c-4.89-2.87-10.76-6.65-15.33-9.65 C56.22,303.29,54.22,301.95,52.87,301.04z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-26.75,494.42c0.02,0.25-0.03-0.08,0.52-0.52l-0.03-0.23C-26.59,493.98-26.76,494.26-26.75,494.42z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-27.49,485.15l-0.04-0.26c-0.21,0.05-0.33,0.08-0.33,0.08C-28.1,485.08-27.93,485.14-27.49,485.15z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-33.74,447.68c-1.41,1.56-2.33,2.51-2.33,2.51c0.16,1.7-0.94,6.42-2.25,11.04c0,0,0,0,0,0 c-0.17,0.71-0.34,1.42-0.52,2.13c-0.39,1.73-0.83,3.85-1.22,5.45c0.38-0.24,0.82-0.46,1.33-0.67c0,0,0.24-0.08,0.65-0.23 c1.3-1.26,6.03-5.77,7.17-6.34l0.1,0.41l-0.5-3.51l0.01-0.01l-0.8-5.53l-0.87-6.01C-33.24,447.18-33.49,447.43-33.74,447.68 C-33.73,447.68-33.73,447.68-33.74,447.68z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-29.01,474.53l-0.01-0.05c-0.3,0.17-0.77,0.44-1.49,0.84C-29.54,474.78-29.16,474.6-29.01,474.53z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M-24.18,491.47c-1.09,0.24-1.6,1.75-2.09,2.21l0.03,0.23c0.36-0.28,1.65,0.65,2.72,0.41 c2.71-0.6,8.34-1.99,10.43-2.44c2.09-0.45,8.5-4.6,8.5-4.6l-0.19-0.1c0,0-5.73,0.05-8.54,1.05S-22.37,491.06-24.18,491.47z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M-10.27,527.3L-10.27,527.3l37.39,17.82c1.84,1.13,3.36-0.01,3.28-2.48L18.8,426.19 c-0.08-2.44-1.68-5.14-3.49-5.88l-15.24-1.49l0,0l-0.3-0.03l-6.11-0.6l-7.63-0.75l-20.33-1.99c-1.87-0.76-3.14,0.89-2.71,3.54 l3.71,25.65l0,0l0.33,2.28l0,0l0.87,6.01l0.8,5.53l-0.01,0.01l0.5,3.51l0.31,4.75c3.75-1.33,8.65-3.02,10.76-3.79 c3.94-1.44,6.81-1.87,8.57,0c0.98,0.82,1.31,1.5,0.46,2.01c-0.01,0-0.86,0.75-0.87,0.76c-1.37,1.66-4.33,1.26-7.75,2.85 c-4.48,2.08-9.67,3.65-9.67,3.65s-0.39,2.08-0.75,2.28l0,0c0.09-0.04-0.5,0-0.5,0l0.33,0.5c0.01,0,0.4,0.14,0.4,0.14l0.29,2.04 c0.37-0.01,1.32,1.21,1.75,1.19c0,0,11.89-1.7,17.58-2.56c4.7-0.71,6.66-1.59,7.93-0.25c1.27,0.91,1.15,2.02,0.05,2.4 c-0.24,0.08-0.35,0.27-0.64,0.36c-1.27,0.85-2.71,0.75-4.9,1.19c-2.89,0.58-12.22,1.95-17.66,3.15 c-1.21,0.27-1.36,0.97-2.01,1.12c-0.17,0.04-1.16,1.1-1.28,1.13l0.23,0.67c0.12,0,1.07,0.19,1.23,0.18 c1.69-0.04,5.44-0.23,7.89-0.72c3.54-0.71,15.51-4.29,18.49-4.25c1.39,0.02,1.67,1.23,1.8,2.33c0.6,0.92,0,1.41-0.79,1.79 c-0.56,0.27-0.27-0.2-1.01,0.07c-0.07,0.03-1.14,0.61-1.21,0.64c-1.96,0.84-4.2,1.9-4.2,1.9s1.24,0.23,1.7,1.01 c0.67,0.6,1.26,1.06,0.69,1.49c-0.26,0.2-0.64,0.31-0.98,0.55c-0.67,0.53-2,0.99-3.45,1.79c-2.81,1.56-5.92,1.8-8.6,2.98 c-2.16,0.95-5.87,1.62-8.57,2.16c-0.17,0.03-0.48,0.06-0.64,0.09l1.35,8.46l0.06-0.02l1.72,11.92c0.32,1.98,1.51,3.95,2.92,4.82 l3.5,1.67l0,0L-10.27,527.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M-29.88,476.59c0.36,0.01,0.79,0,1.27-0.01l-0.22-1.59c0,0,0,0-0.02,0l0.21,1.54 C-29.1,476.57-29.51,476.58-29.88,476.59z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M-16.12,496.21c2.68-1.18,6.12-1.9,8.93-3.46c1.44-0.8,2.49-1.32,3.17-1.86 c0.14-0.1,2.46-0.91,0.78-2.75c-0.47-0.78-1.51-0.97-1.51-0.97l0.19,0.1c0,0-7.69,2.97-9.77,3.42 c-2.09,0.45-7.11,1.76-9.83,2.36c-1.08,0.24-1.69,0.57-2.05,0.85c-0.55,0.43-0.5,0.77-0.52,0.52c-0.01-0.16,0.16-0.45,0.48-0.75 c0.49-0.46,1.32-0.97,2.41-1.21c1.81-0.4,8.22-1.87,11.03-2.88c2.82-1.01,8.06-2.41,8.06-2.41s2.28-0.51,4.28-1.25 c4.16-1.55,2.36-2.6,2.51-3.56c0.15-0.96-0.97-1.98-2.36-2c-2.98-0.04-15.36,3.15-18.9,3.86c-2.45,0.49-6.13,0.89-7.82,0.92 c-0.16,0-0.3,0-0.43,0c-0.45-0.01-0.62-0.07-0.37-0.19c0,0,0.13-0.03,0.33-0.08c0.11-0.03,0.25-0.06,0.41-0.09 c0.65-0.15,1.68-0.38,2.89-0.64c5.44-1.2,14.6-3.14,17.49-3.72c2.18-0.44,4.21-1.06,5.48-1.91c2.65-1.41,0.67-3.21,0.65-3.63 c-0.97-1.24-4.12-1.38-8.82-0.67c-5.69,0.86-17.99,2.31-17.99,2.31c-0.43,0.02-0.83,0.04-1.19,0.05 c-0.48,0.01-0.91,0.02-1.27,0.01c-2.67,0.07-2.48-0.25-0.63-1.27c0.72-0.4,1.19-0.66,1.49-0.84c0.36-0.21,0.48-0.28,0.48-0.28 s5.28-2.76,9.76-4.84c3.42-1.59,7.54-2.57,8.91-4.23c1.13-0.66,0.28-2.71-0.3-2.92c-1.77-1.87-6.11-2.09-10.05-0.65 c-2.1,0.77-6.11,2.19-9.86,3.52l-0.74-3.1l-0.1-0.41c-1.14,0.57-5.87,5.09-7.17,6.34c-0.41,0.15-0.65,0.23-0.65,0.23 c-0.51,0.21-0.94,0.44-1.33,0.67c0,0,0,0,0,0c-0.18,0.11-0.36,0.23-0.52,0.35c0,0,0,0,0,0c-0.47,0.35-0.83,0.72-1.12,1.09 c-0.52,0.67-0.81,1.35-1.04,1.96c-0.04,0.1-0.07,0.2-0.11,0.29c-0.03,0.08-0.05,0.18-0.07,0.27c-1.44,0.03-3.99,0.91-6.03,6.12 c-0.84,2.15-0.71,4.69,0.17,7.19c-0.13-0.43-0.17-0.66-0.17-0.66s0.95,5.6,7.24,9.65c6.27,4.03,10.15,1.99,10.04,1.84 c-0.03-0.05-0.04-0.05,0,0c0.06,0.08,0.12,0.17,0.19,0.25c0.97,1.19,2.71,2.18,4.79,1.89c0.33-0.04,0.72-0.11,1.17-0.19 c0.16-0.03,0.33-0.06,0.5-0.1C-22.32,498.22-18.28,497.16-16.12,496.21z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M-29.88,476.59c0.36-0.01,0.77-0.03,1.24-0.05l-0.21-1.54l-0.07-0.51c0,0,0-0.01-0.1,0.03 c-0.15,0.07-0.53,0.25-1.5,0.79C-32.35,476.35-32.54,476.67-29.88,476.59z"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M94.51,498.2l-19.25-34.34c2.56-0.16,7.06-1.05,7.36-1.25c1.02-0.56,2.27-0.68,3.17-1.45 c3.82-3.24,0.9-4.09,0.9-4.09s6.94-1,3.11-4.69c-3.82-3.69-7.45-7.29-10.83-10.13c-3.38-2.84-5.52-4.37-6.79-6.06 c-1.27-1.69-2.48-4.16-5.19-3.71c0,0-0.55-1.14-1.77-1.95c-1.22-0.81-3.37-0.88-5.17,0.2c-1.79,1.08-7.96,4.36-11.58,5.83 c-3.63,1.48-5.22,2.74-7.66,4.44c-2.44,1.7-5.01,2.92-7.69,3.95c-1.37,0.53-2.95,0.99-4.06,1.59c-0.91,0.42-1.58,0.89-1.46,1.44 c0.02,0.08,0.04,0.16,0.06,0.25c0,0.17,0.03,0.35,0.11,0.54c0,0,1.22,4.49,6.93,2.61c3.63-1.19,12.37-4.89,12.37-4.89l0.09,0.92 c0-0.01,0.01-0.02,0.02-0.03c-0.04,0.15-0.07,0.31-0.11,0.49c-0.23,1.09,0.1,2.19,0.88,3.37c0,0-1.7,0.98-2.71,2.2 c-0.51,0.63-0.77,1.75-0.63,2.8c0,0.1,0.01,0.19,0.02,0.3c0.27,2.62,2.47,2.38,4.02,3.25c1.55,0.87,3.48,2.14,4.82,2.54 c1.16,0.35,1.96-0.71,2.42-1.91c0.29,0.15,0.55,0.28,0.78,0.38c0,0.01-0.01,0.02-0.01,0.02l0.56,0.21 c0.17,0.07,0.27,0.1,0.27,0.1s-0.78,1.7,1.44,3.04c2.22,1.34,4.33,2.29,5.41,2.33c1.08,0.04,3.05-1.25,3.05-1.25 s1.48-1.14,3.55-1.52c1.62,1.13,10.3,15.11,14.45,21.29C92,494.9,94.51,498.2,94.51,498.2z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M54.53,443.36c0.84-0.56,2.83-2.19,4.93-3.53c1.46-0.93,3.08-1.63,3.67-2.07 c1.44-1.09,2.78-4.83,1.9-4.37c-0.88,0.46-1.39-0.27-1.21-0.67c0,0-2.29,1.19-4.61,2.74c-2.32,1.54-5.09,3.63-6.56,4.44 c-1.44,0.78-3.91,2.15-5.43,0.41c-0.06-0.09-0.11-0.18-0.16-0.27c-0.73,0.64-1.72,1.59-2.1,2.32c-0.37,0.71-1.9-0.47-2.18,1.74 c-0.01,0.1-0.03,0.19-0.03,0.3c-0.17,2.63,2.04,2.76,3.42,3.88c1.38,1.12,3.07,2.69,4.33,3.31c1.08,0.54,2.06-0.37,2.71-1.47 C52.44,449.55,53.1,444.31,54.53,443.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M35.2,436.28c2.9-0.53,9.4-1.42,12.28-2.34s9.55-5.21,11.24-6.06c1.69-0.85,2.83-1.14,1.86-0.49 c-0.98,0.65-2.08,1.22-5.98,3.22c-3.86,1.97-7.09,4.14-7.81,5.19c-0.06,0.15-0.13,0.3-0.19,0.46c-0.41,1.03-0.27,2.18,0.3,3.47 c0,0-1.84,0.68-3.04,1.72c-0.61,0.53-1.05,1.6-1.09,2.66c0.28-2.21,1.81-1.03,2.18-1.74c0.38-0.73,1.37-1.68,2.1-2.32 c0.05,0.09,0.1,0.18,0.16,0.27c1.52,1.73,3.81,1.52,5.24,0.74c1.48-0.81,4.96-2.77,7.28-4.32c2.32-1.54,3.4-3.09,3.4-3.09 c-0.18,0.4-0.53,1.05,0.35,0.59c0.88-0.46-0.11,0.4-1.55,1.49c-0.59,0.45-1.92,1.31-3.37,2.24c-2.1,1.34-4.47,2.82-5.31,3.38 c-1.42,0.95-2.16,1.2-3.01,3.02c0,0,0-0.02,0-0.03c-0.15,0.47-0.26,1.12-0.11,1.86c-0.64-1.09-1.32-1.49-2.06-0.85 c-0.86,0.75-0.87,3.09,0.09,3.84c0.95,0.76,1.38,2.17,2.07,1.86c0.64-0.29,0.87-1.99,0.52-3.43c0.02,0.03,0.04,0.06,0.06,0.09 c0.73,1.02,1.63,1.83,2.38,2.4c0.26,0.2,0.5,0.37,0.71,0.51c1.07-1.4,4.04-2.66,6.76-4.15c2.73-1.5,4.37-3.67,4.37-3.67 c-0.68,2.35-3.64,3.96-5.85,5.17c-2.22,1.21-4.01,2.39-4.52,3.11c0,0-1.06,1.55,0.91,3.24c1.97,1.69,3.88,2.99,4.94,3.2 c1.06,0.22,3.22-0.72,3.22-0.72s0.45-0.16,0.72-0.76c0.27-0.59,1.09-0.44,1.09-0.44s0.47,1.58,1.76-1.26c0,0,0.7,1.75,2.49,1.88 c1.79,0.13,2.76-0.92,3.53-1.6c0.77-0.68,0.99,3.5,4.19,5.24c3.2,1.75,5.29,3.02,5.29,3.02s-0.02,0.01-0.05,0.02 c1.1-0.38,2.2-0.87,3.22-1.47c4.31-2.56,6.39-7.02,6.39-7.02s-1.22-2.31-4.37-6.59c-3.15-4.28-6.12-8.44-8.98-11.8 c-2.86-3.36-4.71-5.24-5.68-7.11c-0.97-1.87-1.75-4.51-4.5-4.53c0,0-0.35-1.22-1.42-2.22c-1.07-1-3.18-1.43-5.13-0.67 c-1.95,0.76-8.57,2.96-12.4,3.81c-3.82,0.85-5.6,1.83-8.29,3.09c-2.69,1.27-5.43,2.04-8.24,2.61c-1.44,0.29-3.07,0.48-4.27,0.89 c0.39-0.11-1.57,2.2-1.66,1.43c-0.03,0.17-0.03,0.35,0.01,0.55C28.65,437.13,33.39,436.61,35.2,436.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M54.65,451.09l-0.25-0.14C54.56,451.04,54.65,451.09,54.65,451.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M77.97,458.55c-3.2-1.75-2.73-6.62-3.5-5.94c-0.77,0.68-3.27,2.55-5.06,2.42 c-1.79-0.13-2.25-2.82-2.25-2.82c-1.29,2.84-4.04,3.85-4.04,3.85s1.59-0.58,1.32,0.01c-0.27,0.59-0.72,0.76-0.72,0.76 s2.89,1.22,5.24,1.47c1.53,0.16,2.66,1.22,3.88,2.67c1.22,1.46,2.5,3.06,2.5,3.06c3.83,0.49,6.99-0.89,7.4-1.07 c0.03-0.01,0.05-0.02,0.05-0.02S81.18,460.3,77.97,458.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M59.17,447.98c2.22-1.21,5.17-2.82,5.85-5.17c0,0-1.63,2.18-4.37,3.67c-2.72,1.49-5.69,2.75-6.76,4.15 c-0.01,0.01-0.01,0.01-0.02,0.02l0.52,0.3l0.25,0.14C55.16,450.37,56.96,449.19,59.17,447.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M33.83,437.65c3.77-0.57,13.01-2.75,13.01-2.75l-0.07,0.92c0.01-0.01,0.02-0.02,0.02-0.03 c0.71-1.05,3.94-3.21,7.81-5.19c3.9-1.99,5-2.56,5.98-3.22c0.98-0.65-0.17-0.37-1.86,0.49c-1.69,0.85-8.97,4.48-11.85,5.4 s-8.79,1.87-11.69,2.39c-1.8,0.33-6.53,1.46-7.75-1.76C27.43,433.91,27.88,438.55,33.83,437.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E5D8",
    d: "M29.47,434.87c1.74-0.01,3.87-1.09,3.38-2.33c-0.49-1.23-1.03-1.36-2.52-1.05 c-0.43,0.09-0.86,0.19-1.26,0.3c-0.97,0.26-1.71,0.61-1.68,1.18c0,0.08,0.01,0.17,0.02,0.26 C27.51,433.99,27.92,434.88,29.47,434.87z"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M89.46,449.8c0,0,5.93-0.94,3.03,4.85L89.46,449.8z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M102.07,304.3c1.24,0,1.86-0.86,1.29-0.91c-1.67-0.14-2.91,0.33-3.48,1 C99.3,305.06,100.83,304.3,102.07,304.3z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M100.38,305.54c-1.21,0.13-3.09-0.15-2.94-2.38C97.34,304.33,97.4,307.06,100.38,305.54z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M92.4,313.05c0.03-0.41,0.16-0.83,0.28-1.22c0.63-2.07,3-6.39,3-6.39c0.03-0.16-4.48,7.01-5.77,12.17 c-1.03,4.15,0.52-1.29,1.81-2.58c0.02,0.01,0.03,0.02,0.05,0.04c0,0,3.18,4.48,7.14,6.11c0,0,1.85-1.6-0.54-3.47 c-0.83-0.65-1-0.85-2.44-1.84c-0.95-0.51-2.15-1.27-2.07-1.82c0.01-0.04-0.01,0.03,0,0c0.87-0.01,1.92-0.23,2.89-0.52 c0.34-0.1,0.68-0.22,1.01-0.36c0,0,4.84-1.71,2.67-4.56c-0.03-0.04-0.06-0.08-0.09-0.12C100.33,308.39,96.2,311.64,92.4,313.05z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M71.3,331.62c-9.41-3.14-12.14-4.64-14.59-9.95c0,0,3.91,8.31,6.5,12.95c2.59,4.64,4.52,8.13,4.38,13.03 c0,0,2.67-11.5,8.45-11.93c8.28-0.61,15.89-1.17,15.89-1.17c-0.17-0.02-0.34-0.04-0.5-0.06C84.03,333.63,80.5,334.69,71.3,331.62 z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M85.88,285.09c-0.48,0.19-1,0.81-2,0.86C83.88,285.95,85.53,286.4,85.88,285.09z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M84.84,285.05c0.62-0.3,0.71-0.44,0.71-0.44c-1.1,0.14-1.72-0.1-1.91-0.24 C83.45,284.23,83.98,285.48,84.84,285.05z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M86.75,283.14"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M96.77,281.62v0.08C96.81,281.65,96.81,281.63,96.77,281.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M92.58,282.49c-0.01,0.04-0.02,0.08-0.02,0.13c0,0,0,0,0,0l0,0C92.57,282.56,92.58,282.52,92.58,282.49z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M95.34,276.49c-0.68-0.6-3.41,4.48-3.4,5.56c0,0-1.74,3.16-1.74,4.55c0,0.12-0.22,0.57-0.22,0.66 c-1.5,0.05-1.03,1.53-1.05,1.72c-0.92,7.45,5.87,13.11,8.66,2.74C100.18,282.07,96.91,277.86,95.34,276.49z M96.78,281.62 c0.04,0.01,0.04,0.04,0,0.08V281.62z"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7BFB1",
    d: "M90.2,283.54c0-0.04,0-0.09,0-0.18c0,0-0.05-0.01-0.1-0.01c-1.66,0-3.36,1.06-4.04,1.34 c0,0,0.31-0.06,0.81-0.14c0.75-0.14,2.18-0.42,3.34-0.64C90.2,283.72,90.2,283.72,90.2,283.54z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M90.19,283.37c-0.03,0-0.06-0.01-0.1-0.01c-1.62,0.5-3.08,0.98-3.78,1.27c0,0,0.31-0.06,0.81-0.14 c0.75-0.14,1.91-0.35,3.07-0.57C90.2,283.72,90.2,283.54,90.19,283.37z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M94.05,273.49c-3.49-0.7-6.28,2.79-8.37,5.23c-0.44,0.52-0.79,0.92-1.07,1.24 c0.16-0.01,0.31-0.02,0.47-0.03c1.9-1.51,5.17-3.9,7.05-4.18c1.31-0.2,2.39,0.21,3.21,0.74c0.49,0.11,0.73,0.57,0.97,0.8 c0.49,0.47,0.61,0.79,0.62,0.91c0-0.04,0.12-0.15,0.18-0.13C97.69,277.06,97.39,274.16,94.05,273.49z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M98.05,286.4c0.02-0.02,0.05-0.04,0.07-0.06c-0.04-0.14-0.09-0.28-0.13-0.4 c-0.15,0.18-0.29,0.34-0.41,0.48C97.75,286.42,97.9,286.41,98.05,286.4z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M98.96,276.26c3.71-20.06-2.78-18.51-3.42-18.31c-0.03,0.01-0.05,0.02-0.05,0.02 c2.9,6.71,3.44,13,3.5,16.17c-0.05,0.93-0.13,1.88-0.22,2.82c-0.17,0.51-0.44,1.13-0.78,1.24c-0.09,0.03-0.17,0.03-0.24,0.04 c-0.05,0-0.09,0-0.13,0c-0.04,0-0.08-0.01-0.12-0.02c-0.03-0.01-0.06-0.01-0.09-0.02c-0.14-0.04-0.25-0.09-0.32-0.13 c-0.03-0.01-0.06-0.02-0.07-0.02c-0.01,0-0.02,0-0.02,0.02c0-0.01,0-0.02,0-0.03c-0.01-0.07-0.03-0.2-0.09-0.37 c-0.01-0.02-0.02-0.04-0.02-0.06c-0.01-0.03-0.03-0.06-0.05-0.1c-0.02-0.03-0.04-0.07-0.06-0.1c-0.02-0.03-0.04-0.06-0.06-0.1 c-0.01-0.02-0.16-0.2-0.17-0.21c-0.04-0.04-0.08-0.08-0.13-0.12c-0.24-0.21-0.59-0.39-1.08-0.5c-0.14-0.03-0.3-0.06-0.47-0.07 c-1.46-0.14-3.07,1.26-4.24,2.38c-0.25,0.23-0.39,0.53-0.48,0.86c-0.86,0.05-2.67,0.15-5.08,0.28c-0.15,0.01-0.31,0.02-0.47,0.03 c-0.34,0.02-0.69,0.04-1.05,0.06c-0.55,1-1.14,2.03-1.77,3.06c1.11,0,2.26,0.01,3.44,0.03c0.56,0.01,1.07,0.02,1.53,0.03 c0.07,0,0.14,0,0.21,0.01c1.59,0.05,2.56,0.13,3.13,0.2c0.04,0,0.07,0.01,0.1,0.01c0,0.18,0.01,0.36,0,0.54 c-0.01,0.35-0.03,0.7-0.07,1.06c-0.02,0.19-0.05,0.42-0.07,0.67c-0.27,3.42-0.09,12.1,3.32,11.51c3.66-0.63,3.88-9.78,4.13-11.48 c0.09-0.6,0.28-0.33,0.49,0.27c0.04,0.12,0.09,0.25,0.13,0.4c0.35,1.15,0.71,2.87,0.71,2.87s0.02-0.05,0.06-0.21 c0.09-0.37,0.29-1.36,0.56-3.67c0.04-0.37,0.09-0.78,0.13-1.23c0.13-1.28,0.27-2.85,0.42-4.82c0.03-0.37,0.04-0.69,0.04-0.98 C100.03,275.59,98.96,276.26,98.96,276.26z M95.89,291.42c-1.84,9.82-3.82,3.98-3.76-3.47c0-0.49,0.02-0.96,0.03-1.41 c0.01-0.16,0.02-0.31,0.03-0.47c0.07-1.32,0.2-2.46,0.36-3.45c0.6-3.53,1.71-5.04,2.39-5.29 C96.9,276.61,97.73,281.6,95.89,291.42z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M93.45,287.26l0.04,0.01c0,0,0.02-0.07,0.06-0.18c0.04-0.13,0.09-0.34,0.14-0.59 c0.16-0.8,0.29-2.08-0.15-3.29c0,0,1.55-0.52,3.1-1.42c0.81-0.47-1.44,0.08-4.08,0.84c-0.17,0.99-0.3,2.13-0.36,3.45 c0.03,0.19,0.06,0.37,0.11,0.54C92.7,286.81,93.08,287.03,93.45,287.26z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D7BFB1",
    points: "58.57,304.83 82.54,319.52 84.61,320.76 83.88,322.13 82.18,322.31 80.06,321.37 57.23,306.86 "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M52.87,301.04c-0.37,0.78-0.85,1.5-1.42,2.14c1.27,0.81,3.31,2.1,5.78,3.68l0,0 c4.04,2.57,9.24,5.88,14.13,9c0.16,0.1,0.32,0.2,0.48,0.3c0.61,0.39,1.22,0.77,1.81,1.15c0.61,0.39,1.2,0.76,1.79,1.14 c0.09,0.06,0.18,0.12,0.28,0.18c0.67,0.43,1.33,0.85,1.96,1.25c0.61,0.39,1.2,0.77,1.77,1.13c0.21,0.13,0.41,0.25,0.61,0.36l0,0 c4.06,2.26,5.37-0.43,2-2.12c-1.95-0.98-3.24-1.88-8.16-4.77c-4.89-2.87-10.76-6.65-15.33-9.65 C56.22,303.29,54.22,301.95,52.87,301.04z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#33190D",
    d: "M22.15,315.38c0.85,2.96,1.55,5.98,2,8.92c0.08,0.48,0.15,0.91,0.22,1.33l0,0c0,0,0.4,1.54,0.47,3.66 c0.16-0.03,3.84-0.63,7.63-2.42c0-0.4,0-0.8-0.02-1.2c-0.58-10.42-14.11-25.78-19.02-32.78c0.18,0.42,0.37,0.84,0.57,1.24 C18.01,302.1,20.55,309.46,22.15,315.38z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M20.32,339.09c-0.47,0.1-1.02,0.18-1.67,0.23c-0.15,0.01-0.31,0.03-0.47,0.03 c-1.2,0.11-2.5,0.19-3.89,0.26c-0.3,0.02-0.59,0.03-0.85,0.04c-0.01,0-0.01,0-0.02,0c-2.31,0.09-4.83,0.14-7.48,0.23c0,0,0,0,0,0 c6.92,2.58,12.6,2.64,16.9,1.08c-0.81-0.68-1.62-1.31-2.42-1.87C20.39,339.08,20.35,339.08,20.32,339.09z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M-12.17,461.75c-1.16,0.25-2.06,0.57-2.7,0.84c-0.62,0.26-0.87,1.01-0.54,1.6 c0.44,0.77,1.02,1.78,1.34,2.28c0.54,0.87,2.92-0.55,4.21-1.33c0.01,0,0.02-0.01,0.03-0.02c0.86-0.52,0.65-2.08-0.33-2.91 C-10.66,461.8-11.34,461.57-12.17,461.75z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M-5.51,475.74c-0.25,0.85,0.31,1.97,0.66,2.94c0.29,0.8,2.16,0.32,3.6-0.14c0.3-0.1,0.58-0.19,0.82-0.27 c1.11-0.38,1.24-2.46-0.17-3.36c-0.37-0.24-0.82-0.42-1.39-0.42C-4.56,474.47-5.26,474.89-5.51,475.74z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M-0.23,481.36c-2.55,0.3-3.19,0.81-3.34,1.68c-0.15,0.87,0.54,1.92,1.01,2.84 c0.27,0.54,1.24,0.35,2.27-0.03c0.74-0.27,1.5-0.64,2.07-0.91c0.79-0.38,0.84-1.64,0.24-2.55 C1.59,481.71,0.83,481.23-0.23,481.36z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M-5.19,487.8c-1.89,0.64-2.3,1.12-2.28,1.8c0.03,0.69,0.72,1.37,1.22,2c0.36,0.45,1.35-0.1,2.22-0.72 c0.34-0.24,0.67-0.49,0.93-0.69c0.56-0.43,0.36-1.46-0.3-2.06C-3.83,487.76-4.45,487.55-5.19,487.8z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M-31.53,497.45c0.03-0.01,0.09-0.25,0.06-0.3c-0.89-1.36-2.52-2.47-3.79-4.06 c-1.26-1.59-1.01-3.56-1.94-4.33c-0.6-0.49-1.29-1.24-1.78-2.24c-1.74-0.66-3.98-1.2-6.15-0.81c-3.09,0.56-3.58,0.32-3.58,0.32 s0.04,0.24,0.17,0.66c0.31,1.03,1.17,3.16,3.42,5.87C-42.08,496.22-34.71,498.8-31.53,497.45z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E5D8",
    d: "M30.34,431.64c-0.43,0.09-0.86,0.19-1.26,0.3c-0.97,0.27-1.71,0.61-1.68,1.18"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "249.47,457.57 249.47,457.57 249.47,457.57  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M178.81,405.32c0,0,0.02,0.03,0.04,0.07c-0.01-0.03-0.02-0.07-0.05-0.12 C178.81,405.3,178.81,405.32,178.81,405.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M256.52,487.31c-0.78,0.47-1.78,1.01-2.58,1.5C254.84,488.33,255.7,487.89,256.52,487.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M251.48,445.21c-0.21,0.65-3.56,3.75-3.56,3.75c-3.72,4.1-4.41,7.81-5.86,14.73 c-1.44,6.92-4.52,11.21-2.39,15.55c2.13,4.33,1.88,5.5-3.44,7.48c-2.36,0.88-3.96,3.69-5.48,4.95c1.68,1.63,3.42,3.47,4.9,5.34 c0.47-0.28,1.87-0.37,2.49-0.72c5.07-2.84,12.38-6.77,16.23-8.69c3.85-1.93,3.29-3.14,6.43-6.08c3.14-2.94,4.03-4.71,4.79-5.16 c0.76-0.46,0.52-3.59,0.78-4.5c0.25-0.91,0,0,0.25-0.91l1.37-2.84c0,0-0.04,0.1-0.11,0.27c0.08-0.19,0.17-0.38,0.24-0.55 c0.46-1-1.82-3.64-4.55-0.27c-2.73,3.37-2.64,5.19-4.19,6.37c-1.55,1.18-3.91,3.28-4.46,3.73c-0.28,0.24-1.71,0.55-3.37,0.91 c-0.37-0.19-1.85-0.88-3.18-0.95c-0.77-0.05-1.62,0.03-2.2-1.43c-0.22-0.5-0.29-1.12-0.16-1.85c0.36-2-0.46-5.73,0.73-8.92 c0.08-0.2,0.14-0.41,0.21-0.62c0.06,0.04,2.4,0.3,2.47,0.34c-0.06-0.06-0.75-0.82-0.75-0.82l-0.5-1.33l0,0l1.25-1.8 c0,0,1.08,0.06,2.19,0.36c1.11,0.3,1.74,1.63,2.8,2.13c1.06,0.51,2.07-0.44,2.07-0.44s-0.04,0.25-0.19,0.54 c0.22-0.35,0.26-0.73,0.11-0.98c-0.4-0.63-1.3-1.56-2.09-2.09c-0.79-0.53-1.39-1.72-2.58-2.32c-0.76-0.38-1.35-0.67-2.11-0.81 c-0.06,0.01-0.11,0.02-0.18,0.02c0,0,0.01-0.02,0.02-0.04c0,0,0,0,0,0c0,0,0,0,0,0c0.24-0.42,1.67-2.48,2.15-3.39 c0,1.11,0.99,1.19,1.8,1.61c1.7,0.88,4.62,1.4,4.84-0.26c0,0-0.01,0.04-0.02,0.11c0.68-1.56-1.02-2.22-2.01-2.4 c-1.06-0.2-1.19-1.26-2.38-1.39c-0.33-0.04-0.66-0.09-1.05-0.15c0.35-0.52,0.71-1.02,1.13-1.49c1.55-1.73,4.5-6.55,2.09-7.83 c-1.55-0.82-3.55,1.36-4.28,2C250.99,445.69,251.75,444.38,251.48,445.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M227.63,485.06c-0.33,0.74-0.84,1.64-1.34,2.45c0.03,0.02,0.05,0.05,0.08,0.07 C226.82,486.85,227.28,485.98,227.63,485.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M241.65,454.52c1.49-0.73,2.04-1.12,2.73-3.36c-0.9,0.2-1.58,0.55-2.13,1.01 C240.44,454.43,240.74,455.5,241.65,454.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M253.01,463.95c-1.42-0.78-2.77-1.96-2.77-1.96S251.53,463.18,253.01,463.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M251.37,465.26c0,0-0.01,0.22-0.14,0.45c0.27-0.32,0.35-0.72,0.25-0.9c-0.22-0.4-1.25-1.39-1.92-1.97 c-0.21-0.18-0.45-0.37-0.68-0.54l-0.21,0.05C249.58,463.31,251.12,464.97,251.37,465.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M249.43,466.06c0.41,0.17,0.77,0.18,1.06,0.11C250.22,466.21,249.88,466.19,249.43,466.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M242.41,451.93c0.02-0.02,0.04-0.05,0.07-0.07C242.48,451.86,242.46,451.88,242.41,451.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M242.37,451.98c0.02-0.02,0.03-0.04,0.05-0.05C242.4,451.95,242.38,451.96,242.37,451.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M254.77,462.67c-1.06-0.51-1.93-1.77-3.04-2.08c-1.11-0.3-3.44-0.25-3.44-0.25l-0.56,2.23l0,0 l-0.66,2.23c0,0,0.03,0.04,0.08,0.1c0.2,0.21,0.8,0.73,2.28,1.16c0.45,0.13,0.79,0.15,1.06,0.11c0.4-0.06,0.62-0.26,0.74-0.47 c0.13-0.23,0.14-0.45,0.14-0.45c-0.25-0.28-1.8-1.94-2.7-2.9l0.21-0.05l1.35-0.31c0,0,1.35,1.18,2.77,1.96 c0.48,0.26,0.96,0.48,1.41,0.59c1.1,0.28,1.64-0.3,1.88-0.78c0.15-0.29,0.19-0.54,0.19-0.54S255.83,463.18,254.77,462.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M250.16,478.78c-0.16,0.02-0.32,0.06-0.48,0.12C250.5,478.72,251.1,478.67,250.16,478.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M206.89,498.63c6.62-5.36,13.43-10.55,17.38-12.68C220.54,487.85,214.1,492.73,206.89,498.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M371.04,511.76c0,0.04,0.01,0.09,0.01,0.14C371.05,511.85,371.05,511.8,371.04,511.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M370.95,511.37C370.95,511.38,370.95,511.38,370.95,511.37C370.95,511.38,370.95,511.38,370.95,511.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M371,511.54c0.01,0.02,0.01,0.05,0.02,0.08C371.01,511.59,371.01,511.56,371,511.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M363.31,521.57c-4.04,2.3-12.05,6.38-16.31,8.26l0,0.01c4.25-1.88,12.27-5.97,16.31-8.26 c4.04-2.3,6.09-6.5,7.31-8.34c0.15-0.22,0.25-0.43,0.32-0.64c-0.07,0.2-0.17,0.41-0.32,0.63 C369.39,515.07,367.35,519.27,363.31,521.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M371.05,512c0,0.09-0.01,0.18-0.03,0.27C371.04,512.18,371.05,512.09,371.05,512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M371.02,512.31c-0.02,0.09-0.04,0.17-0.07,0.26C370.98,512.48,371,512.39,371.02,512.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M370.75,510.99C370.75,510.99,370.76,510.99,370.75,510.99c0.53-0.65,1.2-1.48,1.97-2.46 c0.51-0.65,0.76-1.21,0.84-1.68c-0.08,0.47-0.33,1.03-0.84,1.67C371.95,509.5,371.28,510.33,370.75,510.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M344.54,530.52c-2.75,0.69-13.85,4.26-16.87,4.76c-3.02,0.51-4.3,0.36-7.71,1.66s-3.58,1.43-4.9,2.43 c-0.49,0.37-1.77,1.43-3.21,2.61c0,0,0,0.01,0,0.01c1.43-1.19,2.72-2.25,3.21-2.61c1.33-1,1.49-1.13,4.9-2.43 c3.41-1.3,4.69-1.16,7.71-1.66c3.02-0.51,14.12-4.07,16.87-4.76c1.05-0.26,1.85-0.54,2.52-0.84l0-0.01 C346.39,529.98,345.59,530.25,344.54,530.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M308.42,523.38c0.24,0.12,0.43,0.35,0.58,0.69c0.29,0.67,0.55,1.33,0.8,1.99 c3.3-0.37,8.71-1.85,12.79-10.54c5.19-11.05,26.96-6.09,31.85-8.51c4.23-2.09,8.27-4.49,15.14-7.66 c-2.31,0.3-5.64,1.53-6.72,1.76c-1.65,0.36-6.35,2.2-6.35,2.2s-8.04,1.05-12.34,1.11c-3.58,0.05-8.46,0.85-9.52,0.74 c-0.03,0.12-0.04,0.19-0.04,0.19s-0.98,0.07,0.01-2.17c0.98-2.24,2.85-4.22,4.86-5.47c2.02-1.26,2.7-1.49,5.53-2.86 s2.42-4.01,2.64-4.79c0.01,0.01,0.01,0.02,0.02,0.02c-0.61-0.94-1.76-1.24-2.41-0.84c-1.36,0.85-4.11,1.99-6.38,2.92 c-2.27,0.93-4.38,2.05-6.64,3.7c-2.26,1.65-5.79,2.19-8.33,3.9c-2.54,1.71-3.7,2.83-5.83,4.95c-2.13,2.12-4.78,3.18-6.31,7.26 c-1.53,4.08-2.49,4.61-3.89,5.81c-0.43,0.37-1.25,1.02-2.27,1.81C306.58,520.34,307.57,521.52,308.42,523.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M372.61,504.78c0.67-0.97,0.97-1.75,1.04-2.39C373.58,503.03,373.28,503.81,372.61,504.78 C372.6,504.78,372.61,504.78,372.61,504.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M372.61,504.78C372.61,504.78,372.6,504.78,372.61,504.78c0.67-0.97,0.97-1.75,1.04-2.39 c0.21-1.91-1.66-2.44-1.66-2.44c-0.73-0.96-1.84-1.17-3.03-1.02c-0.01,0-0.02,0.01-0.03,0.01c-6.87,3.17-10.71,4.31-14.93,6.4 c-4.89,2.42-27.56-2.17-32.75,8.87c-4.08,8.69-8.14,11.47-11.44,11.84c0.65,1.76,0.11,4.11,0.45,5.81 c0.37,1.85-0.03,4.01,0.06,5.71c0.1,1.93,1.67,2.76,1.54,4.41c1.43-1.19,2.72-2.25,3.21-2.61c1.33-1,1.49-1.13,4.9-2.43 s4.69-1.16,7.71-1.66c3.02-0.51,14.12-4.07,16.87-4.76c1.05-0.26,1.86-0.54,2.52-0.85l0,0.01l-0.06,0.15c0,0,0,0,0,0 c4.25-1.88,12.27-5.96,16.31-8.26c4.04-2.3,6.09-6.5,7.31-8.34c0.14-0.21,0.25-0.42,0.32-0.63c0-0.01,0.01-0.03,0.01-0.04 c0.03-0.09,0.05-0.17,0.07-0.26c0-0.01,0.01-0.03,0.01-0.04c0.02-0.09,0.02-0.18,0.03-0.27c0-0.04,0-0.07,0-0.1 c0-0.05,0-0.09-0.01-0.14c-0.01-0.05-0.01-0.1-0.02-0.14c-0.01-0.03-0.01-0.05-0.02-0.08c-0.01-0.06-0.03-0.11-0.05-0.16 c0,0,0,0,0,0c-0.05-0.14-0.11-0.27-0.2-0.38c0,0,0,0,0-0.01c0.53-0.65,1.2-1.48,1.97-2.47c0.51-0.65,0.75-1.2,0.84-1.67 C373.81,505.45,372.64,504.8,372.61,504.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M134.16,491.44c5.05-0.33,12.56-2.32,18.78-3.38c-1.7-5.66-5.98-19.98-2.83-24.54 c-0.14,0.09,8.48-6.03,15.08-3.83c-0.48-0.01,4.59,0.49,6.95,0.75c4.33,0.48,7.31-3.2,7.86-7.68c0.67-5.47-1.1-6.66,0.85-8.72 c0.69-0.73,1.49-1.48,1.74-2.33c-0.06,0.11-0.12,0.23-0.19,0.34c0,0-1.82-6.28-1.55-6.61c1.55-1.88,2.44-3.4,2.64-3.76 c-0.13-0.22-0.3-0.45-0.5-0.69c-1.49-1.8-1.45-3.97-1.18-5.33c0.57-2.96,3.6-3.61,5-3.67c0.03,0,0.08-0.02,0.11-0.04 c1.61-1.15,1.37-2.7-1.56-6.61c-2.81-3.75-5.66-8.52-6.32-9.65c-0.09-0.16-0.11-0.35-0.05-0.52l-0.05-2.91l1.84-2.02l0,0 c-0.88-2.04-2.46-4.16-2.05-5.37c0.08-0.25,0.14-0.53,0.17-0.83c-0.01,0.03-0.01,0.05-0.01,0.05c-0.33-0.33-0.68-0.65-1.09-0.85 c0,0,0,0-0.01,0c-0.62,0.56-1.06,0.86-1.17,0.93c-0.01,0.01-0.03,0.01-0.04-0.01c-0.08-0.1-0.45-0.49-1.27-0.51c0,0,0,0,0,0 c-0.33,0.23-0.69,0.53-1.09,0.93c0,0,0.15-0.36,0.42-0.86c-0.5,0.1-1.12,0.33-1.87,0.77c-2.25,1.3-5.77,1.78-8.45,2 c-0.67,0.06-1.29,0.09-1.82,0.13c-0.17,0.04-0.34,0.07-0.61,0.09c-0.04,0-0.09,0.01-0.14,0.02c-0.06,0.02-0.11,0.03-0.17,0.05 c-0.01,0-0.01,0-0.02,0.01c-0.01,0-0.02,0.01-0.03,0.01c-0.37,0.14-0.78,0.43-0.89,0.74c-0.69,1.18-1.96,3.52-2.96,6.13 c-0.46,1.25-0.84,2.54-1.06,3.79c-0.2,1.12-0.55,2.1-0.99,2.96c-0.04,0.09-0.09,0.18-0.13,0.26c-0.05,0.08-0.09,0.17-0.14,0.25 c-1.75,3.16-4.74,4.77-4.74,4.77l0-10.92c-0.89,0.6-1.77,1.15-2.61,1.59c0,0,0.07-0.17,0.17-0.42c0,0-0.01,0-0.01,0.01 c0,0,0.05-0.11,0.12-0.28c0.23-0.63,0.47-1.45,0.19-1.45c-0.21,0-0.78,0.49-1.53,1.19c-0.24,0.22-2.22,2.07-2.5,2.33 c-0.24,0.21-0.47,0.42-0.71,0.62c0,0,0.12-0.2,0.23-0.48c-0.03,0.02,0.03-0.12,0.14-0.37c0.08-0.26,0.13-0.53,0.09-0.73 c-0.2-0.1-0.25-0.24-0.46-0.29c-0.15-0.03-0.46,0.03-0.61,0.03c-0.28,0.09-0.63,0.24-1.07,0.46c-0.21,0.11-0.4,0.2-0.57,0.27 c-0.03,0.02-0.05,0.04-0.08,0.06c-0.54,0.47-1.32-0.19-0.93-0.78c0.01-0.01,0.02-0.03,0.03-0.04c0.03-0.05,0.06-0.1,0.07-0.17 c0.33-1.27,1.26-3.46,1.01-5.46c0,0-1.9,0.23-3.89,5.43c-1.99,5.2-6.34,25.54-10.56,35.52c-2.5,5.91-8.99,11.79-24.14,9.44 c0,0,0,0,0,0c-0.36,14.69-7.47,22.8-10.61,25.68C94.73,479.31,104.83,491.96,134.16,491.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M185.75,422.6c0.07-0.03,0.14-0.07,0.21-0.1c-0.38,0.17-0.74,0.33-1.05,0.49 C185.17,422.86,185.45,422.74,185.75,422.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M150.91,436.5c0-0.14-0.01-0.22-0.01-0.22S150.9,436.36,150.91,436.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M182.19,401.3l0.14,0.1C182.34,401.4,182.29,401.35,182.19,401.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M215.48,609.99c0.05-0.07,0.1-0.15,0.15-0.23c-1.22-0.43-2.47-0.91-3.75-1.46 C214.18,609.4,215.48,609.99,215.48,609.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M198.22,601.56c-4.64-2.47-9.9-5.35-16.09-8.59C188.01,596.23,193.48,599.12,198.22,601.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M51.45,720.97c0.46,0.43,0.94,0.86,1.43,1.27c-0.47-0.57-0.9-1.15-1.3-1.76 C51.49,720.81,51.45,720.97,51.45,720.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M63.72,612.31c0.06,0.31,0.11,0.63,0.16,0.94c-2.03-15.08-4.91-26.42-7.47-38.16 C58.71,587.05,61.36,599.61,63.72,612.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M64.88,621.76c2.11,29.39-6.84,71.77-11.19,90.15C58.24,694.09,67.84,651.66,64.88,621.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M51.4,543.74c-0.45-5.12-0.75-10.67-0.87-16.81C50.44,532.15,50.77,537.78,51.4,543.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M111.12,738.81c15.63,0.62,31.54-0.35,45.02-1.76C143.93,738.2,127.49,739.25,111.12,738.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M164.85,623.77c2.45,24.89,8.22,40.42,7.42,57.75c-1.21,26.06-10.23,30.87-0.81,53.83 c9.64-1.46,19.88-3.51,19.88-3.51s-18.01-62.53-14.67-141.76c-0.83-0.48-1.62-0.98-2.35-1.48 C174.31,588.6,161.38,588.56,164.85,623.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M216.65,610.11c-0.14-0.05-0.28-0.09-0.43-0.14C216.36,610.02,216.5,610.07,216.65,610.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M309.8,526.06c-0.24-0.66-0.5-1.33-0.8-1.99c-0.15-0.34-0.35-0.57-0.58-0.69 c-3.24-1.65-17.41,13.27-35.22,34.35c-19.12,22.64-25.06,6.57-28.08,3.56c-3.02-3.02-8.25-4.34-7.75-2.83 c0.5,1.51-6.47-2.8-6.47,3.74c0,6.54-5.75-3.46-5.75-3.46s0.79,16.32-12.58,6.66c-10.42-7.53-19.97-26.78-19.97-26.78 c-7.69-16.59-30.7-52.79-52.31-51.64c-1.97,0.1-3.87,0.17-5.69,0.2c-29.32,0.51-39.87-7.86-42.25-10.22 c-0.39-0.38-0.56-0.61-0.56-0.61c-22.7,5.88-41.6,23.59-41.29,48.69c0.01,0.64,0.02,1.27,0.03,1.89 c0.12,6.14,0.42,11.69,0.87,16.81c1.06,12.16,2.93,21.88,5,31.35c2.57,11.73,5.44,23.08,7.47,38.16 c0.35,2.56,0.67,5.23,0.96,8.03c0.02,0.16,0.04,0.32,0.04,0.48c1.26,34.36-7.19,72.62-11.19,90.15 c-1.21,5.3-2.24,8.39-2.24,8.39c0.04,0.06,0.09,0.13,0.13,0.19c0.4,0.6,0.83,1.19,1.3,1.76c9.79,11.93,33.93,15.9,58.24,16.56 c16.37,0.44,32.82-0.61,45.02-1.76c11.78-1.11,19.61-2.29,19.61-2.29c-0.03-0.07-0.05-0.13-0.08-0.2 c-9.42-22.96-1.08-27.15,0.13-53.21c0.81-17.32-4.59-33.09-7.04-57.98c-3.47-35.22,5.56-34.77,5.56-34.77 c0.74,0.51,1.52,1,2.35,1.48c0.59,0.35,1.21,0.69,1.86,1.02c1.24,0.64,2.44,1.26,3.61,1.87c6.19,3.24,11.45,6.11,16.09,8.59 c5.2,2.77,9.61,5.04,13.65,6.75c1.28,0.54,2.53,1.03,3.75,1.46c0.2,0.07,0.4,0.14,0.6,0.21c0.14,0.05,0.28,0.1,0.43,0.14 c8.37,2.74,15.8,2.67,26.72-0.79c16.76-5.31,29.25-23.03,44.19-36.27c16.3-14.45,22.54-22.16,22.54-22.16s1.32-3.57,1.75-8.89 c0,0,0-0.01,0-0.01C312.21,537.55,311.94,531.9,309.8,526.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M211.47,543.42c0.84-4.33,5.22-11.25,6.75-15.74c2.49-7.3,6.58-14.54,9.41-20.48 c2.69-5.66,3.81-10.59,4.27-13.36c0.25-1.5-1-1.68-1-1.68c-0.48-0.57,0.42-1.8,0.07-2.31c-0.9-1.31-1.49-2.39-2.35-3.13 c-0.03-0.02-2.29,0.83-2.32,0.81c-1.24-1.05-2.03-1.56-2.03-1.56c-3.95,2.13-10.75,7.32-17.38,12.68 c-9.4,7.6-18.43,15.54-18.43,15.54c0.04,0.04-0.04,1.49,0,1.53c0.99,1,1.5,2.28,2.83,3.77c3.82,4.26,7.94,12.29,11.79,16.96 C206.8,540.92,211.47,543.42,211.47,543.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0948F",
    d: "M134.6,487.17c1.84-0.12,3.74-0.28,5.73-0.49c-1.2-12.76,4.07-19.59,9.75-23.11 c2.48-1.53,5.04-2.44,7.17-2.93c3.4-0.78,5.56-0.97,7.46-0.91c0.19,0.01,0.38,0.01,0.57,0.02c2.04,0.11,3.89,0.49,6.86,0.69 c1.97,0.14,3.41-0.51,4.29-1.08c0.64-0.42,0.98-0.8,0.98-0.8c-0.03,0.01-0.05,0.02-0.08,0.04c-9.56,4.54-5.69-14.48-6.17-24.99 c-0.43-9.55-1.6-12.57-3.99-18.81c-2.37-6.2-5.89-13.92-3.89-18.24c-0.29,0.02-0.56,0.04-0.81,0.05 c-0.17,0.04-0.34,0.07-0.61,0.09c-0.04,0-0.09,0.01-0.14,0.02c-0.06,0.02-0.11,0.03-0.17,0.05c-0.01,0-0.01,0-0.02,0.01 c-0.01,0-0.02,0.01-0.03,0.01c-0.37,0.14-0.78,0.43-0.89,0.74c-0.69,1.18-1.96,3.52-2.96,6.13c-0.46,1.25-0.84,2.54-1.06,3.79 c-0.2,1.12-0.55,2.1-0.99,2.96c-0.04,0.09-0.09,0.18-0.13,0.26c-0.05,0.08-0.09,0.17-0.14,0.25c-1.75,3.16-4.74,4.77-4.74,4.77 l0-10.92c-0.89,0.6-1.77,1.15-2.61,1.59c0,0,0.07-0.17,0.17-0.42c0,0-0.01,0-0.01,0.01c0,0,0.05-0.11,0.12-0.28 c0.23-0.63,0.47-1.45,0.19-1.45c-0.46,0-2.75,2.45-4.74,4.13c0,0,0.12-0.2,0.23-0.48c-0.03,0.02-0.05,0.05-0.08,0.07 c0,0,0.11-0.19,0.22-0.44c0.25-0.8,0.2-1.7-2.06-0.52c-3.52,1.84,0-2.45-0.46-6.12c0,0-1.9,0.23-3.89,5.43 c-1.99,5.2-6.34,25.54-10.56,35.52c-2.51,5.94-9.04,11.85-24.33,9.42c0.05,1.17,0.11,2.3-0.02,3.39 c-0.88,7.51-3.95,14.67-7.04,18.6c-1.28,1.64-2.49,2.87-3.38,3.7C94.67,479.27,105.2,487.69,134.6,487.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5B51",
    d: "M372.17,500.47c-0.27,1.01-1.59,2.16-1.59,2.16s-1.28-0.4-0.76-1.43c0.57-1.11,1.08-1.5,1.08-1.5 s-1.89,1.43-1.48,2.41c0.41,0.98,0.76,0.84,0.76,0.84s-0.86,1.26-2.15,2.1c-1.29,0.85-1.61,0.5-1.61,0.5s-0.36,0.95-2.94,2.69 c-1.45,0.98-2.25,1.55-3.07,2.01c-0.46,0.15-0.73-0.29-0.73-0.29s0.21,0.55-0.44,0.85c0,0-0.16,0.09-1.12,0.43 c-2.27,0.79-7.81,2.57-10.39,3.33c-1.42,0.42-2.01,0.19-2.21,0.04c0.02,0.03,0.04,0.07,0.05,0.13c0.03,0.09,0.08,0.19,0.14,0.32 c0.36,0.36,0.76,0.82,1.2,1.38c-0.16-0.6-0.21-1.15,0.12-1.21c0.74-0.13,6.66-2.02,9.46-2.91c2.8-0.89,3.75-1.04,4.68-1.93 c0.93-0.88,5.04-3.34,6.34-4.34c1.3-1,2.57-2.11,3.56-3.14C372.07,501.86,372.35,499.78,372.17,500.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5B51",
    d: "M373.57,501.81c0,0-0.03,1.47-1.07,2.76c-0.54,0.67-0.97,1.02-1.27,1.19c-0.2-0.17-0.66-0.67-0.28-1.43 c0.48-0.95,1.7-2.72,1.7-2.72s-1.33,1.85-1.98,2.72c-0.63,0.83,0,1.11,0.03,1.89c-0.19,0.45-0.66,1.51-1.69,3.42 c-0.1,0.19-0.21,0.36-0.32,0.53c-0.46,0.31-0.75-0.37-0.8-0.03c-0.04,0.3-0.04,0.77-0.1,1.22c-1.03,1.16-2.25,2.01-3.42,3.06 c-0.22,0.2-0.45,0.39-0.68,0.57c-0.27,0.13-0.44,0.04-0.54-0.1c0.04,0.18,0.06,0.37-0.01,0.52c-1.38,1.01-2.85,1.78-4.02,2.25 c-1.53,0.62-4.36,1.77-6.5,2.83c-1.58,0.78-2.65,0.44-3.1,0.21c0.2,0.4,0.4,0.83,0.59,1.28l0.41,0.7c0,0,0.01-0.56,3.81-2.39 c3.8-1.83,5.15-2.37,7.54-3.57c2.38-1.2,5.5-4.29,6.37-5.6c0.87-1.31,1.98-3.43,2.41-4.23c0.42-0.8,1.95-2.1,1.95-2.1 s0-0.01,0.01-0.01c0.01-0.01,0.03-0.05,0.07-0.11C372.93,504.25,373.75,502.79,373.57,501.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#341A0D",
    d: "M98.59,735.53c30.61-1.46,40.84-9.12,4.15-14.78c-52.26-8.06-36.96-13.03-20.19-20.69 c17.05-7.8-13.05-4.63-2.43-34.99c6.51-18.59-2.54-39.08-10.2-59.28c-4.99-13.15-9.66-26.1-13.28-37.14 c-3.66-21.03-6.47-46.81,2.74-62.91c11.45-20.01,22.05-22.87,32.41-29.4c0,0-2.21,0.37-5.8,1.8 c-6.64,2.64-18.03,8.89-29.05,23.16c-0.35,0.45-0.68,0.94-1,1.44c-1.34,2.12-2.4,4.62-3.2,7.43 c-1.58,5.54-2.18,12.26-2.14,19.48c0.02,3.53,0.2,7.18,0.49,10.86c0.18,2.22,0.39,4.46,0.65,6.69 c0.38,3.38,0.45,7.35,2.15,15.27c0.13,0.6,0.26,1.21,0.39,1.83c0.52,2.87,1.06,5.65,1.6,8.3c0.23,1.13,0.46,2.23,0.69,3.3 c0.29,1.35,0.58,2.66,0.86,3.92c0.56,2.89,1.09,5.9,1.68,8.94c4.61,23.53,5.42,34.67,5.7,46.67 c0.63,27.47-13.36,85.52-13.36,85.52s1.8,3.54,6.1,5.65C65.76,730.66,80.75,736.38,98.59,735.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B5743",
    d: "M174.31,588.6L174.31,588.6L174.31,588.6c0,0-9.03-0.45-5.56,34.77c2.45,24.89,7.85,40.66,7.04,57.98 c-1.08,23.1-7.75,29.02-2.69,46.06c0.14,0.35,0.21,0.55,0.21,0.55s7.43-26.44,0.17-90.68 C169.54,602.32,175.07,592.65,174.31,588.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5B51",
    d: "M371.89,509.33c-0.17-0.27-0.59-1.02-0.35-1.46c0.3-0.54,1.58-1.8,1.58-1.8 c-0.57,0.53-1.34,1.08-1.73,1.62c-0.12,0.18-0.2,0.55-0.16,0.71c0.13,0.52,0.38,0.96,0.47,1.12c-1.03,1.1-1.59,2-3.07,3.65 c-0.34,0.38-0.74,0.81-1.17,1.29c-2.02,2.19-4.77,5.12-5.47,5.89c-0.85,0.93-10.25,6.02-10.25,6.02l0,0 c0,0,8.94-4.32,10.76-5.59c0.92-0.64,5.79-6.46,6.87-8.12l0.85-1.04c-0.46,0.65-0.7,1.22-0.46,1.58 c0.23,0.34,0.42,0.52,0.5,0.58c0,0,0,0,0,0c0.02,0.02,0.04,0.03,0.04,0.03l0.09-0.22c0,0,0,0-0.01,0c0,0,0,0,0,0 c-0.05-0.03-0.48-0.3-0.41-0.89c0.07-0.51,0.38-1.17,0.5-1.4l1.98-2.44l0.26-0.32l0,0c0,0,0,0,0,0 c-0.01,0.01-0.02,0.02-0.03,0.03C372.39,508.83,372.13,509.09,371.89,509.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M177.95,403.04c-0.3,0.35-0.54,0.62-0.73,0.83c-0.58,0.56-0.86,0.79-1.48,1.61 c-0.46,0.61,0.63-0.58,1.32-0.92c0.15,0.03,0.35,0.07,0.61,0.13c0.75,0.17,1.02,0.41,1.13,0.58c0.03,0.05,0.05,0.09,0.05,0.12 c0.01,0.03,0.01,0.06,0.01,0.06s0.01-0.01,0.01-0.02c0.06-0.09,0.71-1.13,0.56-3.13l0.63-0.99c1.07-0.53,1.82-0.2,2.12-0.02 l-1.44-1.05l0,0C180.75,400.25,179.38,401.4,177.95,403.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M175.42,406.11c-0.13,0.77-1.92,2.18-1.92,2.18C175.1,407.71,175.31,407.35,175.42,406.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M174.46,406.11c0,0-0.96,0.64-1.73,0.58C172.73,406.69,173.76,407.65,174.46,406.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M183.53,422.29c-2.02,0.36-1.88-0.58-2.38-2.24c-0.51-1.66-1.37-5.56-1.59-5.56 c-0.21,0,1.51,5.32,2.29,10.45c0.02,0.11,0.03,0.23,0.05,0.34c0,0,0-0.88,2.99-2.36c0.31-0.16,0.67-0.32,1.05-0.49 c0.16-0.07,0.31-0.14,0.48-0.21c0.28-0.12,0.37-0.19,0.32-0.24C186.6,421.84,185.07,422.02,183.53,422.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M180.17,436.27c-0.36-0.31,1.24-5.08,0.82-4.04c-0.9,2.2-2.71,6.15-3.02,7.32 c-0.32,1.18,0.46-1.84,1.54-2.05c2.24,0.74,2.88,4.54,2.88,4.54c0.08-0.11,0.14-0.22,0.19-0.34c0.91-1.82-0.91-4.27-1.63-5.13 c0.38-0.26,0.81-0.58,1.25-0.97c1.52-1.37,2.25-2.61,1.32-4.01c0,0-0.02,0.03-0.05,0.08c-0.2,0.36-1.08,1.88-2.64,3.76 C180.57,435.76,180.35,436.03,180.17,436.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M165.18,459.7c-6.59-2.2-9.89-5.27-12.08-12.3c-1.91-6.1-2.16-9.97-2.19-10.89 c0.05,2.13,0.43,19.54-1.01,27.17c0,0,0.07-0.05,0.21-0.14c1.05-0.69,6.05-3.65,13.66-3.83 C164.23,459.69,164.7,459.68,165.18,459.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M148.9,421.73c-1.22-2.3-0.41-2.85,0.16-4.1c0.58-1.25-0.05-1.56-0.05-1.56c-1.2,1.9-2.87,1.32-3.64,2.23 c-0.77,0.91,1.39,4.33,2.52,5.67C149.03,425.32,150.11,424.03,148.9,421.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M147.4,407.08c-0.23-0.38-0.54-0.83-0.94-1.25c-0.15,0.14-2.4-1.61-2.4-1.61s-1.63,0.8-1.67,0.81 c-0.04,0.01-1.21,1.39-1.21,1.39s-0.76,0.36-0.67,0c-0.9,1.3-1.28,3.09-1.64,4.5c0,0,1.06-2.41,2.57-3.66 c-0.17,0.07,1.64-1.05,1.64-1.05s0.18,0.26,0,0.32c0.15-0.01,0.3,0,0.45,0.03c0.22,0.04,0.43,0.12,0.62,0.22 c-0.02-0.08,0.81,0,0.81,0l0.31,0.16c-0.13,0.12-0.26,0.25-0.4,0.37c0.95,0.94,1.29,2.58,0.07,4.06c-1.7,2.07-2.3,2.96-2.68,4.55 c-0.38,1.59,0.77,3.06,0.77,3.06s0.24-1.22,0.62-2.7c0.39-1.47,2.17,0.54,3.89-1.29C149.28,413.17,148.09,408.22,147.4,407.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M146.19,427.97c0,0-6.09-6.57-6.58-12.3C139.61,415.67,140.3,425.82,146.19,427.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M127.1,441.82c4.22-9.98,8.57-30.32,10.56-35.52c1.99-5.2,3.89-5.43,3.89-5.43 c0.26,2.05-0.73,4.29-1.03,5.55c-0.21,0.86-0.1,1.26,0.93,0.84c0.16-0.07,0.35-0.16,0.57-0.27c0.43-0.23,0.78-0.37,1.07-0.46 c0.72-0.22,1.01-0.06,1.08,0.25c0.05,0.21,0,0.48-0.09,0.73c-0.04,0.13-0.09,0.26-0.14,0.37c-0.12,0.28-0.23,0.48-0.23,0.48 c0.39-0.33,0.79-0.69,1.19-1.06c0.55-0.51,1.09-1.02,1.58-1.48c0.96-0.9,1.72-1.59,1.97-1.59c0.28,0,0.04,0.82-0.19,1.45 c-0.04,0.1-0.07,0.19-0.1,0.28c-0.09,0.25-0.17,0.42-0.17,0.42c0.84-0.43,1.72-0.98,2.61-1.59l0,10.92c0,0,2.99-1.61,4.74-4.77 c0.05-0.08,0.09-0.16,0.14-0.25c0.05-0.09,0.09-0.17,0.13-0.26c0.37-0.77,0.67-1.62,0.83-2.55c0.24-1.39,0.69-2.84,1.22-4.21 c1-2.61,2.28-4.95,2.96-6.13c0.12-0.3,0.53-0.59,0.89-0.74c0.01,0,0.02-0.01,0.03-0.01c0.01,0,0.01,0,0.02-0.01 c0.06-0.02,0.12-0.04,0.17-0.05c0.05-0.01,0.1-0.02,0.14-0.02c0.27-0.02,0.43-0.05,0.61-0.09c0.2-0.04,0.42-0.09,0.84-0.13 c0.06-0.11,0.12-0.23,0.18-0.34c3.41-19.76,0.59-27.24,0.59-27.24c3.08,6.43,2.38,16.67,1.75,21.88 c6.15-17.57-2.54-33.6-2.54-33.6c9.57,13.76,4.19,34.86,4.19,34.86c10.02-27.83-10.17-43.39-10.17-43.39 c12.57,8.23,15.56,24.68,15.56,24.68c-1.21-21.35-19.77-29.92-23.56-31.46c-18.69-3.11-37.9,1.88-37.9,1.88s-3.08,0.25-6.21,2.02 l0.38-0.53l0.23-0.32c0,0-12.84,4.47-22.88,15.07c0,0,5.15-4.17,11.42-7.31c0.66-0.33,1.33-0.65,2.01-0.95 c-6.57,4.07-14.85,9.58-20.41,21.45c-2.43,5.2-3.48,9.8-3.69,13.75c0,0.01,0,0.02,0,0.03c0,0.08,0,0.16-0.01,0.24 c-0.13,2.93,0.2,5.5,0.76,7.69c1.52,7.03,5.55,16.14,13.43,26.34c0,0-3.59-6.3-5.84-13.68c-0.01-0.02-0.01-0.05-0.02-0.07 c0.21,0.29,0.42,0.57,0.63,0.85c1.58,2.16,2.86,4.02,2.86,4.02s1.98,2.58,6.72,9.46c4.74,6.88,7.91,12.7,7.91,12.7 c4.53,9.49,3.95,16.69,4.03,16.7c0.08,0.01,0.16,0.02,0.24,0.04C118.11,453.62,124.6,447.74,127.1,441.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M163.32,396.5c0,0,7.57-0.11,11.3-2.76c3.73-2.65,4.92-6.64,4.92-6.64l1.7-21.3c0,0-6.17-9.48-6.78-11.31 c-0.61-1.82-4.87-4.98-4.87-4.98l-12.05-4.86L163.32,396.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M111.42,343.77c0,0,19.22-4.98,37.9-1.88c3.79,1.53,22.35,10.11,23.56,31.46c0,0-2.99-16.46-15.56-24.68 c0,0,20.2,15.56,10.17,43.39c0,0,5.39-21.09-4.19-34.86c0,0,8.68,16.03,2.54,33.6c0.63-5.21,1.33-15.45-1.75-21.88 c0,0,2.81,7.48-0.59,27.24c-0.06,0.11-0.12,0.23-0.18,0.34c-0.43,0.03-0.64,0.08-0.84,0.13c0.53-0.03,1.15-0.07,1.82-0.13 c2.69-0.22,6.27-0.8,8.65-1.83c1.11-0.48,1.14-0.58,1.67-0.93c-0.26,0.49-0.42,0.86-0.42,0.86c0.39-0.39,0.75-0.69,1.09-0.93 c0.93,0.01,1.28,0.53,1.28,0.53s0.48-0.3,1.19-0.94c0.41,0.2,0.76,0.52,1.09,0.85c0,0,0.01-0.02,0.01-0.05 c0.05-0.22,0.26-1.17,0.05-1.96c2.72-3,6.56-9.39,4.4-20.27c-0.98-4.95-2.63-9.15-4.77-12.71c5.43,6.66,6.1,12.93,6.18,14.37 c-0.62-20.51-20.78-27.99-25.12-29.37c-3.28-1.2-6.7-2.05-10.14-2.62c-18.69-3.11-37.9,1.88-37.9,1.88s-2.94,0.24-5.99,1.9 l-0.38,0.53C108.33,344.02,111.42,343.77,111.42,343.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M253.6,454.32c-0.91,0.05-1.42-0.41-1.42-1.52c-0.48,0.9-2.47,4.35-2.71,4.77c0,0,0,0,0,0 c-0.02,0.03-0.02,0.04-0.02,0.04c0.06-0.01,0.12-0.02,0.18-0.02c2.16-0.22,3.37-0.91,3.37-0.91c4.41,1.65,5.14-0.53,5.25-1.04 c0.01-0.06,0.02-0.11,0.02-0.11C257.2,456.19,254.51,454.26,253.6,454.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M246.76,480.35c0.05,0.73,1.53-0.95,2.92-1.45c-0.49,0.11-1.07,0.28-1.45,0.49 c-1.01,0.56,0.25-0.81,0.91-1.17c0.66-0.35-1.01,0.66-1.72-0.2c-0.37-0.45-0.7-0.96-0.93-1.34c-0.21-0.34-0.33-0.58-0.33-0.58 c0.01,0.02,0.01,0.04,0.02,0.07C246.76,477.63,246.71,479.56,246.76,480.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M140.29,486.97c21.61-1.14,41.69,36.11,49.38,52.7c0,0,11.75,20.73,22.17,28.26 c13.37,9.67,13.58-7.36,13.58-7.36s4.02,3.52,4.53,10.06c0.5,6.54,0,10.56,0,10.56s2.52-11.07,2.52-17.61 c0-6.54,2.52-2.01,3.02,4.02c0.5,6.04,2.52-6.04,2.01-7.55c-0.5-1.51,3.02,0,6.04,3.02c3.02,3.02,13.5,20.56,32.61-2.08 c17.81-21.09,29.04-39.28,32.27-37.63c-0.85-1.86-1.84-3.03-2.81-3.79c-0.15-0.12-0.31-0.23-0.46-0.33 c-3.93-2.58-9.81,1.24-12.09,2.68c-41.81,26.38-58.98,34.21-61.94,35.49c-2.21-0.31-7.39-2.46-16.96-13.53 c13.84-20.15,24.73-41.52,24.73-41.52c-0.21-0.58-0.49-1.17-0.81-1.77c0.46-0.68,0.89-1.31,1.17-1.66 c0.6-0.75,2.21-2.15,3.52-3.19c0.45-0.36,1.51-1.1,1.84-1.34c1.27-0.91,4.57-2.51,5.59-3.17c0.34-0.22,0.68-0.44,1.03-0.66 c0.69-0.43,1.39-0.88,2.17-1.42c0.16-0.11,0.35-0.23,0.54-0.35c0.8-0.5,1.79-1.03,2.58-1.5c0.38-0.23,0.71-0.44,0.93-0.62 c0.74-0.6,1.64-1.83,2.64-3.22c0.1-0.14,0.2-0.28,0.3-0.43c1.11-1.57,3.85-4.31,4.76-5.42c0.01-0.01,0.02-0.02,0.03-0.04 c0.88-1.09,0.99-1.76,1.29-4.12c0.25-1.96,1.11-4.32,1.41-5.1c0.07-0.17,0.11-0.27,0.11-0.27l-1.37,2.84 c-0.51-0.35-0.86-0.71-0.61-1.57c0.25-0.86,0.76-1.87,1.47-2.43c0,0-1.52,1.22-1.82,2.53c-0.3,1.32,0.96,1.47,0.71,2.38 c-0.25,0.91-0.51,3.9-1.27,4.36c-0.76,0.46-1.67,2.13-4.81,5.07c-3.14,2.94-2.74,4.1-6.59,6.03c-3.85,1.93-11.35,5.93-16.41,8.76 c-0.62,0.35-1.16,0.66-1.63,0.94c-1.48-1.87-3.23-3.71-4.9-5.34c1.52-1.26,3.53-2.64,5.9-3.52c5.32-1.98,7.13-4.51,5-8.84 c-2.13-4.33,0.3-8.43,1.75-15.35c1.44-6.92,1.44-10.71,5.17-14.82c0,0,2.43-3.43,2.92-3.91s2.31,0.79,4.53-2.16 c0.14-0.19-2.77,2.65-4.26,1.34c0,0-4.56,3.98-6.61,6.03c-0.28,0.28-0.53,0.52-0.76,0.75c-1.46,1.4-2.01,1.78-2.73,3.36 c0,0,0.17-1.57,0.6-2.35c0.04-0.07,0.08-0.13,0.12-0.19c-0.07,0.08-0.18,0.2-0.31,0.35c-0.63,0.73-1.87,2.28-3.15,4.47 c-0.53,0.91-1.07,1.71-1.63,2.45c-1.36,1.8-2.83,3.2-4.6,4.54c-2.51,1.9-3.04,2.13-3.04,6.54c0,4.41-1.05,12.22-2.01,14.73 c-0.35,0.92-0.81,1.79-1.25,2.52c1.2,1.02,2.8,2.53,4.52,4.56c0,0-15.57,26.89-19.78,48.59c0,0-16-19.86-22.55-26.45 c-0.07,0.06-0.15,0.13-0.22,0.19c-20.96-21.18-35.89-29.51-35.89-29.51c-0.33,0.06-0.65,0.11-0.98,0.17 c-6.22,1.06-11.83,1.71-16.88,2.04C136.43,487.14,138.32,487.07,140.29,486.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M344.71,494.05c-2.83,1.37-4.34-1.17-4.34-1.17s0.56,2.81-1.45,4.07c-2.02,1.26-4.02,3.69-5,5.93 c-0.98,2.24-1.53,2.31-4.35,2.34c-0.61,0.01-1.08,0-1.43-0.02c0.23,0.03,0.51,0.07,0.85,0.13c2.17,0.37-0.96,0.75-3.08,1.67 c1.1-0.38,8.72-1.66,8.72-1.66s0.01-0.08,0.04-0.19c0.03-0.12,0.08-0.29,0.15-0.49c0.13-0.35,0.35-0.79,0.71-1.26 c0.15-0.19,0.32-0.39,0.52-0.58c0.3-0.28,0.69-0.57,1.15-0.86c1.5-0.96,3.69-2.02,5.48-3.31c0.56-0.41,1.04-0.76,1.47-1.09 c1.34-1.03,2.11-1.8,2.97-3.13c1.12-1.74,1.75-3.14,0.57-4.35c-0.01-0.01-0.01-0.02-0.02-0.02 C347.44,490.84,347.54,492.69,344.71,494.05z"
  })))), /*#__PURE__*/React.createElement("g", null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1651.11,
    fill: "#1EBDE4",
    width: 269.84,
    height: 504.49
  })), /*#__PURE__*/React.createElement("g", {
    id: "landscape"
  }, /*#__PURE__*/React.createElement("g", null, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M1704.87,419.97c-13.26-1.47-15-11.45-28.22-8.49c-10.49,2.35-15.32-5.28-24.38,0.05 c-1.53,0.9-2.69,1.98-3.29,2.59c2.01,0.67,3.13,1.95,3.67,2.77c2.41-0.4,4.51,0.36,4.51,0.36c2.12-2.23,5.13-2.01,5.13-2.01 c-4.13,0.67-5.02,3.23-5.02,3.23c-5.57-2.56-9.81,2.12-9.81,2.12c1.27-2.23,3.03-3.22,4.7-3.61c-3.34-2.34-7.3-3.53-12.91-2.03 c-2.35,0.79-5.36,2.14-9.34,4.35c-6.61,3.67-25.51,5.69-39.41,6.07l134.03-1.93C1724.52,423.45,1725.3,422.24,1704.87,419.97z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M1932.42,300.21c-4.26-6.26-13.4-13.71-23.8-9c-1.99,0.98-4.2,2.39-6.53,4.41 c0.18,0.04,0.36,0.09,0.54,0.15c2.87,0.9,4.22,2.85,4.22,2.85s8.94-0.72,11.74,6.87c0,0-4.5-7.11-12.28-5.72 c0,0-3.45-5.58-12.6-2.44c0,0,3.79-2.68,8.1-1.78c0.81-1.1,2.62-3.22,5.64-5.12c-4.96-6.41-10.83-8.35-15.01-9.01 c-11.31-1.78-23.42,2.04-33.31,7.87c-19.79,11.69-37.62,12.78-58.78,19.18l159.73-2.14 C1944.72,306.07,1938.42,296.56,1932.42,300.21z"
  })), /*#__PURE__*/React.createElement("g", null, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED4D3",
    d: "M1728.21,467.48c0.32,0.14,1.6,0.25,1.95,0.26c0.8,0.01,0.46,1.63,1.23,1.85c4,1.11,4.02,3.84,3.62,6.7 c1.09-0.66,3.21-0.47,4.08,0.46c0.87,0.94,1.63,2.79,1.82,4.06c-0.14-0.85,0.72-1.94,1.57-2.13s1.56,0.56,1.8,1.39 c1.15-1.01,2.62-0.17,2.57,1.36c0.98-0.21,1.8,0.13,2.26,1.03c0.48,0.94,0.66,2.64,0.8,3.64c1.97-0.32,3.85-0.65,4.98,1.13 c0.24,0.38,0.87,1.31,1.03,1.72c0.5-0.52,1.16-0.81,1.87-0.77c1.03,0.05,1.98,1.59,1.51,2.52c0.47-0.4,1.44-1.3,2.05-1.36 c0.61-0.06,0.88,0.37,0.8,0.98c0.18-0.56,1.2-0.43,1.67-0.08c0.52,0.39,1.09,1.25,1.62,1.64c1.47-1.94,3.12-2.96,5.34-1.98 c2.3,1.02,2.24,2.95,3,5.39c0.36-0.48,0.39-1.68,0.9-1.36c0.39,0.24-0.02,0.95,0.18,1.36c0.61,1.24,3.38-0.8,3.75,2.57 c0.21-0.02,1.17-0.16,1.39-0.18c1.22-0.03,2.44,1.15,2.93,1.62c0.89-2.6,4.38-5,7.05-5.68c-0.54-2.72-0.44-5.69,1.78-7.35 c2.22-1.66,4.32-0.8,6.77,0.48c1.26-2.47,5.46-3.81,7.81-2.33c1.23-3.71,4.64-6.93,8.47-7.73s6.4,1.55,9.02,4.45 c1.06,1.18,2.43,1.94,3.9,2.53c0.73,0.3,1.24,1.13,2.02,1.3c1.8,0.41,1.93,1.95,2.87,3.54c0.34,0.56,2.27-1.17,2.76-0.74 c0.12,0.1,2.44,2.11,2.57,2.19c2.32-6.37,8.48-7.32,9.1-8.56c0.65-1.29,1.44-3.06,1.84-4.45c1.45-4.99,5.97-6.35,11.1-7.46 c5.12-1.11,6.84-0.71,10.27,3.22c0.56,0.65,2.35,1.06,3.15,1.3c2.61-1.58,6.34-1.3,9.38-0.66c0.93,0.19,1.24,0.37,2.12,0.73 c1.25,0.46,1.89-0.04,2.94,0.77c0.43,0.33,0.12,1.57,0.55,1.97c0.87,0.78-0.66,0.06,0.07,0.96 c-11.37,5.83-22.72,17.66-22.72,17.66c10.81-7.39,24.72-10.72,30.12-12.87c1.97-0.73,5.1-1.97,7.26-2.67 c20.41-6.6,39.32-9.49,55.99-7.39c-39.49-31.29-61.15-62.08-26.63-82.75c50.17-30.03-27.22-51.13-23.24-53.76 c-15.86,2.08-30.41,13.25-52.56,32c-46.64,39.49-86.38,78.25-128.3,97.44c0.02,0.02-1.05,0.85-1.03,0.88 C1727.71,466.66,1727.73,467.28,1728.21,467.48z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#97B9B8",
    d: "M1673.6,452.24c12.92,0.91,19,11.35-0.97,23.56c-19.97,12.2-24.03,19.52-9.24,26.18 c14.79,6.66,4.67,14.42,7.39,20.84c2.06,4.87,16.96,10.79,25.51,11.81c1.94,0,4.3-1.8,6.21-1.8c2.79-0.7,5.2-1.17,7.19-1.75 c0.08-0.09,0.9-0.4,0.99-0.48c0.57-0.49,1.15-0.89,1.75-1.35c0.58-0.45,0.32-1.02,1.06-0.98c0.39,0.03,1.1,0.55,1.46,0.4 c0.38-0.17,1.06-0.99,1.21-1.38c0.45-1.13,1.24-1.27,2.4-0.88c0.29-0.98,1.04-1.5,1.85-2.12c0.81-0.63,1.06-1.14,2.05-0.89 c1.12,0.28,0.95,0.53,1.44,1.57c0.38,0.81,1.02,1.89,1.16,2.78c0.58-0.05,2.36-0.17,3.08-0.17c-0.06-0.33,0.23-1.58,0.27-1.92 c0.08-0.53,0.28-1.36,0.17-1.89c-0.24-1.17-0.75-0.74-0.96-1.91c-0.13-0.71,0.96-1.15,1.13-1.54c0.29-0.68-0.88-2.38-1.27-3.01 c-0.39-0.63-0.06-0.91-0.31-1.61c-0.44-1.26-0.94-2.18-0.44-3.42c0.09-0.22,0.8-0.51,0.79-0.75c-0.02-0.49-0.25-1.49-0.55-1.88 c-0.96-1.25-1.26-1.84,0.1-2.64c1.36-0.8,3.01-1.55,3.01,2.46c0,0.68-0.19,4.62-0.17,8.15c0.13-0.07,1.35-0.17,1.51-0.17h0.98 l0.44-0.57c-0.02-1.04,0.48-1.38,1.42-1.82s2.12,0.28,2.91,0.96c0.34-1.47,1.9-3.35,3.4-3.5c1.5-0.15,2.66,0.87,3.93,1.69 c0.26,0.17,1.87,0.68,2.16,0.56c0.19-0.07,0.26-1.26,0.36-1.44c0.71-1.18,1.58-1.98,2.46-3.03c0.89-1.05,0.85-1.32,2.21-1.51 c1.36-0.2,2.51,0.57,3.08,1.82c0.91-0.69,2.27-1.21,3.39-1.46c1.12-0.25,2.02-1.08,2.7-0.15c0.54,0.73,0.71,2.09,1.31,2.77 c1.93-0.83,4.19-1.68,6.13-0.87c1.18,0.49,2.16,1.39,3.36,1.85c1.47,0.56,3.04,0.66,4.61,0.72c0.64,0.03,1.82-0.2,2.4,0.1 c0.33-0.99,0.86-2.54,1.08-3.57c0.37-1.77,1.22-3.08,2.95-3.59c0.55-0.16,1.88-0.52,2.45-0.44c-1.36-1.45-1.87-3.81-1.94-5.8 c-0.03-0.95-1.45-1.8-1.14-2.69c-0.48-0.47-1.22-0.77-2.44-0.74c-0.22,0.02-0.43,0.04-0.65,0.07 c-0.36-3.37-2.56-1.13-3.17-2.38c-0.2-0.41-0.19-0.97-0.58-1.21c-0.51-0.32-1.11,0.22-1.47,0.7c-0.76-2.44-0.25-4.14-2.55-5.16 c-2.22-0.99-4.2-0.13-5.67,1.8c-0.52-0.39-1.05-0.78-1.57-1.18c-0.47-0.35-1.32-0.6-1.5-0.04c0.09-0.61-0.62-1.09-1.23-1.03 c-0.61,0.06-1.12,0.48-1.59,0.88c0.46-0.92-0.45-2.1-1.48-2.15c-0.71-0.04-1.37,0.32-1.88,0.84c-0.16-0.41-0.37-0.81-0.61-1.18 c-1.13-1.78-3.07-2.29-5.05-1.97c-0.14-1.01-0.08-1.99-0.56-2.93c-0.46-0.9-1.46-1.6-2.44-1.39c0.05-1.53-2.13-2.56-3.28-1.55 c-0.24-0.83-1.18-1.39-2.03-1.19c-0.84,0.19-1.45,1.1-1.31,1.96c-0.2-1.26-0.55-2.56-1.42-3.5s-2.37-1.39-3.46-0.73 c0.4-2.86,0.21-6.33-3.79-7.44c-0.77-0.22-1.21-1.19-2.02-1.2c-0.35-0.01-0.72,0.11-1.04-0.03c-0.48-0.2-0.5-0.9-0.87-1.25 c-0.03-0.02-0.05-0.04-0.07-0.07c-2.21-2.05-2.9-0.4-3.82-1.65c-0.75-1.02-0.97-1.83-1.81-2.79c-2.82-3.22-7.17-1.97-9.65-0.53 c-0.58-0.01-1.09-0.36-1.63-0.55c-1.16-0.41-2.57,0.01-3.32,0.98c-2.23-1.44-2.91-2.32-4.94-3.07 c-1.8-0.66-5.17-0.43-6.64,0.81c-1.01-1.19-2.75-1.67-4.25-1.25c-7.32-3.26-13.87-5.2-20.57-5.2c-2.91,0-5.76,0.44-8.62,1.25 C1667.04,452.33,1670.45,452.02,1673.6,452.24z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M1563.96,531.99c26.68,0,83.83,0.05,132.61,0.07c-8.55-1.02-22.38-5.15-24.44-10.01 c-2.73-6.42,7.4-13.6-7.4-20.26c-14.79-6.66-9.62-12.94,10.36-25.15c19.97-12.2,11.44-23.5-1.48-24.41 c-3.16-0.22-6.56,0.09-10.49,1.17c-10.44,2.88-24.57,11.22-47.58,29.59c-32.62,26.04-77.82,49.04-77.82,49.04l26.77,0.03 C1564.14,532.02,1563.96,531.99,1563.96,531.99z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#97B9B8",
    d: "M1842.64,491.57c1.22-1.67,2.92-3.01,4.85-3.75c3.1-1.19,6.75-0.85,9.58,0.9 c-1.72-2.66-5.11-4.12-8.23-3.55c-0.1-3.01,1.75-6,4.48-7.26s6.21-0.72,8.43,1.32c4.64-3.04,11.16-2.86,15.62,0.42 c-1.2-2.48-3.49-4.41-6.14-5.15c0.68-0.88,1.52-1.59,2.45-2.16c-0.8-0.24-1.39-0.98-1.96-1.63c-3.43-3.93-9.1-5.8-14.22-4.69 c-5.12,1.11-9.48,5.16-10.93,10.16c-0.4,1.38-0.6,2.84-1.25,4.13c-0.63,1.24-6.81,0.18-9.13,6.55c0.43,0.25,0.93,0.4,1.4,0.57 C1839.69,488.2,1841.47,489.69,1842.64,491.57z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M1928.17,389.38c-34.53,20.67-10.81,50.83,28.67,82.11c-16.67-2.09-35.45-1.02-55.86,5.58 c-2.15,0.7-4.21,1.41-6.18,2.14c-5.4,2.15-15.41,6.64-26.22,14.03c0,0,12.67-10.01,24.04-15.84c-0.73-0.9-1.54-1.77-2.41-2.55 c-0.46-0.41-0.94-0.81-1.44-1.17c-1.03-0.74-2.16-1.36-3.33-1.84c-0.88-0.36-1.79-0.65-2.72-0.84 c-3.04-0.63-6.42-0.23-9.02,1.35c-0.93,0.57-1.77,1.28-2.45,2.16c2.65,0.75,4.95,2.67,6.14,5.15 c-4.47-3.29-10.99-3.46-15.62-0.42c-2.22-2.04-5.69-2.58-8.43-1.32s-4.58,4.25-4.48,7.26c3.11-0.57,6.51,0.89,8.23,3.55 c-2.82-1.75-6.48-2.1-9.58-0.9c-1.94,0.75-3.63,2.08-4.85,3.75c-1.17-1.87-2.95-3.37-5.03-4.13c-0.47-0.17-0.97-0.32-1.4-0.57 c-0.13-0.08-0.26-0.16-0.37-0.26c-0.49-0.43-0.76-1.06-1.1-1.62c-0.95-1.59-2.57-2.76-4.37-3.17 c-0.77-0.18-1.58-0.22-2.31-0.51c-1.47-0.59-2.36-2.05-3.42-3.22c-2.62-2.9-6.83-4.27-10.66-3.46 c-3.83,0.81-7.13,3.75-8.36,7.47c-2.34-1.48-5.87-0.51-7.12,1.96c-2.46-1.28-5.64-1.02-7.86,0.64 c-2.22,1.66-3.36,4.64-2.82,7.36c-2.67,0.69-4.86,2.86-5.75,5.46c-0.31,0.89-0.46,1.83-0.43,2.78c0.06,1.99,0.94,3.89,2.3,5.33 c1.2,0.19,2.32,0.9,2.83,2c0.03,0.01,0.05,0.02,0.07,0.03c0.45-0.1,1.46-0.39,1.9-0.52l1.45-2.37l0.03-0.68l9.31-9.03 l15.61-0.1l0.96-0.07l7.08-0.17h1.1l7.13,0.58l1.46-0.65l6.67,0.24l1.75,0.21l6.01,0.48l1.07-0.41l6.15,0.38l-1.19,5.24 c0.01,0,0.71,0.16,0.72,0.16c-0.01,0.05-0.71-0.22-0.72-0.16c-0.03,0.18,0.74-0.02,0.72,0.16c-1.27-0.22-3.34,0.14-3.25,1.43 c-0.31,0,0.09,0.55-0.21,0.65c-0.02,0.01,0.02-0.01,0,0c-0.99,0.36-1.49,1.39-1.72,2.43c-0.02,0.09-0.96,0.79-0.98,0.89 c-0.04,0.24,0.45,0.41,0.33,0.62c-0.16,0.3-0.63,0.5-0.89,0.72c-0.63,0.54-0.22,0.63-0.58,1.38c-0.13-0.13,0,0-0.14-0.11 c-0.19-0.16-0.12-0.64-0.34-0.76c-0.89-0.51-2.31-1.05-3.33-0.88c-0.97,0.16-2.52,0.96-3.19,1.68c-0.24,0.25-1.53,0.6-1.7,0.9 c-0.03,0.05,0.24,0.72,0.21,0.78c-0.11,0.2,0,0-0.07,0.21c-0.08,0.23-0.17,0.93-0.21,1.17c-1.93-0.04-3.97,1.5-3.66,3.41 c-0.45,0.09-0.72,0.03-1.13,0.24c-1,0.5-0.5,1.07-1.03,2.06c-0.85-1.01-1.97-1.82-3.24-2.09c-0.44-0.09-1.57-0.16-2.03-0.1 c-0.8,0.1-2.58,1.11-3.11,1.71c-0.17,0.19-0.5,0.88-0.62,1.09c-0.34,0.62-1.14,0.54-0.92,1.23c-0.32-0.12,0.33,0.51,0,0.58 c-0.22,0.05,0.02,0.4-0.17,0.51c-0.51,0.3-1.13,0.33-1.2,0.92c-1.18,0.58-2.17,0.03-3.19,0.86c-0.25,0.2-0.92,0.65-1.15,0.87 c-0.16,0.15,0.02,1.24-0.14,1.39c-0.21,0.2-0.04,0.67-0.24,0.89c-0.07,0.07-0.89-0.07-0.96,0c-1.58,0.43-1.04-0.24-2.77,0.14 c-2.49,0.54-2.82,1.07-5.65,1.49c-0.01-3.43-2-5.3-2.19-6.85c-0.69-5.71-2.97-10.21-4.07-15.85c-0.05,0.39-0.94,2.07-0.96,2.46 c-0.23,4.03-1.07,5.48-1.71,8.59c-0.64,3.06-2.66,7.28-1.56,10.16c0.41,1.08-0.29,1.88,0,3.14c-0.45,0.05-1.09-0.84-1.55-0.79 c-3.08,0.29-4.81,0.26-8.3,0.41c-0.2,0.01-0.87,0.97-1.08,0.98c-3.02,0.12-5.53-0.1-8.88-0.1c-0.06,0-0.41,0.41-0.46,0.41 c-0.15,0-0.21-0.05-0.36-0.05c-3.13-0.01-6.18-0.17-9.39-0.36c-0.21-0.01-0.46-0.35-0.67-0.36c-3.21-0.19-6.26-0.64-9.39-0.92 c-0.21-0.02-1.08,0.07-1.28,0.05c-3.06-0.28-5.94-0.47-8.78-0.77c-6.02-0.63-9.78-0.56-13.91-0.77 c-0.01-1.85-1.39-5.85-1.4-9.78c-0.02-3.53-0.03-6.7-0.03-7.38c0-4.01-3.25-4.04-4.61-3.24c-1.36,0.8-1.7,2.87-0.74,4.12 c0.3,0.39,0.71,0.75,0.74,1.24c0.01,0.24-0.08,0.47-0.17,0.7c-0.49,1.24-1.01,2.61-0.58,3.87c0.24,0.7,0.76,1.27,1.15,1.9 c0.39,0.63,0.66,1.42,0.37,2.1c-0.17,0.39-0.51,1.05-0.38,1.76c0.21,1.17,1.15,1.23,1.39,2.4c0.11,0.53-0.1,1.06-0.17,1.59 c-0.05,0.33-0.04,0.67,0.02,1c-0.72,0-1.37,0.03-1.95,0.07c-0.14-0.89-0.33-1.77-0.71-2.59c-0.49-1.04-1.35-1.97-2.47-2.25 c-0.99-0.25-2.07,0.05-2.88,0.68s-1.35,1.55-1.64,2.53c-1.15-0.4-2.56,0.25-3.02,1.38c-0.16,0.39-0.26,0.87-0.64,1.04 c-0.36,0.16-0.76-0.06-1.16-0.09c-0.74-0.05-1.32,0.57-1.9,1.02c-0.59,0.46-1.29,0.79-1.86,1.27 c-0.09,0.08-0.17,0.16-0.26,0.24c-1.99,0.57-4.19,1.2-6.98,1.91c-2.47,0.62-5.4,1.3-9.05,2.04 c-1.14,0.23,193.93,14.64,193.93,14.64l145.84-13.46V402.27c-15.21-10.8-64.77-45.79-79.11-53.59 c-17.01-9.25-29.59-14.05-43.64-12.94c-0.54,0.04-0.89,0.13-1.08,0.25C1905.23,338.62,1978.35,359.35,1928.17,389.38z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M1817.7,525.13c0.16-0.15,0.32-0.3,0.48-0.45h-0.48V525.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1817.9349,
    y1: 506.4491,
    x2: 1817.9349,
    y2: 529.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M1817.7,525.13c0.16-0.15,0.32-0.3,0.48-0.45h-0.48V525.13z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M1847.3,493.64v-0.04l-7.9,0.04v-0.04l-7.99,0.04v-0.04l-7.99,0.04v-0.04l-7.82,0.04v-0.04l-18.19,0.09 l-9.01,10.2h-0.22l-0.21,4.29c0.19-0.05,0.64,0.09,0.83,0.05c1.24-0.22,1.11-0.22,2.05,0.62c0.94,0.84,1.61,1.89,1.54,3.14 c-0.01,0.21,1.23,0.5,1.39,0.65c0.17,0.16,0.59,0.54,0.82,0.51c1.12-0.13,1.19-0.24,1.69,0.77c0.44,0.89-0.2,1.27-0.29,2.26 l-6.38-0.87l-1.39,0.51l-44.96-0.15l-10.86,0.98h-1.16c-0.16,0-0.3,0.04-0.43,0.12c0.02,3.93,0.04,8.29,0.05,10.14 c4.13,0.21,9.52,0.8,15.54,1.44v-0.03c2.84,0.3,5.83,0.61,8.88,0.89v0.03c0.21,0.02,0.41,0.04,0.62,0.06 c3.14,0.29,6.35,0.55,9.56,0.74c0.21,0.01,0.41,0.02,0.62,0.04c3.21,0.18,6.42,0.3,9.56,0.31c0.15,0,0.3,0,0.45,0 c0.06,0,0.11,0,0.16,0c3.35,0,6.53-0.06,9.56-0.18c0.21-0.01,0.41-0.02,0.62-0.02c3.49-0.14,6.76-0.36,9.85-0.65 c0.46-0.04,0.92-0.09,1.37-0.13c-0.29-1.26-0.26-2.7-0.27-3.85c-0.01-3.14,1.15-7.02,1.79-10.08c0.65-3.11,1.02-4.54,1.25-8.57 c0.02-0.4,0.11-0.78,0.16-1.18c1.1,5.64,2.23,9.37,2.92,15.09c0.19,1.55,0.42,4.39,0.43,7.82c2.83-0.41,5.48-0.89,7.97-1.44 c1.73-0.38,3.38-0.78,4.96-1.22c0.07-0.07,0.13-0.15,0.2-0.22c0.2-0.22,0.41-0.42,0.62-0.63v-0.45h0.48 c0.24-0.21,0.47-0.42,0.72-0.62c1.02-0.83,2.13-1.54,3.32-2.12c0.07-0.59,0.46-1.1,0.97-1.41c0.19-0.11,0.4-0.2,0.62-0.24 c0.33-0.07,0.68-0.06,1,0.06c-0.22-0.69-0.09-1.41,0.25-2.03c0.12-0.22,0.27-0.43,0.44-0.62c0.54-0.6,1.29-1.04,2.09-1.14 c0.46-0.06,0.92-0.03,1.36,0.06c1.27,0.27,2.44,1.09,3.29,2.11c0.53-0.98,1.38-1.78,2.38-2.28c0.41-0.21,0.84-0.36,1.29-0.46 c-0.31-1.91,1.4-3.87,3.33-3.84c0.04-0.24,0.1-0.47,0.18-0.7h-4.77v-0.62h5.04c0.03-0.06,0.06-0.11,0.09-0.16 c0.17-0.3,0.38-0.58,0.62-0.83c0.67-0.72,1.56-1.23,2.53-1.39c1.01-0.17,2.07,0.06,2.95,0.57c0.22,0.12,0.42,0.27,0.62,0.42 c0.14,0.11,0.27,0.24,0.4,0.37c0.36-0.75,0.87-1.43,1.5-1.96c0.26-0.22,0.55-0.42,0.71-0.72c0.12-0.21,0.16-0.45,0.2-0.68 c0.02-0.1,0.03-0.19,0.05-0.28c0.23-1.04,1.04-1.9,2.04-2.27l0.07-0.02c0.29-0.1,0.6-0.16,0.91-0.16 c-0.09-1.29,1.22-2.48,2.5-2.26c0.03-0.18,0.06-0.36,0.09-0.55v-0.16v-7.14L1847.3,493.64z M1755.31,526.69h-8.88v-0.03h8.88 V526.69z M1755.31,522.67h-8.88v-0.03h8.88V522.67z M1765.48,526.69h-9.56v-0.03h9.56V526.69z M1765.48,522.67h-9.56v-0.03 h9.56V522.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1837.1918,
    y1: 506.4491,
    x2: 1837.1918,
    y2: 529.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M1834.61,506.45v10c0.41-0.21,0.84-0.36,1.29-0.46c-0.31-1.91,1.4-3.87,3.33-3.84 c0.04-0.24,0.1-0.47,0.18-0.7h-4.77v-0.62h5.04c0.03-0.06,0.06-0.11,0.09-0.16v-4.22H1834.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1843.1349,
    y1: 506.4491,
    x2: 1843.1349,
    y2: 529.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M1840.39,506.45v3.39c0.67-0.72,1.56-1.23,2.53-1.39c1.01-0.17,2.07,0.06,2.95,0.57v-2.57 H1840.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1847.9012,
    y1: 506.4491,
    x2: 1847.9012,
    y2: 529.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M1846.5,506.45v3c0.14,0.11,0.27,0.24,0.4,0.37c0.36-0.75,0.87-1.43,1.5-1.96 c0.26-0.22,0.55-0.42,0.71-0.72c0.12-0.21,0.16-0.45,0.2-0.68H1846.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1826.3718,
    y1: 506.4491,
    x2: 1826.3718,
    y2: 529.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M1828.94,506.45h-5.14v4.38h5.12v0.62h-5.12v6.25h1.7c0.54-0.6,1.29-1.04,2.09-1.14 c0.46-0.06,0.92-0.03,1.36,0.06V506.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1814.4962,
    y1: 506.4491,
    x2: 1814.4962,
    y2: 529.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M1811.94,524.68v-0.62h5.13v-5.74h-5.13v-0.62h5.13v-6.25h-5.13v-0.62h5.13v-4.38h-5.16v20.75 c1.73-0.38,3.38-0.78,4.96-1.22c0.07-0.07,0.13-0.15,0.2-0.22v-1.08H1811.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1820.4395,
    y1: 506.4491,
    x2: 1820.4395,
    y2: 529.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M1817.7,518.32v5.74h1.2c1.02-0.83,2.13-1.54,3.32-2.12c0.07-0.59,0.46-1.1,0.97-1.41v-2.21 H1817.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1824.4297,
    y1: 506.4491,
    x2: 1824.4297,
    y2: 529.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M1823.8,520.29c0.33-0.07,0.68-0.06,1,0.06c-0.22-0.69-0.09-1.41,0.25-2.03h-1.26V520.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 1820.4395,
    y1: 506.4491,
    x2: 1820.4395,
    y2: 529.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1817.7,
    y: 506.45,
    fill: "url(#SVGID_16_)",
    width: 5.49,
    height: 4.38
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 1820.4395,
    y1: 506.4491,
    x2: 1820.4395,
    y2: 529.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1817.7,
    y: 511.45,
    fill: "url(#SVGID_17_)",
    width: 5.49,
    height: 6.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1750.8599,
    y1: 519.0848,
    x2: 1750.8599,
    y2: 531.9875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M1746.42,527.32v1.06c2.84,0.3,5.83,0.61,8.88,0.89v-1.95H1746.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 1760.7017,
    y1: 519.0719,
    x2: 1760.7017,
    y2: 531.9747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1755.92,
    y: 519.07,
    fill: "url(#SVGID_19_)",
    width: 9.56,
    height: 3.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 1770.8762,
    y1: 519.072,
    x2: 1770.8762,
    y2: 531.9747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1766.1,
    y: 523.29,
    fill: "url(#SVGID_20_)",
    width: 9.56,
    height: 3.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 1781.0509,
    y1: 519.072,
    x2: 1781.0509,
    y2: 531.9747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1776.27,
    y: 523.29,
    fill: "url(#SVGID_21_)",
    width: 9.56,
    height: 3.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 1770.8762,
    y1: 519.0719,
    x2: 1770.8762,
    y2: 531.9747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1766.1,
    y: 519.07,
    fill: "url(#SVGID_22_)",
    width: 9.56,
    height: 3.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 1760.7017,
    y1: 519.072,
    x2: 1760.7017,
    y2: 531.9747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1755.92,
    y: 523.29,
    fill: "url(#SVGID_23_)",
    width: 9.56,
    height: 3.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 1750.8599,
    y1: 519.072,
    x2: 1750.8599,
    y2: 531.9747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1746.42,
    y: 523.29,
    fill: "url(#SVGID_24_)",
    width: 8.88,
    height: 3.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 1760.6973,
    y1: 519.0848,
    x2: 1760.6973,
    y2: 531.9875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M1755.92,527.32v2.01c3.14,0.29,6.35,0.55,9.56,0.74v-2.75H1755.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 1770.8762,
    y1: 519.0848,
    x2: 1770.8762,
    y2: 531.9875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M1766.1,527.32v2.79c3.21,0.18,6.42,0.3,9.56,0.31v-3.1H1766.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 1781.0509,
    y1: 519.0843,
    x2: 1781.0509,
    y2: 531.987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M1776.27,527.32v3.1c3.35,0,6.53-0.06,9.56-0.18v-2.92H1776.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 1750.8641,
    y1: 519.0719,
    x2: 1750.8641,
    y2: 531.9747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1746.42,
    y: 519.07,
    fill: "url(#SVGID_28_)",
    width: 8.88,
    height: 3.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 1791.3704,
    y1: 519.0719,
    x2: 1791.3704,
    y2: 531.9747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1786.45,
    y: 519.07,
    fill: "url(#SVGID_29_)",
    width: 9.85,
    height: 3.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 1781.0509,
    y1: 519.0719,
    x2: 1781.0509,
    y2: 531.9747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1776.27,
    y: 519.07,
    fill: "url(#SVGID_30_)",
    width: 9.56,
    height: 3.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 1791.3704,
    y1: 519.072,
    x2: 1791.3704,
    y2: 531.9747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1786.45,
    y: 523.29,
    fill: "url(#SVGID_31_)",
    width: 9.85,
    height: 3.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 1791.3704,
    y1: 519.072,
    x2: 1791.3704,
    y2: 531.9747
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M1786.45,527.31v2.89c3.49-0.14,6.76-0.36,9.85-0.65v-2.24H1786.45z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED4D3",
    d: "M1779.8,514.83c1.22-0.63,2.89-0.09,3.52,1.13c0.52-0.42,1.11-0.75,1.78-0.83 c1.18-0.16,2.76,0.94,2.38,1.49l0.73,0l9.34,0.02c0.08-0.99,0.15-2.04-0.29-2.93c-0.5-1.01-1.67-1.65-2.79-1.51 c-0.23,0.03-0.51,0.07-0.67-0.09c-0.15-0.15-0.14-0.4-0.12-0.61c0.07-1.26-0.46-2.54-1.4-3.38c-0.94-0.84-2.28-1.22-3.52-1 c-0.19,0.03-0.38,0.08-0.56,0.13c-0.45,0.13-0.89,0.29-1.34,0.39c-0.02,0-0.03,0.01-0.05,0.01c-0.01-0.02-0.02-0.03-0.02-0.05 c-0.51-1.1-1.62-1.81-2.83-2c-0.57-0.09-1.16-0.06-1.72,0.1c-1.73,0.51-3.01,2.14-3.38,3.9c-0.22,1.03-0.18,2.13-0.5,3.12 C1779.2,513.17,1779.84,513.89,1779.8,514.83z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M1787.47,516.62C1787.47,516.62,1787.47,516.62,1787.47,516.62c0.38-0.55-1.19-1.65-2.38-1.49 c-0.66,0.09-1.26,0.41-1.78,0.83c-0.62-1.22-2.3-1.76-3.52-1.13c0.04-0.94-0.6-1.66-1.45-2.1c-0.58-0.3-1.26-0.48-1.89-0.5 c-1.57-0.06-3.21,0.36-4.69-0.2c-1.2-0.46-2.09-1.5-3.28-1.99c-1.94-0.8-4.14,0.03-6.07,0.87c-0.6-0.68-0.67-1.69-1.21-2.42 c-0.68-0.92-1.98-1.2-3.1-0.95c-1.12,0.25-2.08,0.93-2.99,1.62c-0.57-1.25-2.09-1.88-3.45-1.68c-1.36,0.2-2.54,1.07-3.43,2.12 s-1.53,2.28-2.24,3.46c-0.1,0.17-0.22,0.35-0.41,0.43c-0.29,0.12-0.6-0.07-0.87-0.24c-1.27-0.82-2.76-1.4-4.27-1.25 c-1.5,0.15-2.98,1.17-3.32,2.65c-0.79-0.68-1.98-0.84-2.92-0.39c-0.94,0.44-1.82,1.35-1.81,2.39v0.04L1787.47,516.62z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M1834.64,511.45h4.77c0.07-0.21,0.16-0.42,0.27-0.62h-5.04V511.45z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEE7F5",
    d: "M2047.34,574.74v-7.52c0-3.46,0,0,0-3.46v-0.14c0,0-0.05-19.97,0-32.61c0,0-75.91,2.57-88.55,2.16 c-55.88,0-121.1,1-136.97,1c-45.96,0-33.26-2.73-52.96-2.73c-14.74,0-15.05,1.73-18.46,1.73c-1.89,0-7.46-2.21-16.03-2.21 c-10.4,0-32.54-0.71-62.57-0.71c-19.05,0-39.77,0.61-55.1,0.61c-16.19,0-32.54-2.26-37.16-2.95l-27.54-0.15 c0,0,53.03,6.99,105.98,71.71c40.83,49.9,59.82,65.04,71.86,73.42c111.85,77.88,263.41,42.84,317.5,26.21V581.78 C2047.34,574.74,2047.34,581.78,2047.34,574.74z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 1741.36,
    cy: 364.78,
    r: 25.86
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    display: "none",
    opacity: 0.3,
    d: "M1790.45,522.62h-9.49h-43.55c0.46,0,0.84,0.37,0.84,0.84v10.3 c0.7,0.07,1.4,0.15,2.12,0.22v-1.03h8.62v1.9c0.2,0.02,0.4,0.04,0.6,0.06v-1.95h9.28v2.67c0.2,0.01,0.4,0.02,0.6,0.04v-2.71 h9.28v3.01c0.15,0,0.29,0,0.44,0c0.05,0,0.11,0,0.16,0v-3.01h9.28v2.83c0.2-0.01,0.4-0.02,0.6-0.02v-2.81h9.56v2.18 c0.45-0.04,0.89-0.08,1.33-0.13c-0.28-1.23-0.26-2.62-0.26-3.74c-0.01-2.56,0.78-5.61,1.4-8.28 C1791.05,522.75,1790.77,522.62,1790.45,522.62z M1748.99,532.35h-8.62v-3.3h8.62V532.35z M1740.36,528.45v-3.5h8.62v3.5 H1740.36z M1758.86,532.35h-9.28v-3.3h9.28V532.35z M1749.58,528.45v-3.5h9.28v3.5H1749.58z M1768.74,532.35h-9.28v-3.3h9.28 V532.35z M1759.46,528.45v-3.5h9.28v3.5H1759.46z M1778.62,532.35h-9.28v-3.3h9.28V532.35z M1769.34,528.45v-3.5h9.28v3.5 H1769.34z M1779.22,532.35v-3.3h9.56v3.3H1779.22z M1788.78,528.45h-9.56v-3.5h9.56V528.45z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1732.14,518.92V527c2.89,0.19,6.31,0.53,10.07,0.92v-9H1732.14z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1807.53,503.92h0.03v24.14c1.5-0.26,2.95-0.55,4.35-0.85v-20.75h5.16v4.38h-5.13v0.62h5.13v6.25h-5.13 v0.62h5.13v5.74h-5.13v0.62h5.13v1.08c0.2-0.22,0.41-0.42,0.62-0.63v-0.45h0.48c0.24-0.21,0.47-0.42,0.72-0.62h-1.2v-5.74h5.49 v2.21c0.19-0.11,0.4-0.2,0.62-0.24v-1.97h1.26c0.12-0.22,0.27-0.43,0.44-0.62h-1.7v-6.25h5.12v-0.62h-5.12v-4.38h5.14v10.18 c1.27,0.27,2.44,1.09,3.29,2.11c0.53-0.98,1.38-1.78,2.38-2.28v-10h5.16v4.22c0.17-0.3,0.38-0.58,0.62-0.83v-3.39h5.49v2.57 c0.22,0.12,0.42,0.27,0.62,0.42v-3h2.81c0.02-0.1,0.03-0.19,0.05-0.28c0.3-1.36,1.61-2.43,3.01-2.45 c-0.09-1.29,1.22-2.48,2.5-2.26c0.01-0.08,0.03-0.17,0.04-0.25l-0.01-7.6v0l0,0l-7.59,9.78v0.49l-0.04,0l-0.02-10.27v0l0,0 l-7.84,10.1v0.17l-0.04,0l-0.02-10.27v0l0,0l-7.92,10.21v0.06l-0.04,0l-0.02-10.27v0l0,0l-7.92,10.21v0.06l-0.04,0l-0.02-10.27 v0l0,0l-7.76,9.99v0.28l-0.04,0l-0.02-10.27v0l0,0L1807.53,503.92z M1823.18,517.71h-5.49v-6.25h5.49V517.71z M1823.18,510.84 h-5.49v-4.38h5.49V510.84z"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M1821.43,562.14c-10.06,0-22.92,0-35.22,0s-3.19,4.4,9.19,4.4c0.56,0,0.99,0,1.33,0c0.02,0,0.28,0,0.98,0 c1.06,0,3.13,0,6.95,0C1827.02,566.54,1831.49,562.14,1821.43,562.14z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M1834.88,586.04c15.99,0,169.83,0,198.17,0V579c-27.6,0-175.74,0-195.55,0 C1815.65,579,1817.26,586.04,1834.88,586.04z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M1894.62,571.49c14.71,0,115.84,0,138.43,0v-3.46c-21.82,0-117.78,0-135.97,0 C1876.53,568.03,1878.04,571.49,1894.62,571.49z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M1693.28,534.11c3.65-0.74,6.58-1.41,9.05-2.04c-1.91,0-3.83,0-5.77,0 c-48.78-0.03-105.93-0.07-132.61-0.07c0,0,0.18,0.03,0.52,0.08c0.2,0.03,0.46,0.07,0.77,0.12c4.62,0.69,20.97,2.95,37.16,2.95 c15.33,0,35.73,2.14,54.78,2.14c30.03,0,53.16,0,63.55,0c8.56,0,20.65,2.72,12.21,2.72c-3.75,0-7.92,0.17-13.57,0.17 c-14.23,0-13.69,3.89,1.05,3.89c19.7,0,49.82,0,95.78,0c15.88,0,10.05,3.84,4.22,3.84c-6.07,0-15.32,0.27-20.5,0.27 c-8.21,0-16.8,2.46-11.62,3.75c3.11,0.78,16.58,0.67,22.94,0.67c8.73,0,68.42,0,124.3,0c25.28,0.81,14.69,4.15,2.29,4.15 c-14.12,0-18.43,0.67-23.53,0.67c-5.1,0-12.16,4.99,7.06,4.99c9.68,0,39.08,0,65.87,0c9.64,0.95,7.3,5.25-4.44,5.52h50.25v-32.61 l-143.42-1.18C1889.63,534.11,1692.15,534.34,1693.28,534.11z M1762.59,540.03c-9.53,0-12.56-1.11,2.17-1.11 C1777.32,538.92,1772.12,540.03,1762.59,540.03z M1778.38,541.99c-3.78,0-4.98-0.69,0.86-0.69 C1784.22,541.3,1782.16,541.99,1778.38,541.99z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1695.18,553.66c-0.01,0.25-0.01,0.49-0.02,0.74c0.51-0.61,1.04-1.23,1.59-1.85 c-0.49,0.12-1.01,0.26-1.55,0.41C1695.19,553.19,1695.18,553.42,1695.18,553.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1695.89,685.57c-0.88-0.54-1.76-1.09-2.61-1.65c1.34,1.07,2.73,2.14,4.16,3.2 C1696.9,686.6,1696.38,686.09,1695.89,685.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1705.22,560.75c1.26,2.19,2.54,4.67,2.89,5.37c1.73,1.07,3.3,1.63,4.82,2.1c-2.3-4.17-5.82-5.85-6.42-9.84 C1706.51,558.38,1706.11,559.26,1705.22,560.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1585.9,366.73c-0.27,2.42-0.53,4.93-0.78,7.52C1585.46,372.01,1585.71,369.81,1585.9,366.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1604.25,611.78c-7.93-1.18-15.54-2.18-21.57-3.64C1587.41,609.53,1594.15,610.75,1604.25,611.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1641.68,622.49c2,1.59,3.89,3.39,5.91,5.44C1646.03,625.85,1644.02,624.05,1641.68,622.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M1806.62,685.28c18.52,2.51,36.78,4.56,54.14,6.11c-20.28-2.5-44.81-7.03-62.26-15.18 c-21.37-9.97-15.64-26.98-8.3-38.72c0,0-0.04,0.04-0.1,0.12c-3.23,5.47-9.56,11.75-15.61,20.93 C1765.71,671.89,1778.24,679.97,1806.62,685.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M1538.97,564.09c17.94,3.39,18.28,23.52,31.51,36.96c2.63,2.67,5.29,5.06,12.19,7.09 c6.04,1.46,13.64,2.47,21.57,3.64c0.6,0.06,1.2,0.12,1.82,0.18c20.11,1.93,28.52,4.89,35.61,10.53 c2.34,1.56,4.35,3.35,5.91,5.44c0.23,0.23,0.46,0.46,0.69,0.7c6.53,6.7,15.14,31.5,45,55.29c0.86,0.56,1.73,1.11,2.61,1.65 c-28.1-29.54,13.35-65.59-10.41-86.8c-1.99-2.34-2.86-5.5-3.3-8.59c-0.01-0.06-0.1-0.06-0.11,0c-0.16,1.32-0.26,2.65-0.33,3.97 c0,0.05-0.07,0.07-0.1,0.03c-1.12-1.83-1.69-3.94-2.21-6.03c-0.01-0.06-0.1-0.05-0.11,0.01c-0.15,1.46-0.22,2.93-0.2,4.4 c0,0.06-0.09,0.08-0.1,0.03c-1-3.55-2.22-5.35-2.49-5.23c-0.12,0.05,0.75,2.1,0.78,3.6c0,0.05-0.06,0.07-0.09,0.04 c-0.99-0.9-1.54-2.56-1.8-3.68c-0.01-0.06-0.1-0.05-0.11,0.01c-0.03,1.48,0.15,2.97,0.55,4.39c0.02,0.06-0.06,0.09-0.09,0.05 c-0.74-0.97-1.37-2.03-1.85-3.15c-0.02-0.05-0.1-0.04-0.1,0.02c-0.07,1.14,0.11,2.27,0.46,3.35c-4.34-1.86-9.6-3.52-15.94-4.96 c-21.05-4.78-35.4-11.49-44.7-19.11c-0.54-0.95-0.85-2.08-0.99-3.17c-0.25-1.89-0.16-3.84-0.62-5.68 c-0.02-0.07-0.12-0.07-0.14,0c-0.42,1.54-0.7,3.12-0.83,4.71c-0.01,0.08-0.11,0.09-0.13,0.01c-0.44-1.5-0.76-3.03-0.96-4.57 c-0.01-0.08-0.13-0.08-0.13,0l-0.21,2.23c-0.01,0.07-0.11,0.09-0.13,0.02c-0.73-1.78-1.07-3.71-1-5.63 c0-0.08-0.11-0.1-0.14-0.02c-0.48,1.69-0.61,3.48-0.39,5.23c0.01,0.08-0.1,0.11-0.13,0.03c-0.51-1.36-0.92-2.75-1.22-4.17 c-0.02-0.08-0.14-0.07-0.13,0.02l0.07,2.28c0,0.07-0.09,0.1-0.13,0.04c-0.86-1.26-1.36-2.76-1.42-4.29 c0-0.08-0.12-0.09-0.14-0.01c-0.24,1.09-0.27,2.21-0.14,3.32c-5.57-8.37-6.54-17.25-4.63-25.56 c6.97-30.34-26.25-30.75-10.8-30.38c3.69,0.09,7.23,0.31,10.62,0.64c11.24,1.45,19.71,3.49,25.72,5.35 c2.45,0.82,4.8,1.7,7.06,2.64c0.01-0.04,0.02-0.08,0.04-0.13c3.2,1.31,4.7,2.21,4.7,2.21c-0.65-3.43-1.78-6.09-3.14-8.15 c2.55-10.87,3.73-22.68,3.48-31.8c-0.49-17.32-1.85-41.91-8.22-68.42c-3.99-16.59-4.18-28.91-5.63-37.19 c-0.87-4.96-0.87-8.43-1.73-3.47s-6.37,11.99-6.06,28.76c0.22,11.97-1.75,16.74-3.12,25.95c-0.45-5.18-0.98-9.92-1.6-13.99 c-4.65-30.76-6.07-31.09-9.81-53.83c-4.72-28.69-3.34-33.65-5.44-36.01c-2.46,4.34-6.89,21.27-10.26,51.83 c-0.19,3.08-0.44,5.28-0.78,7.52c-2.38,24.44-4.05,56.53-3.73,96.71c-0.34,0.01-0.67,0.04-1.01,0.06c0,0.04,0-0.04,0,0 c-1.61,0.08-3.33,0.52-5.19,1.1c-13.16,4.14-11.58,19.51-11.58,19.51s-7.24,0.14-9.63,9.54c0,0-11.17-4.52-21.34,5.06 c-5.81,5.48-6.61,14.98-6.61,14.98s-9.11,2.8-11.77,18.04c-11.03,13.01-22.02,27.87-37.81,41.75c-0.77,0.67-2.46,2.88,4.73,1.18 C1521.5,570.07,1524.48,561.36,1538.97,564.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M1728.12,593.35c0.04,0.14,0.09,0.27,0.13,0.41c-0.01-0.33,0-0.58-0.16-0.74 c-0.01,0.02-0.01,0.03-0.01,0.05C1728.05,593.16,1728.08,593.26,1728.12,593.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M1728.53,594.48c-0.02-0.02-0.05-0.03-0.07-0.05c0,0.01,0.01,0.03,0.01,0.04 C1728.5,594.48,1728.52,594.48,1728.53,594.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M1727.57,595.05c0.03-0.02,0.06-0.04,0.08-0.06c0.03-0.03,0.05-0.06,0.06-0.1 c-0.07,0-0.14-0.02-0.2-0.05C1727.53,594.91,1727.55,594.98,1727.57,595.05z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0DAC7",
    points: "1727.59,594.14 1727.59,594.14 1727.59,594.14  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M1726.99,593.2c-0.1-0.05-0.2-0.1-0.29-0.16c-0.05-0.03-0.1-0.07-0.15-0.11 c0.02,0.07,0.03,0.14,0.07,0.19C1726.71,593.25,1726.86,593.28,1726.99,593.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3B4A",
    d: "M1629.95,554.23c0,0-0.44-2.05-1.37-4.44c-0.91-2.32-2.29-4.97-4.21-6.39 c-3.96-2.94,0.02,1.28,1.26,6.36c0.17,0.7,0.29,1.42,0.33,2.14L1629.95,554.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M1678.48,552.04c0.65,4.67-0.88,7.3-1.39,10.53c-0.44,1.74-0.45,3.47,0.21,5.04c0,0,0,0.01,0,0.01 c2.54,1.16,7.23,3.35,11.99,5.79c0.21,1.73,0.37,2.83,0.92,4.03c0.04,0.08,0.08,0.16,0.12,0.25c0.44,0.86,1.64,0.55,2.44,0.21 c0.09-0.04,0.17-0.09,0.24-0.14c0.31-0.22,0.49-0.56,0.47-0.93c-0.02-0.36-0.03-0.76-0.02-1.21c0.01-0.75,0.05-1.61,0.12-2.56 c1.18-0.49,2.33-1.26,3.57-2.36c0.02,0.02,0.02,0.02,0.02,0.02c0.78-0.66,1.45-1.23,2.03-1.73c0.05-0.07,0.11-0.14,0.18-0.21 c0.96-0.9,2.2-2.95,3.99-3.38c2.08-0.5,4.67,0.69,4.65,0.67c0.02,0.02,0.05,0.03,0.07,0.04c-0.36-0.7-1.64-3.18-2.89-5.37 c0.9-1.48,1.29-2.37,1.29-2.37c0.6,3.99,4.12,5.67,6.42,9.84c1.92,0.59,3.75,1.05,5.69,2.24c0.08,0.03,0.15,0.06,0.2,0.08 c-2.88-4.5-4.76-16.81-8.5-22.07c-0.96-1.35-2.04-2.23-3.29-2.4c-1.58-0.21-3.21,0.39-4.82,1.44c-0.08-0.04-0.17-0.08-0.27-0.1 c-1.78-0.39-4.18-0.25-6.7,0.02c-0.03-3.87-0.34-5-1.26-6.33c0.01-0.02,0.02-0.03,0.02-0.03c-0.12-0.15-0.24-0.29-0.35-0.43 c-0.13-0.17-0.27-0.35-0.42-0.54c-0.02-0.03-0.05-0.06-0.08-0.08c-0.71-0.92-1.35-1.74-2.58-2.64c-0.1,0.17-0.19,0.35-0.28,0.55 c-0.21,0.56-0.44,1.25-0.66,2.33c-0.4,1.99-0.19,3.52-0.19,3.52s-0.49-1.86,0.4-4.88c-0.11,0.3-1.4,3.95-0.93,5.88 c0,0-0.26-0.36-0.38-1.15c-0.05,0.72-0.02,1.21-0.02,1.21s-0.34,0-0.87-0.05c-0.01-0.47,0.01-2.07,0.53-3.55 c0,0-0.74,1.31-0.73,3.53c-0.24-0.03-0.52-0.06-0.82-0.12c-1.89-0.32-4.71-1.21-6.11-3.65c-1.67-1.78-1.02-4.83,1.12-5.7 c0.78-0.32,1.27-0.79,1.57-1.35c-2.76-0.61-4.86,0.2-5.72,4.07c-0.4,1.82-0.56,3.02-0.54,4.15 C1676.97,544.39,1677.69,546.3,1678.48,552.04z M1695.16,554.4c0.01-0.25,0.01-0.5,0.02-0.74c0-0.24,0.01-0.47,0.01-0.69 c0.54-0.15,1.06-0.29,1.55-0.41C1696.2,553.17,1695.66,553.8,1695.16,554.4z M1703.8,548.97c1.11,0.76,1.11,1.09,1.33,1.84 s0.59,1.58,0.55,1.97c-0.03,0.26-0.2,0.55-0.31,0.72c0.02,0.43-0.08,0.81-0.34,1.19c0,0-0.78,0.98-0.86,0.62 c-0.08-0.35,0.39-1.05,0.27-1.56c-0.11-0.46-0.78-2.77-0.7-2.26c0.08,0.51,0.47,1.56,0.39,2.11c-0.05,0.34-0.07,0.97-0.12,1.55 c-0.03,0.34-0.08,0.67-0.15,0.91c-0.2,0.66-0.63,0.27-0.67,0.09c-0.05-0.31,0-0.17-0.04-0.99c-0.04-0.82-0.39-3.67-0.39-3.67 s0.16,1.33,0.2,2.34s-0.13,1.89-0.32,2.05c-0.15,0.12-0.31,0.22-0.42-0.13c0-0.02,0-0.03-0.01-0.06 c-0.1-0.57-0.01-1.53-0.1-1.99c-0.06-0.34-0.14-1.37-0.2-2.04c-0.03-0.58-0.09-0.88-0.28-0.54c-0.27,0.51-0.23,1.48-0.23,2.3 s-0.74,1.33-0.66,0.66s0-1.21-0.31-1.99c-0.31-0.78,0-1.79,0.08-2.42s0.86-1.95,1.79-1.87 C1702.98,547.87,1702.7,548.21,1703.8,548.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1718.98,570.68c-0.02-0.03-0.03-0.07-0.05-0.1c0,0-0.04-0.02-0.11-0.05c-0.05-0.02-0.12-0.05-0.2-0.08 C1718.74,570.53,1718.86,570.6,1718.98,570.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1729.38,575.13c0,0,0.01,0.01,0.01,0.01c0-0.06,0-0.13,0-0.19 C1729.38,575.01,1729.39,575.07,1729.38,575.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M1693.49,576.82c0.02,0.37-0.16,0.71-0.47,0.93c0.11,0.33,0.23,0.54,0.34,0.71 c0.22,0.35,0.42,0.41,0.58,0.8c0.16,0.38,0.43,0.9,0.9,1.05c0.88,0.29,1.48,0.21,1.08,0.51c-0.39,0.3-1.03,0.31-1.9,0.1 c-0.86-0.22-1.08-0.43-1.4-0.29c-0.63,0.45-0.72,0.77-0.89,1.42c-0.27,1.02-0.3,1.49-0.73,2.49c-0.13,0.3-0.17,0.86-0.57,0.8 c-0.54-0.12-0.08-0.92-0.01-1.19c0.29-1.16,0.31-1.5,0.6-2.66c-0.7,0.32-0.77,2.27-1.97,3.84c-0.15,0.07-0.5,0-0.53-0.26 c-0.03-0.26,0.27-0.97,0.36-1.23c0.54-1.47,0.54-1.4,1.08-2.87c-0.6,1.04-0.94,1.28-1.53,2.32c-0.27,0.47-0.52,1.1-0.96,0.84 c-0.29-0.34,0.08-0.86,0.25-1.16c0.64-1.11,0.53-0.96,1.17-2.06c-0.83,1-1.7,2.38-2.1,1.65c-0.15-0.45,1.55-1.73,2.34-3.21 c0.25-0.46,0.38-0.96,0.67-1.41c0.11-0.18,0.26-0.35,0.43-0.49c-0.56-1.2-0.71-2.29-0.92-4.03c-4.76-2.44-9.45-4.63-11.99-5.79 c0,0,0-0.01,0-0.01c-13.9-6.33-24.64-10.54-36.27-14.69c-5.44-1.94-9.52-2.87-12.46-3.13c0.94,2.39,1.37,4.44,1.37,4.44 l-3.99-2.33c-0.04-0.72-0.16-1.44-0.33-2.14c-1.87,0.18-2.87,0.8-3.15,1.58c-0.02-0.01-0.03-0.01-0.03-0.01 c-0.91,1.26-0.49,5.33,6.91,10.87c5.54,4.15,17.73,10.14,34.48,17.3c11.75,2.5,21.68,4.93,29.24,9.3 c3.67,2.12,7.2,4.49,10.59,6.74c0.23,0.09,0.46,0.18,0.69,0.26c12.88,4.95,17.36,4.91,17.48,2.99c0.04-0.21,0.02-0.47-0.07-0.79 c-2.05-6.87-15.95-15.68-27.59-22c-0.24-0.13-0.47-0.26-0.71-0.39C1693.46,576.06,1693.47,576.47,1693.49,576.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1689.8,577.93c-0.29,0.45-0.42,0.94-0.67,1.41c-0.79,1.48-2.48,2.76-2.34,3.21 c0.4,0.73,1.26-0.65,2.1-1.65c-0.64,1.11-0.53,0.96-1.17,2.06c-0.18,0.31-0.54,0.82-0.25,1.16c0.44,0.26,0.69-0.37,0.96-0.84 c0.6-1.04,0.94-1.28,1.53-2.32c-0.54,1.47-0.54,1.4-1.08,2.87c-0.09,0.26-0.39,0.97-0.36,1.23c0.03,0.26,0.38,0.33,0.53,0.26 c1.21-1.57,1.28-3.52,1.97-3.84c-0.29,1.16-0.31,1.5-0.6,2.66c-0.07,0.27-0.53,1.08,0.01,1.19c0.4,0.06,0.44-0.51,0.57-0.8 c0.43-0.99,0.46-1.47,0.73-2.49c0.18-0.65,0.27-0.96,0.89-1.42c0.32-0.14,0.54,0.07,1.4,0.29c0.87,0.22,1.51,0.2,1.9-0.1 c0.4-0.31-0.2-0.23-1.08-0.51c-0.47-0.15-0.74-0.67-0.9-1.05c-0.16-0.39-0.36-0.45-0.58-0.8c-0.11-0.17-0.23-0.38-0.34-0.71 c-0.07,0.05-0.16,0.1-0.24,0.14c-0.8,0.34-2,0.66-2.44-0.21c-0.04-0.08-0.08-0.16-0.12-0.25 C1690.05,577.59,1689.91,577.76,1689.8,577.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1694.06,529.48c-0.12,0.21-0.22,0.4-0.32,0.58c-0.24-0.41-0.57-0.43-0.77-0.2 c-0.18,0.21-0.31,1.32-0.02,2.22c-0.02,0.14-0.04,0.28-0.05,0.43c-0.13,1.93-0.97,2.85-1.77,4.01c1.59,0.08,2.18-0.49,2.46-1.79 c0.18-0.82,0.65-1.51,0.75-2.33c0.1-0.82-0.03-1.1,0.31-2.57c0.12-0.52,0.15-0.89,0.14-1.21 C1694.61,528.92,1694.37,529.21,1694.06,529.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1702.31,547.82c-0.93-0.08-1.72,1.25-1.79,1.87s-0.39,1.64-0.08,2.42c0.31,0.78,0.39,1.33,0.31,1.99 s0.66,0.16,0.66-0.66s-0.04-1.79,0.23-2.3c0.18-0.34,0.24-0.05,0.28,0.54c0.07,0.66,0.14,1.69,0.2,2.04 c0.09,0.46,0,1.41,0.1,1.99c0,0.02,0.01,0.04,0.01,0.06c0.1,0.35,0.27,0.24,0.42,0.13c0.2-0.16,0.36-1.04,0.32-2.05 s-0.2-2.34-0.2-2.34s0.35,2.85,0.39,3.67c0.04,0.82-0.02,0.68,0.04,0.99c0.03,0.18,0.47,0.57,0.67-0.09 c0.07-0.25,0.12-0.57,0.15-0.91c0.06-0.58,0.07-1.2,0.12-1.55c0.08-0.55-0.31-1.6-0.39-2.11c-0.08-0.51,0.6,1.8,0.7,2.26 c0.12,0.51-0.35,1.21-0.27,1.56c0.08,0.35,0.86-0.62,0.86-0.62c0.26-0.38,0.36-0.76,0.34-1.19c0.11-0.17,0.28-0.46,0.31-0.72 c0.04-0.39-0.33-1.21-0.55-1.97s-0.23-1.09-1.33-1.84C1702.7,548.21,1702.98,547.87,1702.31,547.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M1681.62,535.3c-2.14,0.87-2.79,3.92-1.12,5.7c1.4,2.43,4.22,3.32,6.11,3.65 c0.3,0.05,0.58,0.09,0.82,0.12c-0.02-2.23,0.73-3.53,0.73-3.53c-0.52,1.48-0.54,3.08-0.53,3.55c0.54,0.05,0.87,0.05,0.87,0.05 s-0.03-0.49,0.02-1.21c0.13,0.79,0.38,1.15,0.38,1.15c-0.47-1.93,0.82-5.58,0.93-5.88c-0.89,3.02-0.4,4.88-0.4,4.88 s-0.21-1.53,0.19-3.52c0.22-1.08,0.46-1.77,0.66-2.33c0.09-0.19,0.18-0.37,0.28-0.55c0.17-0.31,0.36-0.59,0.55-0.86 c0.8-1.15,1.64-2.08,1.77-4.01c0.01-0.15,0.03-0.29,0.05-0.43c-0.3-0.9-0.16-2.01,0.02-2.22c0.2-0.24,0.52-0.21,0.77,0.2 c0.1-0.18,0.21-0.37,0.32-0.58c0.31-0.27,0.55-0.56,0.73-0.87c0.71-1.22,0.41-2.62,0.08-3.46c-0.02-0.05-0.04-0.11-0.06-0.17 c0,0-0.77-2.13-2.97-2.83c-0.79-0.25-1.22-0.42-2.42-0.42c-4.79,0.02-6.58,3.57-5.98,8.82l0,0c0,0.03,0.01,0.05,0.01,0.08 c0.03,0.25,0.07,0.5,0.11,0.76c0.09,0.89,0.04,1.8-0.37,2.56C1682.89,534.51,1682.4,534.98,1681.62,535.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M1938.31,694.72c-12.29,0.28-26.47,0-41.93-0.79c-2.94-0.29-6.01-0.52-9.24-0.7 c-5.93-0.33-11.67-0.68-17.21-1.05c-3.03-0.24-6.08-0.5-9.17-0.78c-17.36-1.55-35.62-3.6-54.14-6.11 c-28.38-5.32-40.91-13.39-32.13-26.73c6.05-9.19,12.37-15.46,15.61-20.93c2.56-4.33,3.19-8.16,0.21-12.52 c-4.89-9.31-17.73-21.39-27.81-25.08c-8.22-3.01-10.45-2.23-13.21-3.17c-0.46-0.3-0.93-0.61-1.39-0.91 c0,0.02,0.01,0.04,0.01,0.06c-14.42-9.22-20.21-15.39-21.6-17c-1.01-1.55-2.08-3.16-3.63-4.97c-1.31-1.52-2.52-2.57-3.7-3.34 c-0.12-0.08-0.24-0.15-0.36-0.23c-1.94-1.19-3.77-1.65-5.69-2.24c-1.52-0.47-3.09-1.03-4.82-2.1c-0.02-0.01-0.05-0.03-0.07-0.04 c0.02,0.02-2.57-1.17-4.65-0.67c-1.8,0.43-3.03,2.48-3.99,3.38c-0.07,0.07-0.13,0.14-0.18,0.21c-0.58,0.5-1.25,1.07-2.03,1.73 c0,0-0.01-0.01-0.02-0.02c-1.24,1.11-2.4,1.88-3.57,2.36c-0.07,0.95-0.11,1.81-0.12,2.56c0.24,0.13,0.48,0.26,0.71,0.39 c11.64,6.33,24.37,14.71,26.74,20.2c0.13,0.3,0.12,2.3,0.08,2.52c-0.12,1.92-3.75,2.03-16.63-2.92 c-0.23-0.09-0.46-0.18-0.69-0.26c-3.39-2.24-6.93-4.62-10.59-6.74c-7.55-4.37-17.49-6.8-29.24-9.3 c-16.75-7.16-28.95-13.15-34.48-17.3c-7.39-5.54-7.82-9.61-6.91-10.87c0,0,0.01,0.01,0.03,0.01c0.28-0.78,1.28-1.4,3.15-1.58 c-1.24-5.09-5.22-9.3-1.26-6.36c1.92,1.42,3.3,4.07,4.21,6.39c2.94,0.26,7.01,1.19,12.46,3.13 c11.63,4.16,22.38,8.36,36.27,14.69c-0.66-1.57-0.65-3.3-0.21-5.04c0.51-3.23,2.04-5.86,1.39-10.53 c-0.8-5.73-1.51-7.65-1.55-9.87c-11.84-10.89-24.95-23.18-44.24-31.2c-2.27-0.94-4.62-1.83-7.06-2.64 c-6.02-1.86-14.48-3.9-25.72-5.35c-3.4-0.33-6.93-0.55-10.62-0.64c-15.45-0.37,17.78,0.04,10.8,30.38 c-1.91,8.31-0.94,17.19,4.63,25.56c-0.13-1.11-0.1-2.23,0.14-3.32c0.02-0.08,0.13-0.07,0.14,0.01c0.07,1.52,0.57,3.03,1.42,4.29 c0.04,0.06,0.13,0.03,0.13-0.04l-0.07-2.28c0-0.08,0.12-0.1,0.13-0.02c0.3,1.42,0.7,2.82,1.22,4.17 c0.03,0.08,0.14,0.05,0.13-0.03c-0.22-1.75-0.09-3.54,0.39-5.23c0.02-0.08,0.14-0.06,0.14,0.02c-0.07,1.92,0.27,3.85,1,5.63 c0.03,0.07,0.13,0.05,0.13-0.02l0.21-2.23c0.01-0.08,0.12-0.08,0.13,0c0.2,1.55,0.52,3.08,0.96,4.57 c0.02,0.07,0.13,0.06,0.13-0.01c0.13-1.59,0.41-3.17,0.83-4.71c0.02-0.07,0.12-0.07,0.14,0c0.47,1.84,0.37,3.79,0.62,5.68 c0.15,1.09,0.46,2.22,0.99,3.17c9.3,7.62,23.65,14.33,44.7,19.11c6.34,1.44,11.6,3.1,15.94,4.96c-0.35-1.08-0.53-2.21-0.46-3.35 c0-0.06,0.08-0.07,0.1-0.02c0.49,1.12,1.11,2.18,1.85,3.15c0.04,0.05,0.11,0.01,0.09-0.05c-0.4-1.43-0.58-2.91-0.55-4.39 c0-0.06,0.09-0.07,0.11-0.01c0.26,1.12,0.82,2.78,1.8,3.68c0.03,0.03,0.09,0.01,0.09-0.04c-0.03-1.5-0.89-3.55-0.78-3.6 c0.26-0.11,1.48,1.69,2.49,5.23c0.02,0.05,0.1,0.03,0.1-0.03c-0.02-1.47,0.05-2.94,0.2-4.4c0.01-0.06,0.09-0.07,0.11-0.01 c0.53,2.09,1.09,4.2,2.21,6.03c0.03,0.04,0.1,0.03,0.1-0.03c0.06-1.33,0.17-2.65,0.33-3.97c0.01-0.06,0.1-0.06,0.11,0 c0.44,3.09,1.31,6.25,3.3,8.59c23.77,21.21-17.69,57.26,10.41,86.8c0.49,0.52,1.01,1.03,1.55,1.55 c7.1,5.28,15.31,10.47,24.84,15.36l-0.2-0.35c11.68,6.07,69.27,29.44,156.04,29.44c134.66,0,167.85-25.01,176.01-36.86 C2044.05,694.58,1977.16,693.83,1938.31,694.72z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1644.76,551.76c-1.39,0.25-0.87,2.03-0.24,2.45l6.27,2.3c0,0,5.75,4.08,8.05,5.75 c2.3,1.67,20.19,20.75,20.51,20.96c0.31,0.21,2.98,0.79,3.33,1.1c0.68,0.58,13.38,13.49,14.01,15.05 c0.63,1.57-1.15,1.05-0.63,2.3c0.52,1.25,2.93,0.63,5.02,0.31s1.78-1.88,0.21-1.88s-2.4-2.51-2.4-2.51l-33.56-31.57l-10.04-8.78 L1644.76,551.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M1662.39,562.22c-0.73-0.71-1.25-1.53-1.78-3.11s-3.05-7.21-5.28-9.48s-5.03-2.35-7.57-1.93 c-2.54,0.41-6.02,1.44-3,4.07s11.7,7.81,14.01,9.38c2.31,1.56,3.75,3.03,5.2,4.5s16.52,15.71,19.45,18.6 c2.93,2.88,16.37,15.42,16.37,15.42s-1.48,0.3-0.98,0.97c0.5,0.67,1.17,0.38,2.46,0.14c1.29-0.23,2.53-0.57,1.98-1.19 c-0.55-0.62-1.7,0.16-2-0.27C1701.24,599.32,1664.37,564.16,1662.39,562.22z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1614.09,487.11c4.81,2.87,6.68,8.39,6.85,10.74c0,0,2.81-0.2,6.15,1.13c1.01-8.08,1.67-19.47,0.93-34.71 c-0.77-15.78-5.91-25.74-5.91-35.22s4.34-17.16,2.76-28.9c-1.55-11.53-3.06-32.49-1.83-38.17c0.02-0.1,0.05-0.21,0.07-0.3 c0,0-0.03,0.09-0.09,0.25c-0.16,0.45-0.52,1.5-1.01,2.85c-0.82,2.25-1.97,5.33-3.06,7.84c-0.88,2.01-1.6,5.18-2.09,9.04 c-0.43,3.35-0.69,7.22-0.73,11.29c-0.01,0.95-0.01,1.91,0,2.88c0.01,0.84,0.03,1.68,0.06,2.53c0.23,6.36-1.03,10.39-2.35,15.46 c-0.31,1.2-0.63,2.46-0.93,3.83C1614.78,438.42,1615.25,466.73,1614.09,487.11z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1697.6,591.57c4.81,3.06,9.36,6.3,13.66,8.74c5.77,2.36,8.87,0.62,9.52-0.45 c0.42-0.61,0.1-3.15,0.13-3.65C1720.23,598.65,1710.38,596.46,1697.6,591.57z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1629.95,554.23l-3.99-2.33l-2.33,2.27c-0.59-0.72-1.13-1.4-1.23-2.14c-0.03-0.24-0.01-0.47,0.07-0.7 c-0.02-0.01-0.03-0.01-0.03-0.01c-0.16,0.21-0.27,0.51-0.32,0.89c-2.96,2.31,2.75,14.12,19.71,22.13c2.98,0.93,6.16,1.8,9.5,2.52 c6.91,1.49,15.18,3.22,21.07,4.59c-21.27-8.8-39.17-18.12-46.04-24.68L1629.95,554.23z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1633.88,511.32c-0.65-2.62-1.68-8.4-6.69-10.81c-8.26-3.97-15.45,3.14-14.32,0.63 c0.82-1.83,2.18-3.04,2.86-3.57c0.24-0.18,0.25-0.49,0.15-0.77c-1.14-2.95-3.74-7.28-10.4-7.24c-7.28,0.04-11.1,7.42-11.1,7.42 c1.07-4.68,3.26-7.42,4.11-8.35c0,0.02,0.01,0.03,0.01,0.05c1.57-1.63,3.69-2.86,6.58-3.23c2.43-0.31,4.53-0.1,6.32,0.46 c-0.03-19.43-2.29-43.88-4.26-63.19c-3.23-31.53-8.92-66.45-10.19-76.29c-2.03-15.64-1.03-26.81-0.6-31.3 c0-0.02,0-0.04,0.01-0.05c-0.02-0.01-0.05-0.02-0.07-0.03c-0.06-0.03-0.12-0.05-0.18-0.07c-2.55,4.62-7.14,22.47-10.53,54.69 c-0.07,0.74-0.15,1.49-0.23,2.24c-2.51,24.72-4.29,57.57-3.96,99.04c15.44-0.89,16.83,8.93,16.93,9.25 c0.07,0.21-3.23-4.5-9.79-5.94c-3.46-0.76-8.37-0.65-12.81,2.23c-7.83,5.09-7.09,14.9-7.09,14.9c5.18,0.65,8.03,3.14,9.66,4.68 c0.14,0.13-0.04,0.35-0.2,0.24c-4.17-2.79-8.41-2.98-10.68-2.82c-11.44,1.18-13.7,11.73-13.99,13.47 c-17.44,7.35-30.3,21.22-35.37,27.78c-2.35,3.05-6.65,8.17-11.55,13.86c-7.94,9.22-17.47,19.93-22.89,25.75 c-1.8,1.93-3.15,3.32-3.84,3.94c-2.25,2.01-4.09,3.41-4.03,4.03c0.01,0.08,0.05,0.15,0.14,0.21c0.4,0.27,1.74,0.19,4.44-0.3 c0.93-0.17,2.11-0.45,3.46-0.83c37.87-11.7,41.04-19.97,55.21-17.3c17.94,3.39,18.28,23.52,31.51,36.96 c4.55,4.62,9.17,8.38,35.58,10.91c-38.1-16.75-25.17-34.52-32.32-49.11c-7.15-14.59-8.77-20.78,7.01-31.79 c15.79-11.02,10.21-27.82-0.28-28.7c-0.14-0.01-0.27-0.02-0.41-0.03c6.23-0.14,9.2,0.01,9.2,0.01c19.5,0.53,36.31,6,42.29,8.18 c0.44,0.16,0.82,0.3,1.13,0.42c0.78,0.3,1.2,0.47,1.2,0.47C1633.89,511.37,1633.88,511.35,1633.88,511.32z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1589.27,502.35c0,0,0,0.01,0,0.01C1589.27,502.35,1589.27,502.35,1589.27,502.35z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1589.28,502.33c0,0.01,0,0.01-0.01,0.01C1589.27,502.34,1589.28,502.33,1589.28,502.33z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1589.25,502.39C1589.25,502.39,1589.25,502.4,1589.25,502.39L1589.25,502.39z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1589.25,502.39c0-0.01,0.01-0.02,0.01-0.03C1589.26,502.37,1589.25,502.38,1589.25,502.39z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1677.3,545.12c0.07,0.4,0.15,0.81,0.23,1.21c0.23,1.08,0.52,2.14,0.84,3.13 c1.58,4.94,0.63,9.3-0.34,12.84c-0.93,3.4-0.57,3.84-0.28,5.38c-0.17-0.07-0.33-0.13-0.49-0.19c-0.07-0.03-0.13-0.05-0.2-0.08 c0,0-0.02,0.03-0.04,0.07c-0.27,0.53-1.77,3.89,2.62,7.03c3.11,2.23,6.82,2.78,10.51,2.79c-0.51-1.15-0.66-2.24-0.87-3.93 c-0.94-0.5-1.94-1.03-2.94-1.55l3.01,1.39c0,0,0.39,4.88,1.85,4.98c0.25,0.02,0.47,0.02,0.68,0c-0.62,0.13-1.25,0.08-1.54-0.5 c-0.04-0.08-0.08-0.16-0.12-0.25c-0.17,0.15-0.32,0.32-0.43,0.49c-0.29,0.45-0.42,0.94-0.67,1.41c-0.79,1.48-2.48,2.76-2.34,3.21 c0.07,0.13,0.16,0.2,0.26,0.2c-0.34,0.59-0.37,0.95-0.16,1.11c0.35,0.27,0.71,0.75,1.13,1.08c0.42,0.33,0.78,0.93,1.43,0.71 c0.65-0.22,1.48-0.03,1.78-0.63c0.3-0.6,1.15-3.22,1.53-3.59c0.38-0.37,2.11-0.03,2.69-0.18c0.58-0.15,0.83-0.33,0.47-0.43 c0.11-0.08,0.13-0.1,0.1-0.09c-0.1,0.03-0.64,0.27-1.28,0.06c-0.47-0.15-0.92-0.86-1.08-1.24c-0.16-0.39-0.4-0.64-0.62-0.99 c-0.1-0.16-0.15-0.39-0.18-0.71c-0.02,0.01-0.05,0.03-0.07,0.04c-0.01,0.01-0.03,0.01-0.04,0.02c0.4-0.28,0.62-0.78,0.69-1.61 c0.01-0.1,0.02-0.26,0.04-0.46c0,0.35,0.01,0.68,0.03,0.98c0.01,0.13-0.01,0.25-0.05,0.37c0.84-0.05,1.67-0.11,2.48-0.17 c1.08,0.57,2.41,1.29,3.74,2.09c0.04,0.02,0.07,0.03,0.09,0.03c0.1,0.01,0.14-0.14,0.35-0.36c1.18-1.27,9.89-10.22,18.66-8.23 c0.05,0.01,0.1,0.02,0.15,0.03c0,0,0,0,0,0s-0.05-0.03-0.13-0.09c-0.33-0.21-1.24-0.77-2.4-1.31c-0.09-0.73-0.47-3.26-1.67-8 c-3.19-12.59-5.23-14.07-6.58-14.7c-1.27-0.59-3.22,0.25-5.2,1.69c-0.03-0.03-0.05-0.05-0.08-0.07 c-0.11-0.11-0.21-0.18-0.28-0.22c-0.21-0.12-0.28-0.06-0.28-0.06s-0.25-0.05-0.35,0.03c-0.01,0.01-0.02,0.02-0.03,0.04 c0,0-0.01-0.01-0.04-0.01c-0.18-0.06-1.01-0.28-2.99-0.2c-2.08,0.09-3.66,0.29-3.66,0.29l0.02,4.97c0,0,1.9-0.53,3.44-0.8 c-0.51,0.59-0.97,1.18-1.37,1.74c-1.11,1.59-1.96,2.97-1.96,2.97l-1.23,15.93c-0.17,0.08-0.34,0.14-0.51,0.18 c0.26-4.9,0.68-13.65,0.86-17.39c0.24-5.04,0.04-8.46-0.89-11.65c-0.86-2.93-2.64-5.11-3.27-5.83c-0.02-0.02-0.04-0.04-0.06-0.07 c0.01-0.03,0.02-0.06,0.03-0.08c0.09-0.19,0.18-0.37,0.28-0.55c0.17-0.31,0.36-0.59,0.55-0.86c0.8-1.15,1.64-2.08,1.77-4.01 c0.01-0.15,0.03-0.29,0.05-0.43c-0.3-0.9-0.16-2.01,0.02-2.22c0.2-0.24,0.52-0.21,0.77,0.2c0.1-0.18,0.21-0.37,0.32-0.58 c0.31-0.27,0.55-0.56,0.73-0.87c0.71-1.22,0.41-2.62,0.08-3.46c-0.02-0.05-0.04-0.11-0.06-0.17c0,0-0.77-2.13-2.97-2.83 c-0.79-0.25-8.24,0.07-8.28,9.24c0.09,0.89,0.04,1.8-0.37,2.56c-0.12,0.23-0.28,0.44-0.47,0.64c-2.14-0.21-3.07-0.64-3.98,0.54 c-0.29,0.37-0.53,0.77-0.74,1.2c-0.67,1.35-0.98,2.95-1.03,4.63C1676.94,542.32,1677.06,543.73,1677.3,545.12z M1688.43,558.18 c0.7-2.01,1.17-3.93,1.41-5.88l0.02,0.54c0,0-0.62,5.41-0.65,5.97c-0.06,1.26,0.12,4.6,0.25,6.53c0.04,0.34,0.08,0.69,0.1,1.05 c0.05,0.88-0.01,0.21-0.1-1.05C1689.07,562.23,1687.8,559.99,1688.43,558.18z M1707.09,560.32c0.3,0.61,0.74,1.34,1.42,2.14 c0.43,0.51,0.83,1.01,1.21,1.49c1.35,1.74,2.33,3.22,3.07,4.11c-0.09-0.01-0.17-0.02-0.26-0.03c0,0-0.05,0-0.13,0.01 c-0.92,0.1-6.74,0.84-11.37,4.39c1.17-1.87,3.32-3.97,7.18-6.13c0.07-0.04,0.04-0.1-0.06-0.17c-0.01-0.01-0.03-0.02-0.04-0.03 c-0.32-0.21-1.2-0.52-2.2-0.69c-0.59-0.1-1.23-0.15-1.82-0.11c-0.23,0.02-0.44,0.04-0.63,0.08c-0.66,0.12-1.11,0.38-1.64,0.84 c-0.32,0.28-0.67,0.64-1.12,1.1c0.11-0.13,0.23-0.26,0.35-0.38c0.03-0.04,0.06-0.08,0.08-0.11c2.06-2.92,3.75-5.43,4.76-7.25 c0.19-0.35,0.36-0.67,0.5-0.96c0.04-0.08,0.08-0.16,0.11-0.24C1706.51,558.38,1706.51,559.12,1707.09,560.32z M1705.69,552.77 c-0.01,0.06-0.02,0.13-0.05,0.2c0.03-0.09,0.04-0.17,0.05-0.25C1705.69,552.74,1705.69,552.76,1705.69,552.77z M1702.84,552.12 c-0.04-0.38-0.07-0.64-0.07-0.64s0,0,0,0C1702.78,551.51,1702.81,551.76,1702.84,552.12z M1702.97,553.82 c0.03,0.89-0.09,1.67-0.25,1.96c-0.02,0.04-0.05,0.07-0.07,0.09c-0.04,0.03-0.09,0.07-0.13,0.09c0.04-0.02,0.09-0.05,0.13-0.09 c0.02-0.02,0.05-0.05,0.07-0.09C1702.88,555.5,1703,554.71,1702.97,553.82z M1702.23,555.76c0.02,0.06,0.04,0.1,0.06,0.13 C1702.27,555.86,1702.25,555.82,1702.23,555.76z M1702.47,555.98c-0.02,0-0.03,0.01-0.05,0.01 C1702.44,555.99,1702.46,555.98,1702.47,555.98z M1700.4,552c0.01,0.03,0.02,0.07,0.03,0.1c0.03,0.07,0.05,0.14,0.08,0.21 c-0.02-0.07-0.05-0.13-0.08-0.21C1700.42,552.07,1700.41,552.04,1700.4,552L1700.4,552z M1703.18,555.82c0,0.09,0,0.17,0.01,0.23 C1703.17,555.96,1703.17,555.91,1703.18,555.82z M1704.64,555.13c-0.18,0.17-0.37,0.32-0.44,0.23 C1704.27,555.44,1704.46,555.3,1704.64,555.13z M1704.4,554.37c-0.04,0.13-0.08,0.25-0.12,0.37 C1704.32,554.62,1704.36,554.5,1704.4,554.37z M1704.17,555.16C1704.17,555.16,1704.17,555.16,1704.17,555.16 C1704.17,555.16,1704.17,555.16,1704.17,555.16z M1704.45,554.15c0.03-0.14,0.03-0.27,0.01-0.39 C1704.48,553.89,1704.47,554.02,1704.45,554.15z M1703.75,551.48c0.04,0.25,0.16,0.64,0.25,1.04 C1703.9,552.13,1703.79,551.74,1703.75,551.48c-0.01-0.03-0.01-0.05-0.01-0.06C1703.74,551.43,1703.74,551.45,1703.75,551.48z  M1705.42,553.43c0-0.01,0-0.01,0-0.02c0.07-0.1,0.13-0.2,0.17-0.3C1705.53,553.24,1705.47,553.35,1705.42,553.43z  M1705.41,551.64c0.09,0.25,0.16,0.48,0.22,0.69C1705.55,552.07,1705.48,551.84,1705.41,551.64z M1705.64,552.98 c-0.01,0.04-0.03,0.09-0.05,0.13C1705.61,553.06,1705.63,553.02,1705.64,552.98z M1703.2,556.14c0.01,0.05,0.05,0.11,0.09,0.16 C1703.24,556.25,1703.21,556.19,1703.2,556.14z M1703.16,555.16C1703.16,555.16,1703.16,555.15,1703.16,555.16 c0-0.01,0-0.01,0-0.01C1703.16,555.15,1703.16,555.15,1703.16,555.16C1703.16,555.15,1703.16,555.16,1703.16,555.16z  M1700.19,551.98c-0.06,0-0.13,0.01-0.19,0c-0.03,0-0.05,0-0.08,0C1700,551.97,1700.1,551.97,1700.19,551.98z M1703.69,548.88 c-0.17-0.11-0.31-0.21-0.4-0.32c0,0-0.01-0.01-0.01-0.01C1703.38,548.65,1703.52,548.76,1703.69,548.88z M1695.63,571.9 c-0.43,0.31-0.85,0.57-1.25,0.76C1694.64,572.52,1695.08,572.26,1695.63,571.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1730.83,591.83c-0.08,0.12-0.16,0.24-0.24,0.35c0.22-0.18,0.4-0.32,0.46-0.5 c-0.03-0.01-0.05-0.01-0.08-0.02C1730.92,591.71,1730.87,591.76,1730.83,591.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1736.45,594.68c0.01,0,0.03,0,0.04,0C1736.48,594.69,1736.47,594.68,1736.45,594.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1729.16,592.44c0.03,0.01,0.06,0.02,0.1,0.02c0.04,0,0.08,0,0.11-0.01c-0.04-0.06-0.07-0.12-0.09-0.18 C1729.24,592.32,1729.2,592.38,1729.16,592.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1736.36,594.7c0.02-0.01,0.05-0.01,0.08-0.02c-0.05,0-0.09,0.01-0.13,0.04 C1736.33,594.71,1736.34,594.71,1736.36,594.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1730.22,590.82c0.01-0.01,0.02-0.02,0.03-0.03c-0.02-0.09-0.04-0.18-0.05-0.28c-0.01-0.06,0-0.12,0-0.18 c-0.04,0.06-0.09,0.11-0.11,0.18C1730.05,590.65,1730.1,590.77,1730.22,590.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1730.2,592.85c0-0.03,0-0.06,0-0.08c-0.01,0.01-0.02,0.03-0.03,0.04 C1730.18,592.82,1730.19,592.84,1730.2,592.85z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "1729.89,591.9 1729.89,591.9 1729.89,591.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M1736.19,577.89c0.03-0.06,0.06-0.11,0.1-0.17c0,0,0,0,0-0.01c-0.05,0.03-0.1,0.06-0.14,0.08 C1736.16,577.82,1736.17,577.85,1736.19,577.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M1734.47,579.3c0.51-1.3,1.37-1.85,1.62-1.59c0.06-0.02,0.13-0.03,0.19-0.03 c-0.02-0.13,0-0.25,0.09-0.36c0.6-0.78,1.56-1.15,1.56-1.15s0,0.01,0.01,0.01c1.29-0.84,2.37-1.17,3.38-1.23 c0-0.01,0.01-0.01,0.01-0.01s-0.36-0.55-0.6-1.1c-0.93,0.48-2.38,0.79-4.52,0.8c-0.5,0-0.96-0.01-1.41-0.03c0,0.03,0,0.07,0,0.1 c-0.05,0.52-0.2,0.74-0.35,0.83c0.01,0.05,0.02,0.11,0.02,0.17c0,0.66-0.05,1.73-0.09,2.66c-0.19-0.03-0.37-0.08-0.49-0.19 c-0.12-0.11-0.21-0.16-0.29-0.19c0.02,0.7-0.11,1.47-0.44,2.3c0.43,0.09,0.8,0.17,1.15,0.2 C1734.28,580.08,1734.32,579.69,1734.47,579.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1753.96,597.73c0.05-1.68-1.06-1.37-1.71-1.93c-0.65-0.55-0.36-0.75-1.93-1.89 c-0.69,0.92-1.71,1.67-3.33,2.04c-0.68,0.16-1.28,0.22-1.8,0.21c2.36,0.88,4.91,1.6,5.42,1.94c0.77,0.51,1.29,3.77,2.18,5.07 s1.06,0.83,1.57,0.23c0.33-0.4,0.77-0.51,0.81-1.45C1755.21,600.99,1753.89,600.05,1753.96,597.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1731,574.42c0,0,0.01,0.01,0.01,0.01c0-0.06,0-0.13,0-0.19C1731,574.3,1731,574.36,1731,574.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1734.38,578.37c0.05-0.93,0.09-2,0.09-2.66c0-0.06-0.01-0.11-0.02-0.17c0.14-0.09,0.29-0.31,0.35-0.83 c0-0.03,0-0.07,0-0.1c-0.51-0.02-0.99-0.06-1.43-0.11c0.06,0.38,0.2,0.75,0.34,1.1c-0.23-0.25-0.42-0.53-0.57-0.83 c-0.01,0.3,0.06,0.6,0.2,0.87c-0.36-0.44-0.81-0.81-1.32-1.07c0.01,0.07,0.02,0.14,0.03,0.21c-0.22-0.1-0.41-0.24-0.58-0.41 c0.06,0.14,0.07,0.31,0.02,0.46c-0.1-0.17-0.21-0.32-0.34-0.46c0,0.09,0.01,0.19,0.01,0.28c0.22,0.32,0.45,0.63,0.56,0.87 c0.2,0.43,0.43,0.46,0.6,0.57c0.17,0.11,0.43,1.28,0.77,1.62c0.23,0.23,0.35,0.2,0.51,0.27c0.08,0.03,0.17,0.08,0.29,0.19 C1734.01,578.29,1734.19,578.34,1734.38,578.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1748.09,579.89c0.1,0.73,0.41,1.36,0.65,1.78l0.02-0.01c0,0,0.51,0.79,1.53,2.16 c0.4-0.8,0.39-1.23-0.23-2.37c-0.69-1.27-2.42-3.84-3.37-5.03c-0.02-0.02-0.04-0.05-0.06-0.07c-0.08-0.09-0.15-0.18-0.21-0.26 c0,0,0,0.01,0,0.01c-0.33-0.34-0.72-0.58-1.2-0.68c-0.3-0.06-0.57-0.12-0.82-0.16C1745.19,577.04,1747.91,578.59,1748.09,579.89 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1737.94,576.18c0.15,0.25,2.91,4.82,5.56,3.34c2.72-1.53-1.95-4.55-1.95-4.55 c0.17-0.01,0.36-0.01,0.57,0c-0.26-0.02-0.52-0.02-0.79-0.01C1740.31,575.01,1739.22,575.34,1737.94,576.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1741.03,589.51c-0.24-2.77-0.53-2.01-1.46-3.29c-0.42-0.45-0.79-0.91-1.11-1.34 c-0.19-1.48-0.64-3.04-0.99-4.2c0.01-0.03,0.01-0.05,0.02-0.08c0.25-1.21-1.06-2.18-1.2-2.88c-0.03,0.06-0.07,0.11-0.1,0.17 c-0.02-0.03-0.03-0.06-0.05-0.09c0.05-0.03,0.1-0.06,0.14-0.08c0-0.01,0-0.02,0-0.03c-0.06,0-0.13,0.01-0.19,0.03 c-0.25-0.27-1.11,0.29-1.62,1.59c-0.15,0.39-0.19,0.78-0.17,1.18c0.04,0.71,0.27,1.47,0.43,2.35c-0.4,0.08-0.73,0.43-0.89,1.28 c-0.12,0.62-0.01,1.59,0.26,2.74c-0.62,0.76-1.59,1.75-2.42,2.56c0.23,0.13,0.45,0.27,0.66,0.44c0.08,0.06,0.17,0.13,0.21,0.23 c0.11,0.23-0.04,0.5-0.19,0.71c-0.26,0.35-0.59,0.72-1.03,0.77c-0.11,0.01-0.22,0.01-0.31,0.06c-0.02,0.01-0.04,0.03-0.06,0.05 c0.03,0.01,0.05,0.01,0.08,0.02c-0.07,0.18-0.24,0.32-0.46,0.5c-0.13,0.2-0.26,0.39-0.39,0.59c0,0.03,0,0.06,0,0.08 c0.06,0.1,0.12,0.2,0.18,0.3c0.05,0.01,0.1-0.02,0.15-0.09c0.24-0.34,0.81-0.78,1.45-0.93c0.64-0.15,0.68-0.43,1.09-1 l-0.07-0.03c0.13-0.09,0.26-0.19,0.41-0.3c0.36-0.28,0.99-0.5,1.68-0.74c0.63,1.72,1.42,3.47,2.22,4.82 c-0.11,0.01-0.18,0.01-0.18,0.01c-0.12-0.02-0.29-0.11-0.45-0.16c-0.05-0.01-0.09-0.02-0.12-0.03c-0.02,0-0.04-0.01-0.06-0.01 c-0.01,0-0.03,0-0.04,0c0,0-0.01,0-0.01,0c-0.03,0-0.05,0.01-0.08,0.02c-0.02,0.01-0.04,0.01-0.05,0.02 c-0.01,0.01-0.03,0.02-0.04,0.03c-0.09,0.07-0.08,0.27-0.02,0.37c-0.14-0.04-0.4-0.01-0.44,0.13c-0.01,0.03-0.03,0.06-0.02,0.09 c0.03,0.15-0.09,0.16-0.08,0.2c-0.1,0.07-0.05,0.22-0.1,0.31c-0.06,0.12-0.2,0.18-0.22,0.33c0.02-0.05,0.01-0.1,0-0.14 c-0.01,0.06-0.02,0.13-0.02,0.2c-0.03,0.45-0.11,0.25,0.74,0.57c0.9,0.34,2.04,0.61,3.09,0.8c1.01,0.18,1.64,0.01,1.01-1.27 c-0.15-0.66-0.4-1.85-0.49-2.68l0,0.02c0,0-2.25-2.47-3.12-4.18c-0.01-0.01-0.02-0.03-0.02-0.04c0.13-0.06,0.26-0.13,0.38-0.19 c0.13,0.18,0.25,0.36,0.38,0.56c0.91,1.45,2,2.04,2.43,2.93c0,0,1.19,1.44,2.84,2.31 C1741.28,593.67,1741.18,591.19,1741.03,589.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M1736.95,589.27c-0.12,0.07-0.25,0.13-0.38,0.19c0.01,0.01,0.02,0.03,0.02,0.04 c0.87,1.71,3.12,4.18,3.12,4.18l0-0.02l0.04-0.9c-0.43-0.89-1.52-1.48-2.43-2.93C1737.2,589.64,1737.07,589.45,1736.95,589.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M1731.5,574.83c0.04-0.15,0.04-0.31-0.02-0.46c0.17,0.17,0.37,0.31,0.58,0.41 c-0.01-0.07-0.02-0.14-0.03-0.21c0.51,0.26,0.96,0.62,1.32,1.07c-0.14-0.27-0.21-0.57-0.2-0.87c0.15,0.3,0.35,0.58,0.57,0.83 c-0.14-0.36-0.28-0.73-0.34-1.1c-1.14-0.12-2.06-0.32-2.81-0.58c0.05,0.11,0.11,0.23,0.15,0.34c0.11,0.29,0.2,0.6,0.3,0.89 c-0.04-0.24-0.04-0.49-0.02-0.74c0-0.06,0-0.12,0.01-0.18c0,0.06,0,0.13,0,0.19c0.01,0.2,0.07,0.4,0.17,0.58 c0-0.12-0.01-0.24-0.01-0.36c0-0.09-0.01-0.19-0.01-0.28C1731.28,574.51,1731.4,574.67,1731.5,574.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M1733.38,574.51c0.44,0.05,0.92,0.08,1.43,0.11c0.45,0.02,0.91,0.03,1.41,0.03 c2.13-0.01,3.59-0.32,4.52-0.8c2.21-1.15,1.37-3.28-0.65-4.68c-0.1-1.46-0.37-2.93-1.06-3.39c-1.44-0.96-4.17-0.94-6.08-0.89 c-1.94,0.05-2.57,1.98-2.74,3.67c-0.41,0.23-0.74,0.47-1.04,0.66c-1.57,1.04-2.11,3.5,1.41,4.72 C1731.31,574.18,1732.24,574.38,1733.38,574.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M1750.32,593.9c0.85-1.13,1.21-2.51,1.57-3.74c0.65-2.24,0.12-4.07-1.18-5.78 c-0.15-0.19-0.29-0.38-0.42-0.55c-1.02-1.37-1.53-2.16-1.53-2.16l-0.02,0.01c-0.25-0.42-0.55-1.05-0.65-1.78 c-0.19-1.3-2.9-2.85-3.69-4.63c0-0.01-0.01-0.01-0.01-0.02c0,0-1.26-0.25-2.28-0.28c-0.2-0.01-0.39-0.01-0.57,0 c0,0,4.67,3.03,1.95,4.55c-2.64,1.48-5.41-3.08-5.56-3.34c0-0.01-0.01-0.01-0.01-0.01s-0.97,0.37-1.56,1.15 c-0.08,0.11-0.1,0.23-0.09,0.36c0,0.01,0,0.02,0,0.03c0,0,0,0,0,0.01c0.14,0.7,1.44,1.67,1.2,2.88 c-0.01,0.03-0.01,0.05-0.02,0.08c0.34,1.16,0.79,2.72,0.99,4.2c0.32,0.44,0.69,0.9,1.11,1.34c0.93,1.29,1.23,0.52,1.46,3.29 c0.14,1.68,0.25,4.16,1.56,5.57c0.59,0.63,1.41,1.04,2.6,1.07c0.53,0.01,1.12-0.05,1.8-0.21 C1748.61,595.57,1749.62,594.82,1750.32,593.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M1730.17,592.8c0.01-0.01,0.02-0.03,0.03-0.04c0.13-0.2,0.26-0.39,0.39-0.59 c0.08-0.12,0.16-0.24,0.24-0.35c0.04-0.06,0.09-0.12,0.15-0.17c0.02-0.02,0.04-0.04,0.06-0.05c0.09-0.05,0.21-0.04,0.31-0.06 c0.44-0.05,0.77-0.42,1.03-0.77c0.15-0.21,0.3-0.48,0.19-0.71c-0.05-0.09-0.13-0.16-0.21-0.23c-0.21-0.16-0.43-0.3-0.66-0.44 c-0.15-0.08-0.29-0.17-0.45-0.24c-0.11-0.05-0.22-0.1-0.34-0.08c-0.12,0.02-0.23,0.1-0.31,0.19c-0.16,0.17-0.28,0.38-0.35,0.61 c-0.02,0.07-0.03,0.15-0.04,0.22c0.04,0.02,0.07,0.06,0.05,0.12c-0.01,0.04-0.04,0.08-0.06,0.11c0,0.06,0,0.12,0,0.18 c0.01,0.09,0.03,0.18,0.05,0.28c0,0.02,0.01,0.03,0.01,0.05c0,0,0,0,0,0c0.14,0.04,0.3,0.02,0.42,0.11 c0.09,0.07,0.13,0.19,0.1,0.3c-0.04,0.11-0.14,0.19-0.26,0.18c0.15,0.02,0.23,0.21,0.17,0.34c-0.06,0.14-0.22,0.21-0.37,0.21 c-0.15,0-0.29-0.05-0.43-0.1c0,0,0,0,0,0c0.08,0.24,0.02,0.53-0.16,0.71c-0.02,0.02-0.04,0.04-0.06,0.05 c-0.03,0.01-0.07-0.01-0.1-0.02c-0.08-0.04-0.15-0.11-0.2-0.18c-0.04,0.01-0.07,0.02-0.11,0.01c-0.04,0-0.07-0.01-0.1-0.02 c-0.05,0.07-0.1,0.13-0.15,0.2c-0.1-0.06-0.19-0.16-0.22-0.28c-0.02-0.07,0-0.14,0.03-0.21c-0.09-0.09-0.18-0.18-0.3-0.21 c-0.21-0.06-0.43,0.09-0.54,0.28c-0.1,0.19-0.12,0.42-0.13,0.64c-0.01,0.2-0.02,0.4-0.03,0.6c-0.02,0.29-0.03,0.58,0.07,0.85 c0.09,0.25,0.27,0.46,0.47,0.64c0.27,0.25,0.51,0.45,0.82,0.65c0.35,0.23,0.61,0.4,1.02,0.57c0.28-0.44,0.51-0.91,0.68-1.4 c0.06-0.17,0.12-0.36,0.09-0.54c-0.02-0.14-0.1-0.27-0.17-0.39c-0.14-0.23-0.27-0.46-0.41-0.69c-0.06-0.1-0.12-0.2-0.18-0.3 C1730.19,592.84,1730.18,592.82,1730.17,592.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M1728.79,592.36c0.03,0.12,0.11,0.21,0.22,0.28c0.05-0.07,0.1-0.13,0.15-0.2 c0.04-0.06,0.09-0.12,0.13-0.17c0.02,0.07,0.05,0.13,0.09,0.18c0.05,0.08,0.12,0.14,0.2,0.18c0.03,0.02,0.06,0.03,0.1,0.02 c0.03-0.01,0.05-0.03,0.06-0.05c0.17-0.19,0.23-0.47,0.16-0.71c0,0,0,0,0,0c0,0,0,0,0,0c0.14,0.05,0.28,0.11,0.43,0.1 c0.15,0,0.31-0.07,0.37-0.21c0.06-0.14-0.02-0.33-0.17-0.34c0.11,0,0.22-0.08,0.26-0.18c0.04-0.11-0.01-0.23-0.1-0.3 c-0.12-0.09-0.28-0.07-0.42-0.11c0,0,0,0,0,0c0-0.02-0.01-0.03-0.01-0.05c-0.01,0.01-0.02,0.02-0.03,0.03 c-0.11-0.06-0.17-0.18-0.13-0.31c0.02-0.07,0.07-0.12,0.11-0.18c0.03-0.03,0.05-0.07,0.06-0.11c0.02-0.06-0.01-0.09-0.05-0.12 c-0.05-0.03-0.13-0.04-0.18-0.03c-0.18,0.03-0.28,0.21-0.33,0.37c-0.05,0.16-0.07,0.33-0.06,0.5c0,0.04,0.01,0.07-0.01,0.11 c-0.02,0.05-0.08,0.07-0.12,0.1c-0.09,0.08-0.11,0.23-0.04,0.33c-0.1-0.03-0.19,0.09-0.21,0.19c-0.02,0.1-0.03,0.23-0.11,0.29 c-0.06,0.05-0.15,0.04-0.22,0.08c-0.04,0.02-0.08,0.06-0.1,0.1C1728.79,592.22,1728.78,592.29,1728.79,592.36z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1754.08,599.02c0.14,0.66,0.39,1.17,0.62,1.61C1754.57,600.11,1754.36,599.56,1754.08,599.02z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1752.16,601.81c0.54,1.17,1.11,2.33,1.7,2.07c0.19-0.09-0.68-0.72-0.79-1.52 c-0.11-0.79-0.56-2.8-0.91-3.5c-1.01-2.01-0.32-2.6-0.63-2.53c-0.89,0.19-1.99-1.13-2.35-1.31c0.11-0.09,0.22-0.17,0.33-0.27 c0.56-0.5,1.02-1.09,1.36-1.73c0.07-0.13,0.13-0.26,0.19-0.39c0.95-1.97,1.29-4.07,1.04-5.28c-0.22-1.12-0.48-1.67-1.08-2.54 c-0.09-0.14-0.2-0.28-0.31-0.44c-0.27-0.37-0.34-0.57-0.34-0.72c0.01-0.32,0.38-0.41,0.04-1.42c-0.15-0.44-1.04-1.94-1.91-3.29 c-0.67-1.03-1.33-1.98-1.65-2.33c-0.01-0.01-0.01-0.02-0.02-0.02c-0.34-0.36-1.25-0.68-2.21-0.92 c-1.04-0.27-2.13-0.45-2.59-0.49c-0.07-0.01-0.14-0.01-0.2-0.02c-0.33-0.04-0.54-0.11-0.67-0.19c-0.43-0.27-0.13-0.7-0.65-1.01 c0,0,0,0,0,0c0.15-0.07,0.23-0.12,0.23-0.12c0.86-1.99-0.66-4.32-0.66-4.32c-0.27,0.56-0.93,0.96-0.93,0.96 c0.6-0.56,0.5-1.16,0.5-1.16c-0.33-2.92-1.24-2.67-4.05-2.86c-2.81-0.19-1.11-1.19-2.36-1.27c-1.7-0.12-2.35,1.35-2.58,2.81 c-0.23,1.46-0.17,3.25-0.17,3.25s-1.53,1.83-0.83,2.29c0.01,0,0.01,0.01,0.02,0.01c0.27,0.18,0.61,0.31,0.92,0.41 c0.15,0.05,0.29,0.08,0.42,0.11c0.04,0.01,0.08,0.02,0.12,0.03c0,0,0,0,0,0.01c0.03,0.13,0.08,0.28,0.17,0.44 c0.15,0.27,0.38,0.55,0.7,0.76c0.55,0.35,0.78,0.52,0.93,1.15c0.15,0.63,0.97,0.95,1,1.52c0.01,0.21,0.22,0.31,0.46,0.37 c0.17,0.05,0.37,0.08,0.54,0.13c0.51-0.74,1.08-0.98,1.21-0.68c-0.89,0.36-1.39,1.66-0.79,3.76c0.6,2.1,0,3.7,0.3,4.2 c0.3,0.5,0.6,0.95,0.6,0.95s-0.6-0.3-1.3,0.6c-0.6,0.77-2.05,1.92-2.83,2.41c-0.13,0.08-0.24,0.15-0.32,0.19 c-0.6,0.3-0.71,1.03-1.11,1.08c-0.41,0.05-0.66,0.3-0.79,0.72c-0.12,0.42-0.07,0.22-0.35,0.5c-0.07,0.07-0.15,0.1-0.24,0.13 c-0.02,0.01-0.04,0.01-0.06,0.01c-0.13,0.03-0.26,0.06-0.38,0.18c-0.11,0.11-0.2,0.29-0.27,0.62c-0.2,1-0.24,1.82-0.24,1.82 s0.08,0.07,0.2,0.18c0,0,0,0,0,0c0.36,0.31,1.12,0.93,1.64,1.04c0,0,0.6-0.87,0.68-1.4c0.04-0.27,0.05-0.52,0.01-0.76 c-0.05-0.25-0.15-0.49-0.34-0.73c-0.04-0.06-0.08-0.1-0.1-0.14c-0.19-0.27,0.09-0.08,0.09-0.08s0.01-0.11,0.24-0.27 c0.07-0.05,0.16-0.11,0.28-0.16c0.45-0.23,0.99-0.41,1.31-0.63c0.03-0.02,0.07-0.05,0.09-0.07c0.12-0.1,0.24-0.25,0.35-0.39 c0.16-0.21,0.28-0.41,0.28-0.41s0.76-0.6,1.81-1c0.07-0.03,0.14-0.05,0.2-0.08c0.32-0.12,0.64-0.23,0.96-0.36 c-0.19,0.08-0.39,0.15-0.59,0.22c0.48,0.87,1.03,1.73,1.51,2.53c1.1,1.84,1.34,2.75,1.39,3.1c-0.45-0.41-1.23-1.15-1.72-1.91 c-0.02-0.03-0.04-0.05-0.05-0.08c0.35,0.74,0.56,1.07,0.66,1.21c0.04,0.06,0.07,0.08,0.07,0.08c0.79,0.56,0.72,0.61,1.06,0.84 c0,0.03,0,0.05,0,0.05s-2.38,0.09-2.99,0.57c0-0.02,0-0.05,0.01-0.08c0-0.05,0.01-0.1,0.02-0.15c-0.35,0.1-0.66,0.2-0.93,0.29 c-1.61,0.57-2.1,1.29-0.87,2.21c-0.65,0.14-1.55-0.28-1.7-0.68c-0.11-0.3,0.15-0.75-0.53-0.97c-0.68-0.22-2.16-0.66-3.16,0.43 c0,0,0,0,0,0.99c0,2.17,7.92,2.17,11.97,1.61c11.12-1.04,10.86,3.74,12.91,3.59c-0.09-0.11-0.19-0.24-0.3-0.4 C1752.56,602.82,1752.35,602.34,1752.16,601.81z M1738.06,582.81c0.07,0.27,0.13,0.54,0.18,0.82c0.31,0.57,0.69,1.16,1.17,1.75 c2.18,2.69,1.61,2.47,1.56,3.45c0,0.08-0.01,0.16,0,0.26c0.01,0.19,0.02,0.47,0.03,0.79c-0.05-0.59-0.04-1.01-0.04-1.15 c0-0.03,0-0.05,0-0.05c0,0-0.01-0.01-0.01-0.01c-0.84-0.9-1.63-1.79-2.37-2.54c-0.01-0.28-0.04-0.57-0.09-0.89 C1738.39,584.65,1738.23,583.72,1738.06,582.81z M1737.99,588.41c-0.06,0.08-0.12,0.16-0.19,0.23 c-0.07,0.08-0.15,0.15-0.24,0.21c0.08-0.07,0.16-0.14,0.24-0.21C1737.87,588.57,1737.93,588.49,1737.99,588.41z M1740.04,595.12 c-0.15-0.64-0.28-1.29-0.31-1.81c-0.01-0.21,0-0.39,0.03-0.55c0,0,0.02,0.02,0.04,0.05c0.01,0.01,0.02,0.03,0.04,0.05 c0.01,0.01,0.01,0.02,0.02,0.02c0.29,0.33,1.19,1.3,2.27,1.99C1741.4,594.94,1740.7,595.03,1740.04,595.12z M1736.2,589.63 c-0.04,0.02-0.07,0.03-0.11,0.05C1736.13,589.66,1736.17,589.65,1736.2,589.63z M1739.2,597.6c-0.2-0.04-0.4-0.07-0.6-0.12 c1.23,0.19,1.8,0.2,1.86-0.33C1740.46,597.68,1739.93,597.73,1739.2,597.6z M1742.59,595.08c0,0-0.01,0-0.01-0.01 c-0.01-0.01-0.01-0.02-0.02-0.03c-0.02-0.02-0.03-0.05-0.05-0.07c0.43,0.49,0.99,0.86,1.71,1.02c0.39,0.09,0.76,0.14,1.12,0.16 C1744.08,596.15,1743.2,595.73,1742.59,595.08z M1748.93,597.43c-0.99-0.33-2.28-0.75-3.53-1.21 C1746.25,596.46,1747.75,596.99,1748.93,597.43z M1750.68,598.15c-0.02-0.02-0.05-0.05-0.07-0.06 C1750.63,598.1,1750.66,598.12,1750.68,598.15z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1734.89,584.54c-0.09,0.08-0.18,0.18-0.26,0.29c-0.4,0.54-0.5,1.18-0.41,1.89 c0.29-0.36,0.49-0.66,0.53-0.85C1734.84,585.4,1734.88,584.96,1734.89,584.54z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "father"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M2052.36,553.5c2.45-5.15,10.69-13.75,13.57-9.33c-1.08-2.58-1.44-1.1-3.59-9.21 c-2.13-7.98-7.42-15.96-12.25-16.31c0.38,12.26,0.68,24.7,0.9,37.22C2051.49,555.12,2051.95,554.35,2052.36,553.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M2016.67,511.48c7.53,5.18,16.65,34.5,26.83,55.25c0.46,0.93,0.86,1.79,1.21,2.58 c1.43-7.33,4.18-10.29,6.28-13.44c-0.22-12.52-0.53-24.97-0.9-37.22c-1.98-64.46-5.93-123.64-10.31-160.83 c-5.51-46.89-18.78-81.36-27.2-99.46c-6.11-13.13-20.66-10.34-20.23,5.42c0.37,13.5,4.49,95.61,2,240.44 C2004.65,503.83,2012.03,506.29,2016.67,511.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M2024.94,618.92c-4.68-4.79-8.38-7.53-10.71-9.22c-0.21,0.67-0.42,1.33-0.63,2.01 c-1.69,5.53-3.03,11.64-4.08,17.48c-0.96,10.37-1.55,19.4-1.87,27.15c-0.5,19.95,5.62,57.41,6.5,69.75 c0.1,1.44,0.25,3.17,0.44,5.1c13.31,0,24.59,0,32.56,0c2.47-31.24,3.76-66.75,4.14-103.52 C2042.03,636.42,2032.83,627,2024.94,618.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M1911.9,441.11l0.09-0.03c-0.43-1.91-0.89-3.93-1.35-6.11c-2.7-12.63-0.71-6.13-5.64-11.01 c-0.32,0.86-0.64,1.75-0.94,2.66c-1.6,4.88-2.32,8.17-2.54,10.53c0.12-0.2,0.27-0.28,0.43-0.15c0,0,0.66-0.14,1.3,0.86 c0.64,0.99,1.73,5.64,1.73,5.64s-2.21-1.51-3.31-2.58c0,0-0.01-0.01-0.01-0.01c0.65,3.11,2.53,3.75,1.38,9.28 c-1.21,5.83-0.87,11.82-0.2,17.37c0.98-3.36,3.08-9.55,5.42-14.33C1911.52,446.55,1912.89,446.93,1911.9,441.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M1982.85,460.14c-0.55,1.7-1.06,3.34-1.54,4.93C1981.88,463.46,1982.39,461.81,1982.85,460.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1904.98,443.5c0,0-1.09-4.64-1.73-5.64c-0.64-0.99-1.3-0.86-1.3-0.86c-0.16-0.13-0.3-0.05-0.43,0.15 c-0.43,0.72-0.58,3.03,0.13,3.74c0,0,0.01,0.01,0.01,0.01C1902.77,441.99,1904.98,443.5,1904.98,443.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M1974.79,492.27c0.04-1.15,0.13-2.39,0.28-3.72c-16.13,9.6-33.41,6.89-41.8-10.37 c-3.49-7.18-5.08-14.08-6.11-19.57c0-0.02,0-0.05,0-0.07c0.23-8.74-0.61-13.35-4.49-15.3c-4.24-2.13-7.06,3.7-6.4,9.56 c0.66,5.85-0.84,10.97,0,16.14c0.7,4.32,3.62,5.03,5.45,3.93c0.11,0.7,0.21,1.49,0.3,2.4c2.9,28.56-3.46,25.43-3.46,25.43 s-0.08,0.02-0.22,0.05c1.73,0.25,3.65,0.33,5.81,0.18c1.84-0.13,3.28,0.89,4.4,2.57c3.1-0.57,32.83-6.07,43.14-8.72 C1973.43,494.33,1974.47,493.02,1974.79,492.27z M1919.49,466.86c-0.71,1.51-1.68,0.24-1.02-2.28c0.67-2.52-0.01-3.03-0.59-4.3 c-0.58-1.27-0.14-1.64-0.14-1.64c1.13,1.9,2.33,1.15,3.03,2.04C1921.47,461.57,1920.21,465.35,1919.49,466.86z M1920.7,470.2 c0,0,3.9-7.43,3.63-13.5C1924.33,456.71,1924.95,467.45,1920.7,470.2z M1920.33,447.46c-1.32,0.53-2.07,3.14-0.55,5.18 c1.53,2.03,2.09,2.92,2.55,4.57s-0.24,3.28-0.24,3.28s-0.32-1.27-0.78-2.79c-0.46-1.52-1.6,0.75-3.11-1.03 c-1.51-1.78-1.17-7.08-0.77-8.35c0.4-1.26,1.22-3.28,3.33-2.76c2.11,0.52,2.91,3.81,3.6,6.09 C1924.36,451.65,1922.18,446.71,1920.33,447.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1901.46,402.01c0,0,0.46-0.46,1.36-1.24C1901.64,401.44,1901.46,402.01,1901.46,402.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1922.01,475.26c-0.09-0.91-0.19-1.7-0.3-2.4c-1.83,1.1-4.75,0.4-5.45-3.93 c-0.84-5.17,0.66-10.28,0-16.14c-0.66-5.85,2.16-11.68,6.4-9.56c3.88,1.94,4.72,6.56,4.49,15.3c0,0.02,0,0.05,0,0.07 c1.03,5.49,2.62,12.39,6.11,19.57c8.4,17.26,25.67,19.98,41.8,10.37c0.06-0.03,0.11-0.07,0.17-0.1c0,0,1.86-9.5,6.07-23.38 c0.48-1.59,1-3.24,1.54-4.93c0.35-1.07,0.7-2.17,1.07-3.28c3.71-11.13,7.05-23.19,7-30.52c0.89-9.88-0.32-17.32-2.04-21.9 c-2.29-6.11-1.15-1.91-1.15-1.91s0.26,6.44,0.56,10.64c-1.08-3.36-2.76-6.87-5.86-10.66c-1.62-2.91-3.55-5.77-5.77-7.99 c-6.51-6.51-4.95-6.32-2.71-0.2c-3.31-2.68-6.91-4.81-10.2-4.93c-11.02-0.39-17.86-4.24-24.76-3.82 c-2.38-0.18-6.63,0.59-10.64,2.14c-0.04-0.09-0.06-0.14-0.06-0.14c-5.65,3.11-11.87,3.61-17.8,7.48 c-3.65,2.38-6.23,4.47-7.67,5.73c1.44-0.82,4.36-1.79,10.29-2.09c-1.13,0.05-2.19,0.29-3.18,0.69c-3.82,1.19-6.91,3.72-8.8,7.58 c0,0,0.67-1.1,2.88-2.36c-0.29,0.47-0.57,0.95-0.82,1.45c-0.57,0.65-1.14,1.43-1.67,2.33c-0.98,1.26-1.75,2.65-2.17,4.2 c-1.78,6.54-2.69,6.4,0.7,4.18c0.04,1.92,0.53,3.91,1.62,5.78c2.39,4.1,1.78,2.85,1.14-1.18c0.29,0.48,0.63,0.94,1,1.36 c0.44,0.49,0.83,0.9,1.19,1.26c4.92,4.88,2.93-1.63,5.64,11.01c0.46,2.17,0.92,4.2,1.35,6.11l-0.09,0.03 c0.99,5.82-0.38,5.43-3.64,12.1c-2.34,4.78-4.44,10.97-5.42,14.33c-0.14,0.49-0.26,0.92-0.35,1.28 c-0.15,0.58-0.04,2.18,0.14,2.75c0.21,0.64,0.52,1.75,0.95,3.62c0.85,3.69,0.66,3.52,0.66,7.21c0,3.69-1.36,12.51,7.38,16.88 c3.64,1.82,6.01,1.6,6.71,1.47c0.14-0.03,0.22-0.05,0.22-0.05S1924.91,503.83,1922.01,475.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1920.76,445.56c-2.11-0.52-2.93,1.5-3.33,2.76c-0.4,1.26-0.75,6.57,0.77,8.35 c1.51,1.78,2.65-0.49,3.11,1.03c0.46,1.52,0.78,2.79,0.78,2.79s0.71-1.64,0.24-3.28s-1.03-2.53-2.55-4.57 c-1.53-2.03-0.77-4.65,0.55-5.18c1.86-0.75,4.04,4.2,4.04,4.2C1923.67,449.37,1922.87,446.08,1920.76,445.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1920.78,460.68c-0.69-0.89-1.9-0.14-3.03-2.04c0,0-0.44,0.38,0.14,1.64c0.58,1.27,1.25,1.78,0.59,4.3 c-0.67,2.52,0.3,3.79,1.02,2.28C1920.21,465.35,1921.47,461.57,1920.78,460.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M1920.7,470.2c4.24-2.75,3.63-13.5,3.63-13.5C1924.6,462.77,1920.7,470.2,1920.7,470.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M2065.92,544.17c-2.88-4.42-11.12,4.18-13.57,9.33c-0.4,0.85-0.87,1.62-1.38,2.38 c-2.1,3.15-4.84,6.1-6.28,13.44c-0.35-0.8-0.75-1.65-1.21-2.58c-10.18-20.76-19.3-50.07-26.83-55.25 c-4.64-5.19-12.02-7.65-22.33-7.25c-3.72,0.14-7.81,0.65-12.29,1.54c-3.18-4.39-6.48-9.76-7.14-13.89c0,0.09-0.04,0.23-0.11,0.4 c-0.32,0.75-1.36,2.05-3.12,2.5c-10.31,2.64-40.04,8.14-43.14,8.72c-0.17,0.03-0.27,0.05-0.27,0.05s4.71,7.11-4.2,10.95 c-0.73,0.25-1.5,0.52-2.3,0.82c-4.35,1.65-8.18,3.66-11.56,6.01c-1.16,0.61-2.13,1.14-2.97,1.63 c-15.27,8.91-27.48,19.47-25.03,42.42c2.53,23.65-4.16,24.06-4.16,75.56c0,14.37-18.02,47.54-17.81,90.27 c9.83,0,21.28,0,33.63,0c3.38-11.7,8.29-26.84,14.07-39.06c6.28-13.3,10.15-21.35,11.95-60.6c0-0.03,0-0.05,0-0.05 c0-0.03,0-0.06,0.01-0.1c0.02-0.41,0.04-0.82,0.06-1.24c0.06-1.27,0.14-2.56,0.24-3.85c0.44-12.4-0.92-25.65-1.02-41.63 c-0.11-18.23,4.92-0.37,4.97,8.74c0.03,4.59,0.71,3.36,1.76-0.54c1.89-8.15,3.6-14.62,4-17.53c0.13-0.94,0.01-0.06-0.28,2.21 c0.07-0.3,0.15-0.59,0.22-0.88c1.05-4.17,1-2.74,0.36,1.93c0.52-2.65,0.83-4.05,0.83-4.05s-2.28,13.4-4.77,30.7 c-0.81,7.1-1.65,14.9-2.42,22.78c-0.31,11.67,1.09,23.2,7.65,32.58c6.56,9.39,29.28,14.11,40.08,18.12 c0.95,0.35,0.87,1.66-0.09,1.98c-27.58,9.27-43.32-6.22-43.17,2.66c0.71,1.59,9.8,7.96,27.56,8.88 c2.9,0.15-20.88,7.8-32.71,12.24c-9.53,2.69-15.86,3.58-19.83,11.16c-0.04-0.05-0.08-0.09-0.12-0.14 c-0.04,0.11-0.08,0.22-0.12,0.33c-0.07,0.2-0.14,0.39-0.21,0.59c0.02,0,0.04,0.01,0.06,0.01c-0.01,0.01-0.01,0.02-0.01,0.03 c-0.02,0-0.04-0.01-0.05-0.01c-0.07,0.2-0.14,0.39-0.21,0.58c-0.2,0.45-0.39,0.93-0.58,1.43c-0.39,1.05-0.73,2.1-1,3.13 c-1.19,3.49-2.24,6.7-3.16,9.59c36,0,78.8,0,111.34,0c-0.54-22.98-7.78-30.08-7.94-43.22c-0.07-5.79-0.27-10.44-0.66-14.07 l-1.35,7.78c0.58-3.37,1.04-6.34,1.22-8.85c-0.68-5.48-1.84-8.38-3.67-9.17c-2.22-0.43-5.58,0.32-10.48,2.45 c-15.57,6.76-34.37,3.23-19.97,2.06s31.43-9.69,34.96-26.14c3.52-16.45,12.92-39.36,15.57-51.99c0,0,0.07,0.07,0.16,0.3 c3.12-15.47,2.84-27.86,2.43-33.61c-0.02-0.27,0.37-0.31,0.42-0.05c5.04,24.61-0.91,37.89-5.72,53.04 c2.33,1.68,6.03,4.43,10.71,9.22c7.89,8.08,17.09,17.5,26.35,8.75c0.45-0.42,0.89-0.88,1.34-1.39c2.36-2.68,4.07-5.58,5.29-8.5 c0.11,0.22,0.18,0.34,0.18,0.34c4.44-11.76,7.12-20.57,8.56-33.09c1.44-12.52,1.8-20.62,2.88-27.99 C2070.6,549.69,2068.8,548.59,2065.92,544.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M1901.08,721.6c0.28-1.04,0.61-2.08,1-3.13c0.19-0.5,0.38-0.97,0.58-1.43c0.07-0.19,0.14-0.39,0.21-0.58 c0.02,0,0.04,0.01,0.05,0.01c0.01-0.01,0.01-0.02,0.01-0.03c-0.02,0-0.04-0.01-0.06-0.01c0.07-0.2,0.14-0.39,0.21-0.59 c0.04-0.11,0.08-0.22,0.12-0.33c0.04,0.05,0.08,0.09,0.12,0.14c3.97-7.59,10.3-8.48,19.83-11.16 c11.83-4.43,35.61-12.09,32.71-12.24c-17.76-0.92-26.85-7.29-27.56-8.88c-0.15-8.88,15.59,6.61,43.17-2.66 c0.96-0.32,1.03-1.63,0.09-1.98c-10.81-4.01-33.52-8.74-40.08-18.12c-6.56-9.38-7.96-20.91-7.65-32.58 c0.77-7.87,1.61-15.67,2.42-22.78c2.49-17.31,4.77-30.7,4.77-30.7s-0.31,1.4-0.83,4.05c0.65-4.67,0.69-6.09-0.36-1.93 c-0.07,0.29-0.15,0.59-0.22,0.88c0.29-2.28,0.41-3.16,0.28-2.21c-0.4,2.91-2.1,9.38-4,17.53c-1.05,3.89-1.73,5.13-1.76,0.54 c-0.06-9.12-5.09-26.97-4.97-8.74c0.1,15.99,1.46,29.23,1.02,41.63c-0.1,1.3-0.18,2.58-0.24,3.85 c-0.02,0.42-0.04,0.83-0.06,1.24c0,0.03,0,0.06-0.01,0.1c0,0,0,0.02,0,0.05c-1.81,39.25-5.67,47.3-11.95,60.6 c-5.78,12.22-10.69,27.36-14.07,39.06c1.34,0,2.69,0,4.05,0C1898.84,728.3,1899.89,725.1,1901.08,721.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M2014.15,726.1c-0.88-12.34-7-49.81-6.5-69.75c0.33-7.76,0.91-16.79,1.87-27.15 c1.05-5.84,2.39-11.95,4.08-17.48c0.21-0.67,0.42-1.34,0.63-2.01c4.81-15.15,10.77-28.42,5.72-53.04 c-0.05-0.26-0.44-0.21-0.42,0.05c0.41,5.75,0.69,18.14-2.43,33.61c-0.08-0.23-0.16-0.3-0.16-0.3 c-2.64,12.63-12.04,35.54-15.57,51.99c-3.52,16.45-20.56,24.97-34.96,26.14s4.41,4.7,19.97-2.06c4.9-2.13,8.26-2.88,10.48-2.45 c1.84,0.79,3,3.68,3.67,9.17c-0.19,2.51-0.64,5.48-1.22,8.85l1.35-7.78c0.39,3.63,0.59,8.28,0.66,14.07 c0.16,13.14,7.4,20.25,7.94,43.22c1.81,0,3.58,0,5.33,0C2014.4,729.27,2014.25,727.54,2014.15,726.1z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2069.88,551.69c-0.48-4.17-3.96-7.52-3.96-7.52c1.2,4.42,2.64,7.61-2.16,17.92s-9.11,20.62-8.63,31.67 c0,0,0.62,3.96,0.56,8.96c-1.61-12.09-6.17-23.28-10.91-33.84c1.81-8.74,5.52-11.09,7.56-15.38c2.45-5.15,10.69-13.75,13.57-9.33 c-1.08-2.58-1.44-1.1-3.59-9.21c-2.07-7.79-7.16-15.58-11.9-16.27c-0.25-10.19-0.53-19.7-0.82-28.28 c-2.04-60.46-5.77-104.49-10.39-137.05c-0.8-5.61-1.62-10.88-2.46-15.84c-0.34-1.98-0.68-3.91-1.02-5.8 c-6.73-36.86-14.45-55.01-20.09-66.48c-1.57-3.19-2.97-5.86-4.15-8.28c-3.52-7.21-9.51-6.64-8.86-0.33 c2.2,21.4,6.96,120.51,4.72,248.9c-3.62-1.14-7.53-1.47-11.59-1.35c-3.98,0.11-8.1,0.65-12.2,1.29c-0.5,0.08-1,0.16-1.5,0.23 c0,0-0.15-0.17-0.4-0.48c-0.81-1.01-2.72-3.56-4.42-7.06c-0.86-1.77-1.67-3.79-2.25-5.97c0.19-2.63,0.98-8.17,3.91-18.42 c4.52-15.77,11.24-32.22,11.9-43.57c0.49-8.5,1.06-14.29-0.69-21.56c-0.31-1.31-0.71-2.68-1.19-4.11 c-0.38-1.13-0.81-2.31-1.31-3.55c0,0,0.01,0.13,0.02,0.35c0.01,0.23,0.03,0.55,0.05,0.97c0.11,2.1,0.33,6.36,0.54,10.18 c0,0-0.86-2.72-3.27-6.52c-0.03-0.04-0.06-0.09-0.09-0.13c-0.72-1.12-1.57-2.34-2.58-3.61c-0.06-0.07-0.12-0.15-0.17-0.22 c-4.61-5.74-6.3-5.74-10.68-7.65c-4.39-1.91,0.23,0.68,4.11,5.12s-50.11-8.32-55.52,26.75c-1.91,12.39-1.03,17.19-1.03,17.19 c0.04-0.01,0.08-0.02,0.12-0.04c2.51-0.72,6.92,1.67,7.4,11c0.26,5.03-0.93,5.5-2.27,13.38c-0.85,5-3.39,5.62-5.18,5.39 c-0.27-0.03-0.53-0.09-0.75-0.15c0,0,0.99,1.13,3.23,0.57c-0.23,0.52,1.6,29.12-11.09,25.04c-0.22-0.07-0.45-0.15-0.68-0.24 c0,0,1.23,1.14,4.4,1.93c0.82,0.2,1.76,0.38,2.85,0.51c1.91,0.23,4.26,0.31,7.11,0.1c0.24-0.02,0.46-0.04,0.68-0.06 c0.18,0.04,0.38,0.09,0.59,0.16c0.52,0.17,1.1,0.42,1.62,0.79c0.35,0.25,0.67,0.54,0.93,0.89c0.18,0.24,0.33,0.51,0.43,0.81 c0.04,0.13,0.08,0.25,0.11,0.39c0.02,0.1,0.04,0.2,0.05,0.31l0.1-0.02l0.96-0.21c1.73,4.2,5.53,6.8-0.61,9.46 c0,0,7.45-1.51,16.01-1.74c0.51-0.01,0.62,0.7,0.13,0.84c-6.16,1.78-19.09,4.19-35.62,19.24c-19.12,17.41-3.28,52.85-9.83,73.74 c-6.56,20.89-6.96,32.37-6.96,45.07c0,11.25-13.37,42.87-21.58,80.59c54.91,0,144.85,0,176.86,0 c2.29-28.98,3.3-66.01,3.54-103.75c-1.67,1.63-3.34,2.67-5,3.23c3-1.27,5.97-3.83,8.64-7.71c1-1.46,1.96-3.11,2.86-4.95 c0.18-0.37,0.35-0.74,0.53-1.12c1.37-2.99,2.58-6.45,3.59-10.38c0.32-1.26,0.63-2.56,0.91-3.92c2.55-12.43,3.65-19.19,4.42-25.31 c0.32-2.52,0.58-4.93,0.86-7.58C2069.28,560.62,2070.36,555.87,2069.88,551.69z"
  })))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "line",
    x: 439.58,
    y: 212.66,
    width: 1112.42,
    height: 13
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1196.1543 284.0464)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "22px"
  }, "Seit 2020 beziehen wir den Strom f\xFCr"), /*#__PURE__*/React.createElement("tspan", {
    x: -16.46,
    y: 32,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "22px"
  }, "alle Werke der BMW Group zu "), /*#__PURE__*/React.createElement("tspan", {
    x: 287.74,
    y: 32,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "27px"
  }, "100%"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.69,
    y: 64,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "22px"
  }, "aus "), /*#__PURE__*/React.createElement("tspan", {
    x: 32.4,
    y: 64,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "27px"
  }, "ERNEUERBAREN ENERGIEN.")))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-left"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 332.9995 181.5151)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "112px",
    letterSpacing: -2
  }, "gesagt"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 439.4312 289.3579)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "22px"
  }, "Wir wollen die"), /*#__PURE__*/React.createElement("tspan", {
    x: 141.14,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "22px"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 145.12,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "27px"
  }, "CO2-EMISSIONEN"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "22px"
  }, " je produziertes Fahrzeug senken.")))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-right"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1411.3076 175.5581)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "112px",
    letterSpacing: -2
  }, "getan"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.a5ac2542.svg";
export { ForwardRef as ReactComponent };